
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bJeU6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hjUDQ = parcelRequire("hjUDQ");

var $5RH40 = parcelRequire("5RH40");

var $cfM7x = parcelRequire("cfM7x");










var $6461dd9a11ba8e64$exports = {};

var $9nTiU = parcelRequire("9nTiU");


var $fZvv3 = parcelRequire("fZvv3");


var $2Ryc1 = parcelRequire("2Ryc1");

/** Used as references for various `Number` constants. */ var $6461dd9a11ba8e64$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used as references for the maximum length and index of an array. */ var $6461dd9a11ba8e64$var$MAX_ARRAY_LENGTH = 4294967295;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6461dd9a11ba8e64$var$nativeMin = Math.min;
/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */ function $6461dd9a11ba8e64$var$times(n, iteratee) {
    n = $2Ryc1(n);
    if (n < 1 || n > $6461dd9a11ba8e64$var$MAX_SAFE_INTEGER) return [];
    var index = $6461dd9a11ba8e64$var$MAX_ARRAY_LENGTH, length = $6461dd9a11ba8e64$var$nativeMin(n, $6461dd9a11ba8e64$var$MAX_ARRAY_LENGTH);
    iteratee = $fZvv3(iteratee);
    n -= $6461dd9a11ba8e64$var$MAX_ARRAY_LENGTH;
    var result = $9nTiU(length, iteratee);
    while(++index < n)iteratee(index);
    return result;
}
$6461dd9a11ba8e64$exports = $6461dd9a11ba8e64$var$times;



var $w6R6I = parcelRequire("w6R6I");


var $dinVW = parcelRequire("dinVW");











var $kmQhR = parcelRequire("kmQhR");





var $iMnC5 = parcelRequire("iMnC5");




var $1LXnB = parcelRequire("1LXnB");


var $4pBmf = parcelRequire("4pBmf");








var $iDrrr = parcelRequire("iDrrr");


var $j0Q3v = parcelRequire("j0Q3v");

const $09e0b7f0b9011910$export$1f7957aafeeb725b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const isAdvancedThemingEnabled = (0, $j0Q3v.useIsAdvancedThemingEnabled)();
    let t0;
    if ($[0] !== isAdvancedThemingEnabled) {
        t0 = isAdvancedThemingEnabled && (0, $iDrrr.fg)("hub-space-density");
        $[0] = isAdvancedThemingEnabled;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const isAdvancedThemingEnabled = (0, $j0Q3v.useIsAdvancedThemingEnabled)();
    return isAdvancedThemingEnabled && (0, $iDrrr.fg)('hub-space-density');
};


/**
 * Public type for the Hub space density (spacing) customization.
 *
 * Values mirror the backend `HelpCenterSpaceDensity` GraphQL enum exactly
 * (uppercase), so there is no case-mapping at the read/write boundaries.
 *
 * The chosen density will control the vertical rhythm
 * between every element on the hub page and, eventually, the spacing inside
 * elements.
 */ const $755de27231b6e471$export$7525d7f8474e6b81 = [
    'DEFAULT',
    'COMFORTABLE',
    'BREEZY'
];
const $755de27231b6e471$export$61fa4fc6e277c51f = 'DEFAULT';
const $755de27231b6e471$export$cf3820686f87514a = '--ak-editor-extension-block-spacing';
const $755de27231b6e471$export$6ca1261611fbc46e = {
    DEFAULT: '0',
    COMFORTABLE: '16px',
    BREEZY: '24px'
};
const $755de27231b6e471$export$a652a2b31fb9818 = (density)=>$755de27231b6e471$export$6ca1261611fbc46e[density];
const $755de27231b6e471$export$cc1134cace54c337 = {
    DEFAULT: 16,
    COMFORTABLE: 16,
    BREEZY: 24
};
const $755de27231b6e471$export$4cd8ab356af25889 = (density)=>$755de27231b6e471$export$cc1134cace54c337[density];



var $531JC = parcelRequire("531JC");


var $gMXXV = parcelRequire("gMXXV");


var $5D0gt = parcelRequire("5D0gt");

const $1036ce2280d59186$export$ba1fe8828f2c393e = 16;
const $1036ce2280d59186$export$f4a9066d04eb34fe = 16;
const $1036ce2280d59186$var$styles = {
    flexBox: "_1e0c1txw _kqswh2mm _19bvze3t",
    stacked: "_1n261g80",
    row: "_1reo15vq _18m915vq",
    left: "_1bah1y6m",
    center: "_1bah1h6o",
    right: "_1bahesu3"
};
const $1036ce2280d59186$export$37f8d84bb48ae4b7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(63);
    const { numberOfCards: numberOfCards, cardDimensions: cardDimensions, alignment: alignment, isStacked: isStacked, isInViewMode: isInViewMode, extensionLocalId: extensionLocalId, cards: cards, renderCard: renderCard, showAIDisclaimer: showAIDisclaimer, cardsContentFooter: CardsContentFooter, testId: testId } = t0;
    const isHubSpaceDensityEnabled = (0, $09e0b7f0b9011910$export$1f7957aafeeb725b)();
    const spaceDensity = (0, $4pBmf.useHubTheming)()?.spaceDensity;
    let t1;
    if ($[0] !== isHubSpaceDensityEnabled || $[1] !== spaceDensity) {
        t1 = isHubSpaceDensityEnabled && spaceDensity ? (0, $755de27231b6e471$export$4cd8ab356af25889)(spaceDensity) : undefined;
        $[0] = isHubSpaceDensityEnabled;
        $[1] = spaceDensity;
        $[2] = t1;
    } else t1 = $[2];
    const gapBetweenItems = t1;
    let t2;
    if ($[3] !== cardDimensions || $[4] !== gapBetweenItems || $[5] !== numberOfCards) {
        t2 = {
            numberOfCards: numberOfCards,
            cardDimensions: cardDimensions,
            gapBetweenItems: gapBetweenItems
        };
        $[3] = cardDimensions;
        $[4] = gapBetweenItems;
        $[5] = numberOfCards;
        $[6] = t2;
    } else t2 = $[6];
    const { calculations: calculations, setCurrentCardsGridWidth: setCurrentCardsGridWidth, setCurrentCardWidth: setCurrentCardWidth } = (0, $gMXXV.useWidthAndSpacingCalculations)(t2);
    const { cardWidthOnFullRow: cardWidthOnFullRow, isFirstRowFull: isFirstRowFull, isGridSmallerOrEqualWidthToCards: isGridSmallerOrEqualWidthToCards, gaps: gaps, maxNumberOfCardsPerRow: maxNumberOfCardsPerRow } = calculations;
    let t3;
    if ($[7] !== setCurrentCardsGridWidth) {
        t3 = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))(setCurrentCardsGridWidth, 200);
        $[7] = setCurrentCardsGridWidth;
        $[8] = t3;
    } else t3 = $[8];
    const throttledSetWidth = t3;
    const orientation = isStacked ? "grid" : "row";
    const spaceBetweenCards = gaps.spaceBetweenCards;
    const t4 = cards?.length;
    const t5 = !isStacked;
    let t6;
    if ($[9] !== maxNumberOfCardsPerRow || $[10] !== t4 || $[11] !== t5) {
        t6 = {
            maxNumberOfItemsPerRow: maxNumberOfCardsPerRow,
            numberOfItems: t4,
            isRow: t5
        };
        $[9] = maxNumberOfCardsPerRow;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    const { isAtBeginning: isAtBeginning, isAtEnd: isAtEnd, scrollToPrevious: scrollToPrevious, scrollToNext: scrollToNext, scrollToIndex: scrollToIndex, requestScrollIndex: requestScrollIndex, resetScrollIndex: resetScrollIndex } = (0, $531JC.useOrientationScrolling)(t6);
    const allCardsShown = isInViewMode && isAtBeginning && isAtEnd;
    const t7 = `link-cards-content-cards-${orientation}`;
    const t8 = isStacked ? $1036ce2280d59186$var$styles.stacked : $1036ce2280d59186$var$styles.row;
    const t9 = !isStacked || isGridSmallerOrEqualWidthToCards ? $1036ce2280d59186$var$styles.left : $1036ce2280d59186$var$styles[alignment];
    let t10;
    if ($[13] !== t8 || $[14] !== t9) {
        t10 = (0, $w6R6I.cx)($1036ce2280d59186$var$styles.flexBox, t8, t9);
        $[13] = t8;
        $[14] = t9;
        $[15] = t10;
    } else t10 = $[15];
    const t11 = `${spaceBetweenCards}px`;
    let t12;
    if ($[16] !== t11) {
        t12 = {
            gap: t11
        };
        $[16] = t11;
        $[17] = t12;
    } else t12 = $[17];
    let t13;
    if ($[18] !== cardDimensions || $[19] !== cardWidthOnFullRow || $[20] !== cards || $[21] !== extensionLocalId || $[22] !== isFirstRowFull || $[23] !== orientation || $[24] !== renderCard || $[25] !== requestScrollIndex || $[26] !== resetScrollIndex || $[27] !== scrollToIndex || $[28] !== setCurrentCardWidth) {
        let t14;
        if ($[30] !== cardDimensions || $[31] !== cardWidthOnFullRow || $[32] !== extensionLocalId || $[33] !== isFirstRowFull || $[34] !== orientation || $[35] !== renderCard || $[36] !== requestScrollIndex || $[37] !== resetScrollIndex || $[38] !== scrollToIndex || $[39] !== setCurrentCardWidth) {
            t14 = (card, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5D0gt.CardOrientationWrapper), {
                    cardId: card.cardId,
                    key: index,
                    isFirstRowFull: isFirstRowFull,
                    cardWidthOnFullRow: cardWidthOnFullRow,
                    itemDimensions: cardDimensions,
                    setWidth: index === 0 ? setCurrentCardWidth : undefined,
                    scrollToCard: index === scrollToIndex,
                    clearScrollToCard: resetScrollIndex,
                    testId: `link-cards-content-cards-${orientation}-card-${index}`,
                    index: index,
                    requestScrollIndex: requestScrollIndex,
                    extensionLocalId: extensionLocalId,
                    ariaRole: "listitem"
                }, renderCard(card));
            $[30] = cardDimensions;
            $[31] = cardWidthOnFullRow;
            $[32] = extensionLocalId;
            $[33] = isFirstRowFull;
            $[34] = orientation;
            $[35] = renderCard;
            $[36] = requestScrollIndex;
            $[37] = resetScrollIndex;
            $[38] = scrollToIndex;
            $[39] = setCurrentCardWidth;
            $[40] = t14;
        } else t14 = $[40];
        t13 = cards.map(t14);
        $[18] = cardDimensions;
        $[19] = cardWidthOnFullRow;
        $[20] = cards;
        $[21] = extensionLocalId;
        $[22] = isFirstRowFull;
        $[23] = orientation;
        $[24] = renderCard;
        $[25] = requestScrollIndex;
        $[26] = resetScrollIndex;
        $[27] = scrollToIndex;
        $[28] = setCurrentCardWidth;
        $[29] = t13;
    } else t13 = $[29];
    let t14;
    if ($[41] !== throttledSetWidth) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.default), {
            setWidth: throttledSetWidth,
            offscreen: true
        });
        $[41] = throttledSetWidth;
        $[42] = t14;
    } else t14 = $[42];
    let t15;
    if ($[43] !== t10 || $[44] !== t12 || $[45] !== t13 || $[46] !== t14 || $[47] !== t7) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            testId: t7,
            xcss: t10,
            style: t12,
            role: "list"
        }, t13, t14);
        $[43] = t10;
        $[44] = t12;
        $[45] = t13;
        $[46] = t14;
        $[47] = t7;
        $[48] = t15;
    } else t15 = $[48];
    let t16;
    if ($[49] !== CardsContentFooter || $[50] !== allCardsShown || $[51] !== cards.length || $[52] !== isAtBeginning || $[53] !== isAtEnd || $[54] !== isStacked || $[55] !== scrollToNext || $[56] !== scrollToPrevious || $[57] !== showAIDisclaimer) {
        t16 = cards.length > 0 && CardsContentFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CardsContentFooter, {
            isStacked: isStacked,
            showAIDisclaimer: showAIDisclaimer,
            allCardsShown: allCardsShown,
            isAtBeginning: isAtBeginning,
            isAtEnd: isAtEnd,
            scrollToPrevious: scrollToPrevious,
            scrollToNext: scrollToNext
        });
        $[49] = CardsContentFooter;
        $[50] = allCardsShown;
        $[51] = cards.length;
        $[52] = isAtBeginning;
        $[53] = isAtEnd;
        $[54] = isStacked;
        $[55] = scrollToNext;
        $[56] = scrollToPrevious;
        $[57] = showAIDisclaimer;
        $[58] = t16;
    } else t16 = $[58];
    let t17;
    if ($[59] !== t15 || $[60] !== t16 || $[61] !== testId) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            testId: testId
        }, t15, t16);
        $[59] = t15;
        $[60] = t16;
        $[61] = testId;
        $[62] = t17;
    } else t17 = $[62];
    return t17;
} : ({ numberOfCards: numberOfCards, cardDimensions: cardDimensions, alignment: alignment, isStacked: isStacked, isInViewMode: isInViewMode, extensionLocalId: extensionLocalId, cards: cards, renderCard: renderCard, showAIDisclaimer: showAIDisclaimer, cardsContentFooter: CardsContentFooter, testId: testId })=>{
    // Space density (Default/Comfortable/Breezy) widens the horizontal gap
    // between cards. When the feature is disabled or no density is selected, the
    // gap stays at the default 16px — a no-op for existing hubs.
    const isHubSpaceDensityEnabled = (0, $09e0b7f0b9011910$export$1f7957aafeeb725b)();
    const spaceDensity = (0, $4pBmf.useHubTheming)()?.spaceDensity;
    const gapBetweenItems = isHubSpaceDensityEnabled && spaceDensity ? (0, $755de27231b6e471$export$4cd8ab356af25889)(spaceDensity) : undefined;
    const { calculations: calculations, setCurrentCardsGridWidth: setCurrentCardsGridWidth, setCurrentCardWidth: setCurrentCardWidth } = (0, $gMXXV.useWidthAndSpacingCalculations)({
        numberOfCards: numberOfCards,
        cardDimensions: cardDimensions,
        gapBetweenItems: gapBetweenItems
    });
    const { cardWidthOnFullRow: cardWidthOnFullRow, isFirstRowFull: isFirstRowFull, isGridSmallerOrEqualWidthToCards: isGridSmallerOrEqualWidthToCards, gaps: gaps, maxNumberOfCardsPerRow: maxNumberOfCardsPerRow } = calculations;
    const throttledSetWidth = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))(setCurrentCardsGridWidth, 200);
    const orientation = isStacked ? 'grid' : 'row';
    const spaceBetweenCards = gaps.spaceBetweenCards;
    const { isAtBeginning: isAtBeginning, isAtEnd: isAtEnd, scrollToPrevious: scrollToPrevious, scrollToNext: scrollToNext, scrollToIndex: scrollToIndex, requestScrollIndex: requestScrollIndex, resetScrollIndex: resetScrollIndex } = (0, $531JC.useOrientationScrolling)({
        maxNumberOfItemsPerRow: maxNumberOfCardsPerRow,
        numberOfItems: cards?.length,
        isRow: !isStacked
    });
    const allCardsShown = isInViewMode && isAtBeginning && isAtEnd;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        testId: `link-cards-content-cards-${orientation}`,
        xcss: (0, $w6R6I.cx)($1036ce2280d59186$var$styles.flexBox, isStacked ? $1036ce2280d59186$var$styles.stacked : $1036ce2280d59186$var$styles.row, /**
     * Align left regardless of alignment if
     * - orientation is row
     * - the grid width is smaller or equal to the minimum width of the card size
     */ !isStacked || isGridSmallerOrEqualWidthToCards ? $1036ce2280d59186$var$styles.left : $1036ce2280d59186$var$styles[alignment]),
        style: {
            gap: `${spaceBetweenCards}px`
        },
        role: "list"
    }, cards.map((card, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5D0gt.CardOrientationWrapper), {
            cardId: card.cardId,
            key: index,
            isFirstRowFull: isFirstRowFull,
            cardWidthOnFullRow: cardWidthOnFullRow,
            itemDimensions: cardDimensions,
            setWidth: index === 0 ? setCurrentCardWidth : undefined,
            scrollToCard: index === scrollToIndex,
            clearScrollToCard: resetScrollIndex,
            testId: `link-cards-content-cards-${orientation}-card-${index}`,
            index: index,
            requestScrollIndex: requestScrollIndex,
            extensionLocalId: extensionLocalId,
            ariaRole: "listitem"
        }, renderCard(card))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.default), {
        setWidth: throttledSetWidth,
        offscreen: true
    })), cards.length > 0 && CardsContentFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CardsContentFooter, {
        isStacked: isStacked,
        showAIDisclaimer: showAIDisclaimer,
        allCardsShown: allCardsShown,
        isAtBeginning: isAtBeginning,
        isAtEnd: isAtEnd,
        scrollToPrevious: scrollToPrevious,
        scrollToNext: scrollToNext
    }));
};











var $kSwu1 = parcelRequire("kSwu1");


var $24dy7 = parcelRequire("24dy7");


var $kz1Yj = parcelRequire("kz1Yj");

var $6Pqow = parcelRequire("6Pqow");

var $buxP3 = parcelRequire("buxP3");







const $0f6158376f466854$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    errorLoadingCardsPreamble: {
        id: "company-hub.company-hub-common.link-cards-content.card-components.error-states.loading-cards-error-preamble",
        defaultMessage: "We\u2019re having trouble loading these cards."
    },
    errorLoadingCardsSupport: {
        id: "company-hub.company-hub-common.link-cards-content.card-components.error-states.loading-cards-error-support",
        defaultMessage: "Reload to try again."
    }
});


const $f15264ed5f302311$var$inlineStyles = (0, $buxP3.xcss)({
    marginTop: 'space.150'
});
const $f15264ed5f302311$export$533cd3269e981a31 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { error: error } = t0;
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    let t1;
    let t2;
    if ($[0] !== error || $[1] !== submitError) {
        t1 = ()=>{
            submitError?.(error);
        };
        t2 = [
            error,
            submitError
        ];
        $[0] = error;
        $[1] = submitError;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            label: "error",
            color: "var(--ds-icon-danger, #C9372C)"
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
            weight: "medium",
            size: "medium",
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $0f6158376f466854$export$defe85febe8b728c).errorLoadingCardsPreamble));
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            space: "space.100",
            alignBlock: "center",
            xcss: $f15264ed5f302311$var$inlineStyles
        }, t3, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
            weight: "medium",
            size: "medium",
            color: "color.text.subtlest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $0f6158376f466854$export$defe85febe8b728c).errorLoadingCardsSupport)));
        $[6] = t5;
    } else t5 = $[6];
    return t5;
} : ({ error: error })=>{
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    (0, $cozmU.useEffect)(()=>{
        submitError?.(error);
    }, [
        error,
        submitError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: $f15264ed5f302311$var$inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        weight: "medium",
        size: "medium",
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $0f6158376f466854$export$defe85febe8b728c).errorLoadingCardsPreamble)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        weight: "medium",
        size: "medium",
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $0f6158376f466854$export$defe85febe8b728c).errorLoadingCardsSupport)));
};















const $e4389e92f972a9fa$export$93c098ff84870fcb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { isCompanyHub: isCompanyHub, isSegmentationShown: isSegmentationShown, isTargetAudience: isTargetAudience, cards: cards, isInViewMode: isInViewMode, segmentationTarget: segmentationTarget, audienceSegmentationGroupIds: audienceSegmentationGroupIds, renderVariant: renderVariant } = t0;
    const shouldApplySegmentation = isCompanyHub && isSegmentationShown;
    let t1;
    bb0: {
        const isAudienceSegmentationEnabled = isInViewMode && shouldApplySegmentation;
        const isDynamicOrManualWithAllTarget = renderVariant === (0, $hjUDQ.RenderVariant).DYNAMIC || renderVariant === (0, $hjUDQ.RenderVariant).MANUAL && segmentationTarget === (0, $hjUDQ.SegmentationTargets).ALL;
        if (!isAudienceSegmentationEnabled) {
            t1 = cards;
            break bb0;
        }
        if (isDynamicOrManualWithAllTarget) {
            let t2;
            if ($[0] !== audienceSegmentationGroupIds || $[1] !== cards || $[2] !== isTargetAudience) {
                t2 = isTargetAudience(audienceSegmentationGroupIds) ? cards : [];
                $[0] = audienceSegmentationGroupIds;
                $[1] = cards;
                $[2] = isTargetAudience;
                $[3] = t2;
            } else t2 = $[3];
            t1 = t2;
            break bb0;
        }
        let t2;
        if ($[4] !== cards || $[5] !== isTargetAudience) {
            let t3;
            if ($[7] !== isTargetAudience) {
                t3 = (card)=>isTargetAudience(card.audienceSegmentationGroupIds);
                $[7] = isTargetAudience;
                $[8] = t3;
            } else t3 = $[8];
            t2 = cards.filter(t3);
            $[4] = cards;
            $[5] = isTargetAudience;
            $[6] = t2;
        } else t2 = $[6];
        t1 = t2;
    }
    const filteredCards = t1;
    let t2;
    if ($[9] !== filteredCards) {
        t2 = {
            filteredCards: filteredCards
        };
        $[9] = filteredCards;
        $[10] = t2;
    } else t2 = $[10];
    return t2;
} : ({ isCompanyHub: isCompanyHub, isSegmentationShown: isSegmentationShown, isTargetAudience: isTargetAudience, cards: cards, isInViewMode: isInViewMode, segmentationTarget: segmentationTarget, audienceSegmentationGroupIds: audienceSegmentationGroupIds, renderVariant: renderVariant })=>{
    const shouldApplySegmentation = (0, $cozmU.useMemo)(()=>isCompanyHub && isSegmentationShown, [
        isCompanyHub,
        isSegmentationShown
    ]);
    const filteredCards = (0, $cozmU.useMemo)(()=>{
        const isAudienceSegmentationEnabled = isInViewMode && shouldApplySegmentation;
        const isDynamicOrManualWithAllTarget = renderVariant === (0, $hjUDQ.RenderVariant).DYNAMIC || renderVariant === (0, $hjUDQ.RenderVariant).MANUAL && segmentationTarget === (0, $hjUDQ.SegmentationTargets).ALL;
        if (!isAudienceSegmentationEnabled) return cards;
        if (isDynamicOrManualWithAllTarget) return isTargetAudience(audienceSegmentationGroupIds) ? cards : [];
        return cards.filter((card)=>isTargetAudience(card.audienceSegmentationGroupIds));
    }, [
        isInViewMode,
        shouldApplySegmentation,
        segmentationTarget,
        cards,
        renderVariant,
        isTargetAudience,
        audienceSegmentationGroupIds
    ]);
    return {
        filteredCards: filteredCards
    };
};




const $b2481ad40679111c$export$c6c5cac0793c45d9 = (items)=>{
    const itemIdSet = (0, $cozmU.useMemo)(()=>new Set(items.map((item)=>item.cardId)), [
        items
    ]);
    const [areAllItemsLoaded, setAreAllItemsLoaded] = (0, $cozmU.useState)(false);
    const [itemFailureError, setItemFailureError] = (0, $cozmU.useState)(null);
    const onItemFailed = (0, $cozmU.useCallback)((error)=>{
        setItemFailureError(error);
    }, []);
    const onItemSucceeded = (0, $cozmU.useCallback)((itemId)=>{
        itemIdSet.delete(itemId);
        if (itemIdSet.size === 0) setAreAllItemsLoaded(true);
    }, [
        itemIdSet
    ]);
    return (0, $cozmU.useMemo)(()=>({
            areAllItemsLoaded: areAllItemsLoaded,
            itemFailureError: itemFailureError,
            onItemSucceeded: onItemSucceeded,
            onItemFailed: onItemFailed
        }), [
        areAllItemsLoaded,
        itemFailureError,
        onItemSucceeded,
        onItemFailed
    ]);
};





























var $8qkba = parcelRequire("8qkba");

var $619Qo = parcelRequire("619Qo");


var $8N7MV = parcelRequire("8N7MV");

var $hOJLU = parcelRequire("hOJLU");

var $4XdCR = parcelRequire("4XdCR");


var $hz3c4 = parcelRequire("hz3c4");


var $k2pUk = parcelRequire("k2pUk");

const $75b0428829020cae$var$getFilterValue = (filter)=>{
    return filter?.split(',') || [];
};
const $75b0428829020cae$var$getFilterDateRange = (filters)=>{
    const { lastModified: lastModified } = filters;
    if (lastModified && lastModified !== 'custom') return [
        (0, $hz3c4.getConfluenceDateOptionValues)(lastModified)
    ];
    else if (lastModified === 'custom') {
        if (filters?.from && filters?.to) return [
            (0, $hz3c4.getConfluenceDateOptionFromCustomDates)(filters.from, filters.to)
        ];
    }
    return [];
};
const $75b0428829020cae$var$getEntities = (type)=>{
    if (type === 'page') return [
        (0, $8N7MV.PAGE_ATI)
    ];
    else if (type === 'blogpost') return [
        (0, $8N7MV.BLOGPOST_ATI)
    ];
    return [
        (0, $8N7MV.PAGE_ATI),
        (0, $8N7MV.BLOGPOST_ATI)
    ];
};
const $75b0428829020cae$var$getConfluenceFilters = (filters)=>{
    const { spaces: spaces, owners: owners, labels: labels, contributors: contributors, ancestor: ancestor, verified: verified } = filters;
    return {
        spacesFilter: $75b0428829020cae$var$getFilterValue(spaces),
        isVerified: verified || undefined,
        contributorsFilter: $75b0428829020cae$var$getFilterValue(contributors),
        ancestorIdsFilter: $75b0428829020cae$var$getFilterValue(ancestor),
        range: $75b0428829020cae$var$getFilterDateRange(filters),
        owners: $75b0428829020cae$var$getFilterValue(owners),
        labelsFilter: $75b0428829020cae$var$getFilterValue(labels)
    };
};
const $75b0428829020cae$var$getSearchPageQueryVariables = (cardCount, filters, cloudId, searchSessionId)=>{
    const entities = $75b0428829020cae$var$getEntities(filters.type);
    return {
        query: '',
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: cardCount,
        entities: entities,
        commonFilters: {},
        confluenceFilters: $75b0428829020cae$var$getConfluenceFilters(filters),
        jiraFilters: {
            issueFilter: {
                projectARIs: [],
                assigneeARIs: []
            }
        },
        thirdPartyFilters: {
            titleMatchOnly: false,
            subtypes: []
        },
        queryVersion: 1,
        searchSessionId: searchSessionId ?? '',
        sort: [
            {
                field: filters.sortField || (0, $4XdCR.SORT_FIELD_KEY).LAST_MODIFIED_DATE,
                order: filters.sortOrder || (0, $4XdCR.SORT_ORDER).DESC
            }
        ]
    };
};
const $75b0428829020cae$export$7bf81438544569b5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(7);
    const { cloudId: cloudId, searchConfigProvider: searchConfigProvider } = (0, $cfM7x.useProductDependencies)();
    let t0;
    if ($[0] !== searchConfigProvider) {
        t0 = searchConfigProvider || {};
        $[0] = searchConfigProvider;
        $[1] = t0;
    } else t0 = $[1];
    const { searchSessionId: searchSessionId } = t0;
    let t1;
    if ($[2] !== cloudId || $[3] !== searchSessionId) {
        t1 = async (cardCount, filters)=>{
            const variables = $75b0428829020cae$var$getSearchPageQueryVariables(cardCount, filters, cloudId, searchSessionId);
            const { data: data, errors: errors } = await (0, $hOJLU.searchPageQuery)({
                variables: variables
            });
            const results = data?.search.results.edges.map($75b0428829020cae$var$_temp) || [];
            if (results.length === 0) return {
                cards: [],
                errors: errors
            };
            const trimmedResults = results?.slice(0, Math.min(cardCount, results.length));
            const dynamicCards = trimmedResults?.map($75b0428829020cae$var$_temp5);
            return {
                cards: dynamicCards,
                errors: errors
            };
        };
        $[2] = cloudId;
        $[3] = searchSessionId;
        $[4] = t1;
    } else t1 = $[4];
    const getDynamicCards = t1;
    let t2;
    if ($[5] !== getDynamicCards) {
        t2 = {
            getDynamicCards: getDynamicCards
        };
        $[5] = getDynamicCards;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ()=>{
    const { cloudId: cloudId, searchConfigProvider: searchConfigProvider } = (0, $cfM7x.useProductDependencies)();
    const { searchSessionId: searchSessionId } = searchConfigProvider || {};
    const getDynamicCards = (0, $cozmU.useCallback)(async (cardCount, filters)=>{
        const variables = $75b0428829020cae$var$getSearchPageQueryVariables(cardCount, filters, cloudId, searchSessionId);
        const { data: data, errors: errors } = await (0, $hOJLU.searchPageQuery)({
            variables: variables
        });
        const results = data?.search.results.edges.map((edge)=>edge.node) || [];
        if (results.length === 0) return {
            cards: [],
            errors: errors
        };
        const trimmedResults = results?.slice(0, Math.min(cardCount, results.length));
        const dynamicCards = trimmedResults?.map((result)=>{
            const { title: title, description: description, url: url, id: id, confluenceEntity: confluenceEntity } = result;
            const newCard = (0, $k2pUk.createNewCardWithDefaultParameters)();
            newCard.link = url;
            newCard.title = title;
            newCard.description = description;
            newCard.confluencePageId = id.split('/')[1];
            if (confluenceEntity) {
                const { subtype: subtype, properties: properties } = confluenceEntity;
                const isLivePage = subtype === 'live';
                let imageProperty;
                if (isLivePage) imageProperty = properties?.find((image)=>image?.key === (0, $8qkba.CoverPictureIdPropertyKey).DRAFT);
                else {
                    imageProperty = properties?.find((image_0)=>image_0?.key === (0, $8qkba.CoverPictureIdPropertyKey).PUBLISHED);
                    if (!imageProperty) imageProperty = properties?.find((image_1)=>image_1?.key === (0, $8qkba.CoverPictureIdPropertyKey).DRAFT);
                }
                let imageSrc = (0, $8qkba.propertyToId)(imageProperty)?.value?.id;
                if (imageSrc && !(0, $619Qo.isUnsplashImage)(imageSrc)) imageSrc = `${newCard.confluencePageId}/${imageSrc}`;
                newCard.imageSrc = imageSrc;
            }
            return newCard;
        });
        return {
            cards: dynamicCards,
            errors: errors
        };
    }, [
        cloudId,
        searchSessionId
    ]);
    return (0, $cozmU.useMemo)(()=>({
            getDynamicCards: getDynamicCards
        }), [
        getDynamicCards
    ]);
};
function $75b0428829020cae$var$_temp(edge) {
    return edge.node;
}
function $75b0428829020cae$var$_temp2(image) {
    return image?.key === (0, $8qkba.CoverPictureIdPropertyKey).DRAFT;
}
function $75b0428829020cae$var$_temp3(image_0) {
    return image_0?.key === (0, $8qkba.CoverPictureIdPropertyKey).PUBLISHED;
}
function $75b0428829020cae$var$_temp4(image_1) {
    return image_1?.key === (0, $8qkba.CoverPictureIdPropertyKey).DRAFT;
}
function $75b0428829020cae$var$_temp5(result) {
    const { title: title, description: description, url: url, id: id, confluenceEntity: confluenceEntity } = result;
    const newCard = (0, $k2pUk.createNewCardWithDefaultParameters)();
    newCard.link = url;
    newCard.title = title;
    newCard.description = description;
    newCard.confluencePageId = id.split("/")[1];
    if (confluenceEntity) {
        const { subtype: subtype, properties: properties } = confluenceEntity;
        const isLivePage = subtype === "live";
        let imageProperty;
        if (isLivePage) imageProperty = properties?.find($75b0428829020cae$var$_temp2);
        else {
            imageProperty = properties?.find($75b0428829020cae$var$_temp3);
            if (!imageProperty) imageProperty = properties?.find($75b0428829020cae$var$_temp4);
        }
        let imageSrc = (0, $8qkba.propertyToId)(imageProperty)?.value?.id;
        if (imageSrc && !(0, $619Qo.isUnsplashImage)(imageSrc)) imageSrc = `${newCard.confluencePageId}/${imageSrc}`;
        newCard.imageSrc = imageSrc;
    }
    return newCard;
}


const $6d3e30142bf823a9$export$5fe928848609fec7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (parameters)=>{
    const $ = (0, $bDgLe.c)(11);
    const { cardCount: cardCount, filters: filters } = parameters;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const [cards, setCards] = (0, $cozmU.useState)(t0);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(null);
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    const { getDynamicCards: getDynamicCards } = (0, $75b0428829020cae$export$7bf81438544569b5)();
    let t1;
    let t2;
    if ($[1] !== cardCount || $[2] !== filters || $[3] !== getDynamicCards || $[4] !== submitError) {
        t1 = ()=>{
            if (!!cardCount && !!filters) {
                setLoading(true);
                setError(null);
                let isActive = true;
                getDynamicCards(cardCount, filters).then((t3)=>{
                    const { cards: dynamicCards, errors: aggErrors } = t3;
                    if (!isActive) return;
                    if (aggErrors) {
                        const error_0 = new Error(JSON.stringify(aggErrors));
                        if (dynamicCards.length === 0) setError(error_0);
                        else submitError?.(error_0);
                    }
                    setCards(dynamicCards);
                }).catch((err)=>{
                    if (!isActive) return;
                    setError(err);
                }).finally(()=>{
                    if (!isActive) return;
                    setLoading(false);
                });
                return ()=>{
                    isActive = false;
                };
            }
        };
        t2 = [
            getDynamicCards,
            cardCount,
            filters,
            submitError
        ];
        $[1] = cardCount;
        $[2] = filters;
        $[3] = getDynamicCards;
        $[4] = submitError;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[7] !== cards || $[8] !== error || $[9] !== loading) {
        t3 = {
            cards: cards,
            loading: loading,
            error: error
        };
        $[7] = cards;
        $[8] = error;
        $[9] = loading;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : (parameters)=>{
    const { cardCount: cardCount, filters: filters } = parameters;
    const [cards, setCards] = (0, $cozmU.useState)([]);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(null);
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    const { getDynamicCards: getDynamicCards } = (0, $75b0428829020cae$export$7bf81438544569b5)();
    (0, $cozmU.useEffect)(()=>{
        if (!!cardCount && !!filters) {
            setLoading(true);
            setError(null);
            let isActive = true;
            getDynamicCards(cardCount, filters).then(({ cards: dynamicCards, errors: aggErrors })=>{
                if (!isActive) return;
                if (aggErrors) {
                    const error_0 = new Error(JSON.stringify(aggErrors));
                    if (dynamicCards.length === 0) setError(error_0);
                    else submitError?.(error_0);
                }
                setCards(dynamicCards);
            }).catch((err)=>{
                if (!isActive) return;
                setError(err);
            }).finally(()=>{
                if (!isActive) return;
                setLoading(false);
            });
            return ()=>{
                isActive = false;
            };
        }
    }, [
        getDynamicCards,
        cardCount,
        filters,
        submitError
    ]);
    return (0, $cozmU.useMemo)(()=>({
            cards: cards,
            loading: loading,
            error: error
        }), [
        cards,
        loading,
        error
    ]);
};



var $9BXp4 = parcelRequire("9BXp4");




var $ikd73 = parcelRequire("ikd73");



const $f73aa100a9fdb106$var$checkIsParameterValueValid = (parameter, expectedValues)=>{
    return expectedValues.includes(parameter) ? parameter : null;
};
const $f73aa100a9fdb106$var$checkSize = (size)=>$f73aa100a9fdb106$var$checkIsParameterValueValid(size, [
        (0, $hjUDQ.Height).SMALL,
        (0, $hjUDQ.Height).MEDIUM,
        (0, $hjUDQ.Height).LARGE
    ]);
const $f73aa100a9fdb106$var$checkLayout = (layout)=>$f73aa100a9fdb106$var$checkIsParameterValueValid(layout, [
        (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT,
        (0, $ikd73.CardsLayout).FLEXIBLE_IMAGE_HEIGHT
    ]);
const $f73aa100a9fdb106$export$9a666555160249c1 = (currentParameters)=>{
    const validatedCards = (0, $9BXp4.checkItems)(currentParameters.cards);
    const validatedSize = $f73aa100a9fdb106$var$checkSize(currentParameters.size);
    const validatedLayout = $f73aa100a9fdb106$var$checkLayout(currentParameters.layout);
    const validatedRequiredParameters = {
        ...currentParameters,
        size: validatedSize || (0, $hjUDQ.Height).MEDIUM,
        cards: validatedCards || [],
        layout: validatedLayout || (0, $ikd73.CardsLayout).FLEXIBLE_IMAGE_HEIGHT
    };
    const { orientation: orientation, alignment: alignment, isAutoscrollEnabled: isAutoscrollEnabled } = validatedRequiredParameters;
    return {
        ...validatedRequiredParameters,
        // if alignment is not available (cards created before alignment), default to center
        alignment: alignment ?? (0, $ikd73.Alignment).CENTER,
        // if orientation is not available (cards created before orientation), default to stacked
        orientation: orientation ?? (0, $ikd73.Orientation).STACKED,
        isAutoscrollEnabled: orientation === (0, $ikd73.Orientation).STACKED ? false : isAutoscrollEnabled,
        // if audience segmentation new format is enabled and params are outdated, use the first card's audience segmentation group ids
        audienceSegmentationGroupIds: currentParameters.segmentationTarget === (0, $hjUDQ.SegmentationTargets).ALL && currentParameters.audienceSegmentationGroupIds === undefined ? currentParameters.cards[0]?.audienceSegmentationGroupIds : currentParameters?.audienceSegmentationGroupIds
    };
};

















var $hekY6 = parcelRequire("hekY6");








var $1sCHt = parcelRequire("1sCHt");


var $k5vii = parcelRequire("k5vii");


var $fZ6J4 = parcelRequire("fZ6J4");




var $1l0kj = parcelRequire("1l0kj");










var $32chb = parcelRequire("32chb");




const $c4a2c67793caa51b$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    pause: {
        id: "company-hub.cards-extension.autoscroll-wrapper.pause",
        defaultMessage: "Pause"
    },
    play: {
        id: "company-hub.cards-extension.autoscroll-wrapper.play",
        defaultMessage: "Play"
    }
});


const $508f24952640e58a$export$ba1fe8828f2c393e = 16;
const $508f24952640e58a$export$f4a9066d04eb34fe = 16;
const $508f24952640e58a$var$wrapperStyles = null;
const $508f24952640e58a$var$pausedStyles = null;
const $508f24952640e58a$var$scrollAnimation = null;
const $508f24952640e58a$var$styles = {
    iconBackgroundStyles: "_2rko1rr0 _bfhk1bhr _1e0c1txw _4cvr1h6o _1bah1h6o",
    iconPadding: "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
    cardsGroup: "_1e0c1txw",
    container: "_kqswh2mm"
};
const $508f24952640e58a$var$unboundedStyles = {
    wrapperStyles: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1rjcv77o _kqswh2mm"
};
const $508f24952640e58a$var$animationStyles = null;
const $508f24952640e58a$var$shortDuration = null;
const $508f24952640e58a$var$mediumDuration = null;
const $508f24952640e58a$var$longDuration = null;
const $508f24952640e58a$export$ac70d6b7d7a09503 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    const { numberOfCards: numberOfCards, cardDimensions: cardDimensions, cards: cards, renderCard: renderCard, showAIDisclaimer: showAIDisclaimer, testId: testId } = t0;
    const [isPaused, setIsPaused] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== isPaused) {
        t1 = ()=>setIsPaused(!isPaused);
        $[0] = isPaused;
        $[1] = t1;
    } else t1 = $[1];
    const handlePauseClick = t1;
    let t2;
    if ($[2] !== cardDimensions || $[3] !== numberOfCards) {
        t2 = {
            numberOfCards: numberOfCards,
            cardDimensions: cardDimensions
        };
        $[2] = cardDimensions;
        $[3] = numberOfCards;
        $[4] = t2;
    } else t2 = $[4];
    const { calculations: calculations, setCurrentCardsGridWidth: setCurrentCardsGridWidth } = (0, $gMXXV.useWidthAndSpacingCalculations)(t2);
    let t3;
    if ($[5] !== setCurrentCardsGridWidth) {
        t3 = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))(setCurrentCardsGridWidth, 200);
        $[5] = setCurrentCardsGridWidth;
        $[6] = t3;
    } else t3 = $[6];
    const throttledSetWidth = t3;
    const { cardWidthOnFullRow: cardWidthOnFullRow, isFirstRowOverflown: isAnimationEnabled } = calculations;
    let t4;
    if ($[7] !== cardWidthOnFullRow || $[8] !== cards || $[9] !== isAnimationEnabled || $[10] !== numberOfCards || $[11] !== renderCard) {
        t4 = ()=>/*#__PURE__*/ $cozmU.createElement("div", {
                style: {
                    gap: `${$508f24952640e58a$export$ba1fe8828f2c393e}px`,
                    paddingRight: `${$508f24952640e58a$export$ba1fe8828f2c393e}px`
                },
                className: (0, $hekY6.default)([
                    $508f24952640e58a$var$styles.cardsGroup,
                    isAnimationEnabled && "",
                    isAnimationEnabled && "_y44v543u _1bumglyw",
                    numberOfCards <= 5 ? "_5sagx094" : numberOfCards <= 10 ? "_5sag1als" : "_5sag1bqb"
                ])
            }, cards.map((card, cardIndex)=>/*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), {
                    key: cardIndex
                }, /*#__PURE__*/ $cozmU.createElement("div", {
                    style: {
                        minWidth: `${cardWidthOnFullRow}px`,
                        maxWidth: `${cardWidthOnFullRow}px`
                    },
                    className: (0, $hekY6.default)([
                        $508f24952640e58a$var$unboundedStyles.wrapperStyles
                    ])
                }, renderCard(card)))));
        $[7] = cardWidthOnFullRow;
        $[8] = cards;
        $[9] = isAnimationEnabled;
        $[10] = numberOfCards;
        $[11] = renderCard;
        $[12] = t4;
    } else t4 = $[12];
    const renderCardsGroup = t4;
    const t5 = isPaused && "_10r1trqk";
    let t6;
    if ($[13] !== t5) {
        t6 = (0, $hekY6.default)([
            "_1reo15vq _1e0c1txw _1wudtrqk",
            t5
        ]);
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== renderCardsGroup) {
        t7 = renderCardsGroup();
        $[15] = renderCardsGroup;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== isAnimationEnabled || $[18] !== renderCardsGroup) {
        t8 = isAnimationEnabled && renderCardsGroup();
        $[17] = isAnimationEnabled;
        $[18] = renderCardsGroup;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== throttledSetWidth) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $1LXnB.default), {
            setWidth: throttledSetWidth,
            offscreen: true
        });
        $[20] = throttledSetWidth;
        $[21] = t9;
    } else t9 = $[21];
    let t10;
    if ($[22] !== t6 || $[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "cards-autoscroll-wrapper",
            className: t6
        }, t7, t8, t9);
        $[22] = t6;
        $[23] = t7;
        $[24] = t8;
        $[25] = t9;
        $[26] = t10;
    } else t10 = $[26];
    let t11;
    if ($[27] !== handlePauseClick || $[28] !== isAnimationEnabled || $[29] !== isPaused || $[30] !== showAIDisclaimer) {
        t11 = isAnimationEnabled && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            alignInline: "start"
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: $508f24952640e58a$var$styles.iconPadding
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            space: "space.075",
            alignBlock: "center"
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: $508f24952640e58a$var$styles.iconBackgroundStyles
        }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            shape: "circle",
            icon: isPaused ? (0, (/*@__PURE__*/$parcel$interopDefault($fZ6J4))) : (0, (/*@__PURE__*/$parcel$interopDefault($k5vii))),
            label: isPaused ? /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $c4a2c67793caa51b$export$defe85febe8b728c).play) : /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $c4a2c67793caa51b$export$defe85febe8b728c).pause),
            onClick: handlePauseClick
        })), showAIDisclaimer && /*#__PURE__*/ $cozmU.createElement((0, $32chb.CardsAIDisclaimer), null))));
        $[27] = handlePauseClick;
        $[28] = isAnimationEnabled;
        $[29] = isPaused;
        $[30] = showAIDisclaimer;
        $[31] = t11;
    } else t11 = $[31];
    let t12;
    if ($[32] !== t10 || $[33] !== t11 || $[34] !== testId) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
            testId: testId,
            xcss: $508f24952640e58a$var$styles.container,
            space: "space.075"
        }, t10, t11);
        $[32] = t10;
        $[33] = t11;
        $[34] = testId;
        $[35] = t12;
    } else t12 = $[35];
    return t12;
} : ({ numberOfCards: numberOfCards, cardDimensions: cardDimensions, cards: cards, renderCard: renderCard, showAIDisclaimer: showAIDisclaimer, testId: testId })=>{
    // there are 2 ways to pause the autoscroll
    // 1. Hover over a card. Should resume back to speed when unhovered
    // 2. Pause button click. Should resume when clicked again. This is implemented to meet a11y standards
    const [isPaused, setIsPaused] = (0, $cozmU.useState)(false);
    const handlePauseClick = ()=>setIsPaused(!isPaused);
    const { calculations: calculations, setCurrentCardsGridWidth: setCurrentCardsGridWidth } = (0, $gMXXV.useWidthAndSpacingCalculations)({
        numberOfCards: numberOfCards,
        cardDimensions: cardDimensions
    });
    const throttledSetWidth = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))(setCurrentCardsGridWidth, 200);
    const { cardWidthOnFullRow: cardWidthOnFullRow, isFirstRowOverflown: isAnimationEnabled } = calculations;
    const renderCardsGroup = ()=>/*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        , {
            style: {
                gap: `${$508f24952640e58a$export$ba1fe8828f2c393e}px`,
                paddingRight: `${$508f24952640e58a$export$ba1fe8828f2c393e}px`
            },
            className: (0, $hekY6.default)([
                $508f24952640e58a$var$styles.cardsGroup,
                isAnimationEnabled && "",
                isAnimationEnabled && "_y44v543u _1bumglyw",
                numberOfCards <= 5 ? "_5sagx094" : numberOfCards <= 10 ? "_5sag1als" : "_5sag1bqb"
            ])
        }, cards.map((card, cardIndex)=>{
            return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), {
                key: cardIndex
            }, /*#__PURE__*/ $cozmU.createElement("div", {
                style: {
                    minWidth: `${cardWidthOnFullRow}px`,
                    maxWidth: `${cardWidthOnFullRow}px`
                },
                className: (0, $hekY6.default)([
                    $508f24952640e58a$var$unboundedStyles.wrapperStyles
                ])
            }, renderCard(card)));
        })); // we are making a duplicate call to renderCardsGroup to make the infinte scroll experience more seamless
    // duplicate call is only required when animation is enabled, meaning there is overflow of cards than the number of cards a row can fit
    // in which case, no autoscroll will take effect
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
        testId: testId,
        xcss: $508f24952640e58a$var$styles.container,
        space: "space.075"
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "cards-autoscroll-wrapper",
        className: (0, $hekY6.default)([
            "_1reo15vq _1e0c1txw _1wudtrqk",
            isPaused && "_10r1trqk"
        ])
    }, renderCardsGroup(), isAnimationEnabled && renderCardsGroup(), /*#__PURE__*/ $cozmU.createElement((0, $1LXnB.default), {
        setWidth: throttledSetWidth,
        offscreen: true
    })), isAnimationEnabled && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        alignInline: "start"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $508f24952640e58a$var$styles.iconPadding
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        space: "space.075",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $508f24952640e58a$var$styles.iconBackgroundStyles
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        shape: "circle",
        icon: isPaused ? (0, (/*@__PURE__*/$parcel$interopDefault($fZ6J4))) : (0, (/*@__PURE__*/$parcel$interopDefault($k5vii))),
        label: isPaused ? /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $c4a2c67793caa51b$export$defe85febe8b728c).play) : /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $c4a2c67793caa51b$export$defe85febe8b728c).pause),
        onClick: handlePauseClick
    })), showAIDisclaimer && /*#__PURE__*/ $cozmU.createElement((0, $32chb.CardsAIDisclaimer), null)))));
};








const $0f285ce5da73768c$export$efa81a508b70a345 = {
    [(0, $hjUDQ.Height).SMALL]: {
        minWidth: 221,
        maxWidth: 380,
        height: 72
    },
    [(0, $hjUDQ.Height).MEDIUM]: {
        minWidth: 240,
        maxWidth: 308,
        height: 312
    },
    [(0, $hjUDQ.Height).LARGE]: {
        minWidth: 358,
        maxWidth: 640,
        height: 312
    }
};
const $0f285ce5da73768c$export$f86a06fd1ecacb03 = {
    [(0, $hjUDQ.Height).SMALL]: {
        minWidth: 240,
        maxWidth: 294,
        height: 84
    },
    [(0, $hjUDQ.Height).MEDIUM]: {
        minWidth: 240,
        maxWidth: 294,
        height: 320
    },
    [(0, $hjUDQ.Height).LARGE]: {
        minWidth: 326,
        maxWidth: 392,
        height: 320
    }
};
const $0f285ce5da73768c$export$6909d5bfaed761e6 = {
    [(0, $hjUDQ.Height).SMALL]: {
        ...$0f285ce5da73768c$export$f86a06fd1ecacb03[(0, $hjUDQ.Height).SMALL]
    },
    [(0, $hjUDQ.Height).MEDIUM]: {
        minWidth: 240,
        maxWidth: 294,
        minHeight: 52,
        maxHeight: 348
    },
    [(0, $hjUDQ.Height).LARGE]: {
        minWidth: 326,
        maxWidth: 392,
        minHeight: 64,
        maxHeight: 424
    }
};


const $7ee74d072d6273e0$export$90cc9ab68d35b5b9 = ({ cardSize: cardSize, layout: layout })=>{
    if (layout === (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT) return (0, $0f285ce5da73768c$export$6909d5bfaed761e6)[cardSize];
    // Default to flexible dimensions (used for FLEXIBLE_IMAGE_HEIGHT and undefined layout)
    return (0, $0f285ce5da73768c$export$f86a06fd1ecacb03)[cardSize];
};



























var $cvDI4 = parcelRequire("cvDI4");

var $4buyQ = parcelRequire("4buyQ");

var $6gjqU = parcelRequire("6gjqU");

var $fEbt0 = parcelRequire("fEbt0");

var $keB0x = parcelRequire("keB0x");

var $4yYAm = parcelRequire("4yYAm");

var $es2gJ = parcelRequire("es2gJ");

var $7j5Rg = parcelRequire("7j5Rg");


var $QXwxo = parcelRequire("QXwxo");

















var $4aRua = parcelRequire("4aRua");


var $jWbXj = parcelRequire("jWbXj");

var $4yUlE = parcelRequire("4yUlE");




const $a585f263cb2be9f9$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    emptyStatePlaceholderLabel: {
        id: "company-hub.company-hub-common.ui.empty-state.label-placeholder",
        defaultMessage: "LABEL"
    }
});


const $d187d3f4498a1480$var$styles = {
    label: "_2rkofajl _u5f31b66 _19bv1b66"
};
const $d187d3f4498a1480$export$bc1a48e1b7ed7af = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { label: label, labelColor: labelColor } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage || $[1] !== label) {
        t1 = label || formatMessage((0, $a585f263cb2be9f9$export$defe85febe8b728c).emptyStatePlaceholderLabel);
        $[0] = formatMessage;
        $[1] = label;
        $[2] = t1;
    } else t1 = $[2];
    const labelFinal = t1;
    const labelColorFinal = labelColor ?? (0, $jWbXj.DEFAULT_GRAY_COLOR);
    const labelTextColorFinal = (0, $4yUlE.isReadable)(labelColorFinal, "var(--ds-text, #292A2E)") ? "color.text" : "color.text.inverse";
    let t2;
    if ($[3] !== labelColorFinal) {
        t2 = {
            backgroundColor: labelColorFinal
        };
        $[3] = labelColorFinal;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $d187d3f4498a1480$var$styles.label
        ]);
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== labelFinal) {
        t4 = labelFinal?.toUpperCase();
        $[6] = labelFinal;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== labelTextColorFinal || $[9] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
            color: labelTextColorFinal,
            size: "small",
            maxLines: 1,
            weight: "bold"
        }, t4);
        $[8] = labelTextColorFinal;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== t2 || $[12] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement("div", {
            style: t2,
            className: t3
        }, t5);
        $[11] = t2;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : ({ label: label, labelColor: labelColor })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const labelFinal = label || formatMessage((0, $a585f263cb2be9f9$export$defe85febe8b728c).emptyStatePlaceholderLabel);
    const labelColorFinal = labelColor ?? (0, $jWbXj.DEFAULT_GRAY_COLOR);
    const labelTextColorFinal = (0, $cozmU.useMemo)(()=>{
        return (0, $4yUlE.isReadable)(labelColorFinal, "var(--ds-text, #292A2E)") ? 'color.text' : 'color.text.inverse';
    }, [
        labelColorFinal
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            backgroundColor: labelColorFinal
        },
        className: (0, $hekY6.default)([
            $d187d3f4498a1480$var$styles.label
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        color: labelTextColorFinal,
        size: "small",
        maxLines: 1,
        weight: "bold"
    }, labelFinal?.toUpperCase()));
};

















var $9GVkD = parcelRequire("9GVkD");














var $iRKv3 = parcelRequire("iRKv3");


var $4sYZY = parcelRequire("4sYZY");

const $2e96401708fc6284$var$DARK_THRESHOLD = 50;
const $2e96401708fc6284$var$convertToHoveredShade = (hexColor)=>{
    const lightnessPercentage = (0, $iRKv3.getLightnessPercentage)(hexColor);
    if (lightnessPercentage === undefined) return hexColor;
    // Lighten dark colors; darken light colors slightly based on LCH lightness
    // 0 - 100 dark to light
    const LIGHTEN_TO = Math.min(100, Math.round(lightnessPercentage + 10));
    const DARKEN_TO = Math.max(0, Math.round(lightnessPercentage - 10));
    if (lightnessPercentage < $2e96401708fc6284$var$DARK_THRESHOLD) return (0, $iRKv3.increaseLightness)(hexColor, LIGHTEN_TO);
    return (0, $iRKv3.reduceLightness)(hexColor, DARKEN_TO);
};
const $2e96401708fc6284$export$8af9b0107e419002 = (backgroundColor)=>{
    const tokenizedHoveredBackgroundColor = (0, $4sYZY.getBackgroundHoveredColor)(backgroundColor);
    if (tokenizedHoveredBackgroundColor) return tokenizedHoveredBackgroundColor;
    const convertedColor = (0, $4yUlE.convertLegacyColor)(backgroundColor);
    if (convertedColor.isValid()) return $2e96401708fc6284$var$convertToHoveredShade(convertedColor.toHexString());
    return backgroundColor;
};


const $37e5cd8620e57bb3$export$1b6000962053a12c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (color)=>{
    const $ = (0, $bDgLe.c)(11);
    const [backgroundColor, setBackgroundColor] = (0, $cozmU.useState)();
    const [hoveredBackgroundColor, setHoveredBackgroundColor] = (0, $cozmU.useState)();
    const [shownBackgroundColor, setShownBackgroundColor] = (0, $cozmU.useState)();
    let t0;
    let t1;
    if ($[0] !== color) {
        t0 = ()=>{
            const hoveredBgColor = color ? (0, $2e96401708fc6284$export$8af9b0107e419002)(color) : undefined;
            setBackgroundColor(color);
            setShownBackgroundColor(color);
            setHoveredBackgroundColor(hoveredBgColor);
        };
        t1 = [
            color
        ];
        $[0] = color;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[3] !== hoveredBackgroundColor) {
        t2 = ()=>{
            setShownBackgroundColor(hoveredBackgroundColor);
        };
        $[3] = hoveredBackgroundColor;
        $[4] = t2;
    } else t2 = $[4];
    const handleHover = t2;
    let t3;
    if ($[5] !== backgroundColor) {
        t3 = ()=>{
            setShownBackgroundColor(backgroundColor);
        };
        $[5] = backgroundColor;
        $[6] = t3;
    } else t3 = $[6];
    const handleUnhover = t3;
    const t4 = shownBackgroundColor || backgroundColor;
    let t5;
    if ($[7] !== handleHover || $[8] !== handleUnhover || $[9] !== t4) {
        t5 = {
            backgroundColor: t4,
            handleHover: handleHover,
            handleUnhover: handleUnhover
        };
        $[7] = handleHover;
        $[8] = handleUnhover;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : (color)=>{
    const [backgroundColor, setBackgroundColor] = (0, $cozmU.useState)();
    const [hoveredBackgroundColor, setHoveredBackgroundColor] = (0, $cozmU.useState)();
    const [shownBackgroundColor, setShownBackgroundColor] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        const hoveredBgColor = color ? (0, $2e96401708fc6284$export$8af9b0107e419002)(color) : undefined;
        setBackgroundColor(color);
        setShownBackgroundColor(color);
        setHoveredBackgroundColor(hoveredBgColor);
    }, [
        color
    ]);
    const handleHover = (0, $cozmU.useCallback)(()=>{
        setShownBackgroundColor(hoveredBackgroundColor);
    }, [
        hoveredBackgroundColor
    ]);
    const handleUnhover = (0, $cozmU.useCallback)(()=>{
        setShownBackgroundColor(backgroundColor);
    }, [
        backgroundColor
    ]);
    return {
        backgroundColor: shownBackgroundColor || backgroundColor,
        handleHover: handleHover,
        handleUnhover: handleUnhover
    };
};


var $jIDse = parcelRequire("jIDse");


var $bIp5p = parcelRequire("bIp5p");


var $eafQX = parcelRequire("eafQX");








var $4WDWC = parcelRequire("4WDWC");




const $0589719409b932c8$var$message = (0, $kSwu1.defineMessages)({
    selectToEditAriaLabel: {
        id: "company-hub.company-hub-common.items-shared.item-container.button.edit.aria-label",
        defaultMessage: "Select card to edit"
    }
});
var $0589719409b932c8$export$2e2bcd8739ae039 = $0589719409b932c8$var$message;


const $a962904bbde7c9a2$var$unboundedStyles = {
    containerBase: "_1reo15vq _18m915vq _1dqonqa1 _189ee4h9 _1h6d1l7x _vchhusvi _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _4t3i1osq _syazi7uo _bfhk1bhr",
    containerCorner: "_2rko1mok",
    viewOnHover: "_irr36o2t _d0altlke",
    overlayButtonForSelectToEdit: "_19itglyw _kqswstnw _b35bglyw _bfhk1j28 _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _1pbykb7n",
    selectedToEdit: "_1a37dfik",
    selectedToRemove: "_1a3719ep _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _oounidpf _19woidpf _1g0vkb7n _154p105o _1rus1gly"
};
const $a962904bbde7c9a2$var$SelectToEditButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { cardId: cardId, extensionLocalId: extensionLocalId, onSelectStateUpdate: onSelectStateUpdate } = t0;
    const [t1, t2] = (0, $bIp5p.useExtensionsState)();
    const { selectedExtensionLocalId: selectedExtensionLocalId, selectedToEditCardId: selectedToEditCardId, selectedToRemoveCardId: selectedToRemoveCardId } = t1;
    const { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId } = t2;
    let t3;
    if ($[0] !== cardId || $[1] !== extensionLocalId || $[2] !== selectedExtensionLocalId || $[3] !== setIsInAutoFocusMode || $[4] !== setSelectedToEditCardId) {
        t3 = ()=>{
            if (cardId && extensionLocalId === selectedExtensionLocalId) {
                setIsInAutoFocusMode(true);
                setSelectedToEditCardId(cardId);
            }
        };
        $[0] = cardId;
        $[1] = extensionLocalId;
        $[2] = selectedExtensionLocalId;
        $[3] = setIsInAutoFocusMode;
        $[4] = setSelectedToEditCardId;
        $[5] = t3;
    } else t3 = $[5];
    const handleClick = t3;
    const isSelectedToEdit = selectedToEditCardId === cardId && extensionLocalId === selectedExtensionLocalId;
    const isSelectedToRemove = selectedToRemoveCardId === cardId && extensionLocalId === selectedExtensionLocalId;
    let t4;
    let t5;
    if ($[6] !== isSelectedToEdit || $[7] !== isSelectedToRemove || $[8] !== onSelectStateUpdate) {
        t4 = ()=>{
            onSelectStateUpdate?.({
                isSelectedToEdit: isSelectedToEdit,
                isSelectedToRemove: isSelectedToRemove
            });
        };
        t5 = [
            isSelectedToEdit,
            isSelectedToRemove,
            onSelectStateUpdate
        ];
        $[6] = isSelectedToEdit;
        $[7] = isSelectedToRemove;
        $[8] = onSelectStateUpdate;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            $a962904bbde7c9a2$var$unboundedStyles.overlayButtonForSelectToEdit
        ]);
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $0589719409b932c8$export$2e2bcd8739ae039).selectToEditAriaLabel));
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== handleClick) {
        t8 = /*#__PURE__*/ $cozmU.createElement("button", {
            onClick: handleClick,
            className: t6
        }, t7);
        $[13] = handleClick;
        $[14] = t8;
    } else t8 = $[14];
    return t8;
} : ({ cardId: cardId, extensionLocalId: extensionLocalId, onSelectStateUpdate: onSelectStateUpdate })=>{
    const [{ selectedExtensionLocalId: selectedExtensionLocalId, selectedToEditCardId: selectedToEditCardId, selectedToRemoveCardId: selectedToRemoveCardId }, { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId }] = (0, $bIp5p.useExtensionsState)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (cardId && extensionLocalId === selectedExtensionLocalId) {
            setIsInAutoFocusMode(true);
            setSelectedToEditCardId(cardId);
        }
    }, [
        cardId,
        extensionLocalId,
        selectedExtensionLocalId,
        setSelectedToEditCardId,
        setIsInAutoFocusMode
    ]);
    const isSelectedToEdit = selectedToEditCardId === cardId && extensionLocalId === selectedExtensionLocalId;
    const isSelectedToRemove = selectedToRemoveCardId === cardId && extensionLocalId === selectedExtensionLocalId;
    (0, $cozmU.useEffect)(()=>{
        onSelectStateUpdate?.({
            isSelectedToEdit: isSelectedToEdit,
            isSelectedToRemove: isSelectedToRemove
        });
    }, [
        isSelectedToEdit,
        isSelectedToRemove,
        onSelectStateUpdate
    ]); /*
                                                                   	Overlay an invisible button to allow click interaction on edit.
                                                                   	Also avoid violating A11y rules for making non-interactive element interactive by putting onClick on the container.
                                                                   */ 
    // eslint-disable-next-line @atlaskit/design-system/no-html-button
    return /*#__PURE__*/ $cozmU.createElement("button", {
        onClick: handleClick,
        className: (0, $hekY6.default)([
            $a962904bbde7c9a2$var$unboundedStyles.overlayButtonForSelectToEdit
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $0589719409b932c8$export$2e2bcd8739ae039).selectToEditAriaLabel)));
}; /**
    *
    * This component is used to wrap the card content and set the followings of the card
    * - border
    * - height (optional)
    * - background color
    * - hover effect ( for view)
    * - outline (for edit)
    * - color
    */ 
const $a962904bbde7c9a2$export$8a23e74e5cf3ca41 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(41);
    const { id: id, cardHeight: cardHeight, isInViewMode: isInViewMode, children: children, hasLink: hasLink, cardId: cardId, extensionLocalId: extensionLocalId, cornerStyle: cornerStyle, backgroundColor: savedBackgroundColor, textColor: savedTextColor, borderColor: borderColor, isEditable: isEditable, isHoverable: t1, enableHubCornerRadius: t2, cornerRadiusOverride: cornerRadiusOverride } = t0;
    const isHoverable = t1 === undefined ? true : t1;
    const enableHubCornerRadius = t2 === undefined ? false : t2;
    const isCardEditable = !isInViewMode && isEditable;
    const isCardHoverable = isInViewMode && hasLink && isHoverable;
    const [isSelectedToEdit, setIsSelectedToEdit] = (0, $cozmU.useState)(false);
    const [isSelectedToRemove, setIsSelectedToRemove] = (0, $cozmU.useState)(false);
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $cfM7x.useProductDependencies)();
    const { getDarkModeCompatibleTextColor: getDarkModeCompatibleTextColor, getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor } = (0, $jIDse.useDarkModeColors)(isSSRProductInDarkMode);
    let t3;
    if ($[0] !== getDarkModeCompatibleTextColor || $[1] !== savedTextColor) {
        t3 = savedTextColor ? getDarkModeCompatibleTextColor(savedTextColor) : undefined;
        $[0] = getDarkModeCompatibleTextColor;
        $[1] = savedTextColor;
        $[2] = t3;
    } else t3 = $[2];
    const textColor = t3;
    let t4;
    if ($[3] !== getDarkModeCompatibleBackgroundColor || $[4] !== savedBackgroundColor) {
        t4 = savedBackgroundColor ? getDarkModeCompatibleBackgroundColor(savedBackgroundColor) : undefined;
        $[3] = getDarkModeCompatibleBackgroundColor;
        $[4] = savedBackgroundColor;
        $[5] = t4;
    } else t4 = $[5];
    const backgroundColor = t4;
    const { backgroundColor: currentBackgroundColor, handleHover: handleHover, handleUnhover: handleUnhover } = (0, $37e5cd8620e57bb3$export$1b6000962053a12c)(backgroundColor);
    let t5;
    if ($[6] !== handleHover) {
        t5 = ()=>{
            handleHover();
        };
        $[6] = handleHover;
        $[7] = t5;
    } else t5 = $[7];
    const handleMouseEnter = t5;
    let t6;
    if ($[8] !== handleUnhover) {
        t6 = ()=>{
            handleUnhover();
        };
        $[8] = handleUnhover;
        $[9] = t6;
    } else t6 = $[9];
    const handleMouseLeave = t6;
    let t7;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (t8)=>{
            const { isSelectedToEdit: isSelectedToEdit_0, isSelectedToRemove: isSelectedToRemove_0 } = t8;
            setIsSelectedToEdit(isSelectedToEdit_0);
            setIsSelectedToRemove(isSelectedToRemove_0);
        };
        $[10] = t7;
    } else t7 = $[10];
    const handleSelectStateUpdate = t7;
    const hideCorner = cornerStyle === (0, $hjUDQ.CornerStyle).SQUARED;
    const isHubCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const useHubRadius = enableHubCornerRadius && isHubCornerRadiusEnabled;
    let t8;
    if ($[11] !== cornerRadiusOverride || $[12] !== useHubRadius) {
        t8 = useHubRadius ? {
            borderRadius: `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`,
            ...typeof cornerRadiusOverride === "number" ? {
                [(0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR)]: `${(0, $4WDWC.resolveHubCornerRadius)(cornerRadiusOverride)}px`
            } : {}
        } : {};
        $[11] = cornerRadiusOverride;
        $[12] = useHubRadius;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== borderColor || $[15] !== cardHeight || $[16] !== currentBackgroundColor || $[17] !== t8 || $[18] !== textColor) {
        t9 = {
            height: cardHeight,
            color: textColor,
            backgroundColor: currentBackgroundColor,
            borderColor: borderColor,
            ...t8
        };
        $[14] = borderColor;
        $[15] = cardHeight;
        $[16] = currentBackgroundColor;
        $[17] = t8;
        $[18] = textColor;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== handleMouseEnter || $[21] !== handleMouseLeave || $[22] !== isCardHoverable || $[23] !== savedBackgroundColor) {
        t10 = isCardHoverable && !!savedBackgroundColor ? {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave
        } : {};
        $[20] = handleMouseEnter;
        $[21] = handleMouseLeave;
        $[22] = isCardHoverable;
        $[23] = savedBackgroundColor;
        $[24] = t10;
    } else t10 = $[24];
    const t11 = !useHubRadius && !hideCorner && $a962904bbde7c9a2$var$unboundedStyles.containerCorner;
    const t12 = isCardHoverable && $a962904bbde7c9a2$var$unboundedStyles.viewOnHover;
    const t13 = isSelectedToEdit && $a962904bbde7c9a2$var$unboundedStyles.selectedToEdit;
    const t14 = isSelectedToRemove && $a962904bbde7c9a2$var$unboundedStyles.selectedToRemove;
    let t15;
    if ($[25] !== t11 || $[26] !== t12 || $[27] !== t13 || $[28] !== t14) {
        t15 = (0, $hekY6.default)([
            $a962904bbde7c9a2$var$unboundedStyles.containerBase,
            t11,
            t12,
            t13,
            t14
        ]);
        $[25] = t11;
        $[26] = t12;
        $[27] = t13;
        $[28] = t14;
        $[29] = t15;
    } else t15 = $[29];
    let t16;
    if ($[30] !== cardId || $[31] !== extensionLocalId || $[32] !== isCardEditable) {
        t16 = isCardEditable && /*#__PURE__*/ $cozmU.createElement($a962904bbde7c9a2$var$SelectToEditButton, {
            onSelectStateUpdate: handleSelectStateUpdate,
            cardId: cardId,
            extensionLocalId: extensionLocalId
        });
        $[30] = cardId;
        $[31] = extensionLocalId;
        $[32] = isCardEditable;
        $[33] = t16;
    } else t16 = $[33];
    let t17;
    if ($[34] !== children || $[35] !== id || $[36] !== t10 || $[37] !== t15 || $[38] !== t16 || $[39] !== t9) {
        t17 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": id,
            style: t9,
            ...t10,
            className: t15
        }, t16, children);
        $[34] = children;
        $[35] = id;
        $[36] = t10;
        $[37] = t15;
        $[38] = t16;
        $[39] = t9;
        $[40] = t17;
    } else t17 = $[40];
    return t17;
} : ({ id: id, cardHeight: cardHeight, isInViewMode: isInViewMode, children: children, hasLink: hasLink, cardId: cardId, extensionLocalId: extensionLocalId, cornerStyle: cornerStyle, backgroundColor: savedBackgroundColor, textColor: savedTextColor, borderColor: borderColor, isEditable: isEditable, isHoverable: isHoverable = true, enableHubCornerRadius: enableHubCornerRadius = false, cornerRadiusOverride: cornerRadiusOverride })=>{
    const isCardEditable = !isInViewMode && isEditable;
    const isCardHoverable = isInViewMode && hasLink && isHoverable;
    const [isSelectedToEdit, setIsSelectedToEdit] = (0, $cozmU.useState)(false);
    const [isSelectedToRemove, setIsSelectedToRemove] = (0, $cozmU.useState)(false); // handle theme responsiveness for text and background colors
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $cfM7x.useProductDependencies)();
    const { getDarkModeCompatibleTextColor: getDarkModeCompatibleTextColor, getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor } = (0, $jIDse.useDarkModeColors)(isSSRProductInDarkMode);
    const textColor = (0, $cozmU.useMemo)(()=>savedTextColor ? getDarkModeCompatibleTextColor(savedTextColor) : undefined, [
        savedTextColor,
        getDarkModeCompatibleTextColor
    ]);
    const backgroundColor = (0, $cozmU.useMemo)(()=>savedBackgroundColor ? getDarkModeCompatibleBackgroundColor(savedBackgroundColor) : undefined, [
        savedBackgroundColor,
        getDarkModeCompatibleBackgroundColor
    ]);
    const { backgroundColor: currentBackgroundColor, handleHover: handleHover, handleUnhover: handleUnhover } = (0, $37e5cd8620e57bb3$export$1b6000962053a12c)(backgroundColor);
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        handleHover();
    }, [
        handleHover
    ]);
    const handleMouseLeave = (0, $cozmU.useCallback)(()=>{
        handleUnhover();
    }, [
        handleUnhover
    ]); // handle select to edit
    const handleSelectStateUpdate = (0, $cozmU.useCallback)(({ isSelectedToEdit: isSelectedToEdit_0, isSelectedToRemove: isSelectedToRemove_0 })=>{
        setIsSelectedToEdit(isSelectedToEdit_0);
        setIsSelectedToRemove(isSelectedToRemove_0);
    }, [
        setIsSelectedToEdit,
        setIsSelectedToRemove
    ]);
    const hideCorner = cornerStyle === (0, $hjUDQ.CornerStyle).SQUARED;
    const isHubCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const useHubRadius = enableHubCornerRadius && isHubCornerRadiusEnabled;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": id,
        style: {
            height: cardHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: textColor,
            backgroundColor: currentBackgroundColor,
            borderColor: borderColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            ...useHubRadius ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                borderRadius: `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`,
                ...typeof cornerRadiusOverride === 'number' ? {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    [(0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR)]: `${(0, $4WDWC.resolveHubCornerRadius)(cornerRadiusOverride)}px`
                } : {}
            } : {}
        },
        ...isCardHoverable && !!savedBackgroundColor ? {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave
        } : {},
        className: (0, $hekY6.default)([
            $a962904bbde7c9a2$var$unboundedStyles.containerBase,
            !useHubRadius && !hideCorner && $a962904bbde7c9a2$var$unboundedStyles.containerCorner,
            isCardHoverable && $a962904bbde7c9a2$var$unboundedStyles.viewOnHover,
            isSelectedToEdit && $a962904bbde7c9a2$var$unboundedStyles.selectedToEdit,
            isSelectedToRemove && $a962904bbde7c9a2$var$unboundedStyles.selectedToRemove
        ])
    }, isCardEditable && /*#__PURE__*/ $cozmU.createElement($a962904bbde7c9a2$var$SelectToEditButton, {
        onSelectStateUpdate: handleSelectStateUpdate,
        cardId: cardId,
        extensionLocalId: extensionLocalId
    }), children);
};




var $9QaSD = parcelRequire("9QaSD");





var $iMYjN = parcelRequire("iMYjN");

var $dhLnb = parcelRequire("dhLnb");








var $3s2S5 = parcelRequire("3s2S5");

const $37d9cdf0819e0905$var$hasValidUrl = (s)=>!!s && s.trim() !== '';
const $37d9cdf0819e0905$export$71956575015d1f5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (link, imageData)=>{
    const loomThumbnailUrl = (0, $3s2S5.useLoomThumbnailUrl)(link, imageData);
    const hasResolved = $37d9cdf0819e0905$var$hasValidUrl(loomThumbnailUrl);
    const hasStored = $37d9cdf0819e0905$var$hasValidUrl(imageData);
    if (hasResolved || hasStored) return loomThumbnailUrl ?? imageData ?? "";
    return "";
} : (link, imageData)=>{
    const loomThumbnailUrl = (0, $3s2S5.useLoomThumbnailUrl)(link, imageData);
    const hasResolved = $37d9cdf0819e0905$var$hasValidUrl(loomThumbnailUrl);
    const hasStored = $37d9cdf0819e0905$var$hasValidUrl(imageData);
    if (hasResolved || hasStored) return loomThumbnailUrl ?? imageData ?? '';
    return '';
};











const $56bdef66f01f9e9c$export$28a088c1679c6579 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { isOwnerInfoShown: isOwnerInfoShown, isModifiedOnShown: isModifiedOnShown, isSocialStatsShown: isSocialStatsShown } = t0;
    const [isAvatarAvailable, setIsAvatarAvailable] = (0, $cozmU.useState)();
    const [isOwnerNameAvailable, setIsOwnerNameAvailable] = (0, $cozmU.useState)();
    const [isModifiedOnAvailable, setIsModifiedOnAvailable] = (0, $cozmU.useState)();
    const [isCommentCountAvailable, setIsCommentCountAvailable] = (0, $cozmU.useState)();
    const [isReactCountAvailable, setIsReactCountAvailable] = (0, $cozmU.useState)();
    let t1;
    let t2;
    if ($[0] !== isModifiedOnShown || $[1] !== isOwnerInfoShown || $[2] !== isSocialStatsShown) {
        t1 = ()=>{
            setIsAvatarAvailable(!!isOwnerInfoShown);
            setIsOwnerNameAvailable(!!isOwnerInfoShown);
            setIsModifiedOnAvailable(!!isModifiedOnShown);
            setIsCommentCountAvailable(!!isSocialStatsShown);
            setIsReactCountAvailable(!!isSocialStatsShown);
        };
        t2 = [
            isOwnerInfoShown,
            isModifiedOnShown,
            isSocialStatsShown
        ];
        $[0] = isModifiedOnShown;
        $[1] = isOwnerInfoShown;
        $[2] = isSocialStatsShown;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    const shouldRenderOwnerInfo = isAvatarAvailable || isOwnerNameAvailable;
    const shouldRenderMetadata = shouldRenderOwnerInfo || isModifiedOnAvailable;
    const shouldRenderSocials = isReactCountAvailable || isCommentCountAvailable;
    let t3;
    if ($[5] !== shouldRenderMetadata || $[6] !== shouldRenderOwnerInfo || $[7] !== shouldRenderSocials) {
        t3 = {
            setIsAvatarAvailable: setIsAvatarAvailable,
            setIsOwnerNameAvailable: setIsOwnerNameAvailable,
            setIsModifiedOnAvailable: setIsModifiedOnAvailable,
            setIsReactCountAvailable: setIsReactCountAvailable,
            setIsCommentCountAvailable: setIsCommentCountAvailable,
            shouldRenderOwnerInfo: shouldRenderOwnerInfo,
            shouldRenderMetadata: shouldRenderMetadata,
            shouldRenderSocials: shouldRenderSocials
        };
        $[5] = shouldRenderMetadata;
        $[6] = shouldRenderOwnerInfo;
        $[7] = shouldRenderSocials;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ isOwnerInfoShown: isOwnerInfoShown, isModifiedOnShown: isModifiedOnShown, isSocialStatsShown: isSocialStatsShown })=>{
    // smart card elements render states
    const [isAvatarAvailable, setIsAvatarAvailable] = (0, $cozmU.useState)();
    const [isOwnerNameAvailable, setIsOwnerNameAvailable] = (0, $cozmU.useState)();
    const [isModifiedOnAvailable, setIsModifiedOnAvailable] = (0, $cozmU.useState)();
    const [isCommentCountAvailable, setIsCommentCountAvailable] = (0, $cozmU.useState)();
    const [isReactCountAvailable, setIsReactCountAvailable] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        // attempt to render the elements when they are supposed to be shown to get data availability
        setIsAvatarAvailable(!!isOwnerInfoShown);
        setIsOwnerNameAvailable(!!isOwnerInfoShown);
        setIsModifiedOnAvailable(!!isModifiedOnShown);
        setIsCommentCountAvailable(!!isSocialStatsShown);
        setIsReactCountAvailable(!!isSocialStatsShown);
    }, [
        isOwnerInfoShown,
        isModifiedOnShown,
        isSocialStatsShown
    ]);
    const shouldRenderOwnerInfo = (0, $cozmU.useMemo)(()=>isAvatarAvailable || isOwnerNameAvailable, [
        isAvatarAvailable,
        isOwnerNameAvailable
    ]);
    const shouldRenderMetadata = (0, $cozmU.useMemo)(()=>shouldRenderOwnerInfo || isModifiedOnAvailable, [
        shouldRenderOwnerInfo,
        isModifiedOnAvailable
    ]);
    const shouldRenderSocials = (0, $cozmU.useMemo)(()=>isReactCountAvailable || isCommentCountAvailable, [
        isReactCountAvailable,
        isCommentCountAvailable
    ]);
    return {
        setIsAvatarAvailable: setIsAvatarAvailable,
        setIsOwnerNameAvailable: setIsOwnerNameAvailable,
        setIsModifiedOnAvailable: setIsModifiedOnAvailable,
        setIsReactCountAvailable: setIsReactCountAvailable,
        setIsCommentCountAvailable: setIsCommentCountAvailable,
        shouldRenderOwnerInfo: shouldRenderOwnerInfo,
        shouldRenderMetadata: shouldRenderMetadata,
        shouldRenderSocials: shouldRenderSocials
    };
};












var $epZ7a = parcelRequire("epZ7a");














var $4wH3g = parcelRequire("4wH3g");


var $iLpJO = parcelRequire("iLpJO");


const $617759dfffa61af2$export$836160481278e63f = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "vUDoI",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("inIhs"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ $cozmU.createElement((0, $iLpJO.EmojiPlaceholder), props) : null
});
const $617759dfffa61af2$var$styles = {
    wrapper: "_1e0c1txw _1bah1h6o"
};
const $617759dfffa61af2$export$56e4c85b6a8d02e6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { emojiId: emojiId, height: t1, width: t2 } = t0;
    const height = t1 === undefined ? 40 : t1;
    const width = t2 === undefined ? 40 : t2;
    let t3;
    if ($[0] !== width) {
        t3 = (props)=>/*#__PURE__*/ $cozmU.createElement("div", {
                style: {
                    maxWidth: `${width}px`
                },
                ...props,
                className: (0, $hekY6.default)([
                    $617759dfffa61af2$var$styles.wrapper
                ])
            });
        $[0] = width;
        $[1] = t3;
    } else t3 = $[1];
    const wrapper = t3;
    if (!emojiId) return null;
    let t4;
    if ($[2] !== emojiId || $[3] !== height || $[4] !== wrapper) {
        t4 = /*#__PURE__*/ $cozmU.createElement($617759dfffa61af2$export$836160481278e63f, {
            emoji: emojiId,
            height: height,
            wrapper: wrapper,
            renderResourcedEmoji: true
        });
        $[2] = emojiId;
        $[3] = height;
        $[4] = wrapper;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : ({ emojiId: emojiId, height: height = 40, width: width = 40 })=>{
    const wrapper = (0, $cozmU.useMemo)(()=>(props)=>/*#__PURE__*/ $cozmU.createElement("div", {
                style: {
                    maxWidth: `${width}px`
                },
                ...props,
                className: (0, $hekY6.default)([
                    $617759dfffa61af2$var$styles.wrapper
                ])
            }), [
        width
    ]);
    if (!emojiId) return null;
    return /*#__PURE__*/ $cozmU.createElement($617759dfffa61af2$export$836160481278e63f, {
        emoji: emojiId,
        height: height,
        wrapper: wrapper,
        renderResourcedEmoji: true
    });
};





var $4yccB = parcelRequire("4yccB");




const $f6e7599786666e93$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $f6e7599786666e93$export$6ed6867e3290476 = (link)=>{
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    const [emojiId, setEmojiId] = (0, $cozmU.useState)();
    const getEmoji = (0, $cozmU.useCallback)(async ()=>{
        const client = new (0, $4yccB.default)();
        try {
            const queriedEmojiObject = await client.fetchData(link);
            setEmojiId($f6e7599786666e93$var$sanitizeEmojiValue(queriedEmojiObject.data['atlassian:titlePrefix']?.text));
        } catch (error) {
            submitError?.(error);
        }
    }, [
        link,
        submitError
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!!link) getEmoji();
    }, [
        link,
        getEmoji
    ]);
    return {
        emojiId: !!emojiId ? emojiId : null
    };
};


const $7f30d41a2009de7e$export$69387b41dfc808f7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { link: link } = t0;
    const { emojiId: emojiId } = (0, $f6e7599786666e93$export$6ed6867e3290476)(link);
    let t1;
    if ($[0] !== emojiId) {
        t1 = emojiId ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $617759dfffa61af2$export$56e4c85b6a8d02e6), {
                emojiId: emojiId,
                height: 24,
                width: 24
            }) : undefined;
        $[0] = emojiId;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $epZ7a.LinkIconElement), {
            iconTileSize: 24,
            render: t1
        });
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ link: link })=>{
    const { emojiId: emojiId } = (0, $f6e7599786666e93$export$6ed6867e3290476)(link);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $epZ7a.LinkIconElement), {
        iconTileSize: 24,
        render: emojiId ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $617759dfffa61af2$export$56e4c85b6a8d02e6), {
                emojiId: emojiId,
                height: 24,
                width: 24
            }) : undefined
    });
};














var $68e47287a83f3aa2$export$6eeb615c261d1c6b = /*#__PURE__*/ function(FontVariant) {
    FontVariant["HeadingMedium"] = "headingMedium";
    FontVariant["HeadingSmall"] = "headingSmall";
    FontVariant["HeadingXSmall"] = "headingXSmall";
    FontVariant["Body"] = "body";
    FontVariant["BodyLarge"] = "bodyLarge";
    return FontVariant;
}({});
const $68e47287a83f3aa2$var$unboundedStyles = {
    baseText: "_1reo15vq _18m915vq _1bto1l2s _1e0ccj1k _sudp1e54 _1yyj11wp",
    title: "_1bsb1osq",
    description: "_o5724jg8",
    headingMedium: "_11c81af2",
    headingSmall: "_11c81e3o",
    headingXSmall: "_11c81qyo",
    bodyLarge: "_11c81d4k",
    body: "_11c8fhey"
};
const $68e47287a83f3aa2$export$474db65c3c394e1c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, maxLine: maxLine, fontVariant: fontVariant } = t0;
    let t1;
    if ($[0] !== maxLine) {
        t1 = {
            WebkitLineClamp: maxLine
        };
        $[0] = maxLine;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = $68e47287a83f3aa2$var$unboundedStyles[fontVariant];
    let t3;
    if ($[2] !== t2) {
        t3 = (0, $hekY6.default)([
            $68e47287a83f3aa2$var$unboundedStyles.baseText,
            $68e47287a83f3aa2$var$unboundedStyles.title,
            t2
        ]);
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== children || $[5] !== t1 || $[6] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement("span", {
            style: t1,
            className: t3
        }, children);
        $[4] = children;
        $[5] = t1;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ children: children, maxLine: maxLine, fontVariant: fontVariant })=>/*#__PURE__*/ $cozmU.createElement("span", {
        style: {
            WebkitLineClamp: maxLine
        },
        className: (0, $hekY6.default)([
            $68e47287a83f3aa2$var$unboundedStyles.baseText,
            $68e47287a83f3aa2$var$unboundedStyles.title,
            $68e47287a83f3aa2$var$unboundedStyles[fontVariant]
        ])
    }, children);
const $68e47287a83f3aa2$export$16e0ed4cb97c00d4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, maxLine: maxLine, fontVariant: fontVariant } = t0;
    let t1;
    if ($[0] !== maxLine) {
        t1 = {
            WebkitLineClamp: maxLine
        };
        $[0] = maxLine;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = $68e47287a83f3aa2$var$unboundedStyles[fontVariant];
    let t3;
    if ($[2] !== t2) {
        t3 = (0, $hekY6.default)([
            $68e47287a83f3aa2$var$unboundedStyles.baseText,
            $68e47287a83f3aa2$var$unboundedStyles.description,
            t2
        ]);
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== children || $[5] !== t1 || $[6] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement("span", {
            style: t1,
            className: t3
        }, children);
        $[4] = children;
        $[5] = t1;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ children: children, maxLine: maxLine, fontVariant: fontVariant })=>/*#__PURE__*/ $cozmU.createElement("span", {
        style: {
            WebkitLineClamp: maxLine
        },
        className: (0, $hekY6.default)([
            $68e47287a83f3aa2$var$unboundedStyles.baseText,
            $68e47287a83f3aa2$var$unboundedStyles.description,
            $68e47287a83f3aa2$var$unboundedStyles[fontVariant]
        ])
    }, children);





const $0295777f01fea73a$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.card-extensions.large-card.large-card-v2.empty-state.title-placeholder",
        defaultMessage: "Give your card a title"
    }
});


const $166f78176fd22bef$var$unboundedStyles = {
    avatar: "_c71l1tcg _19pk1lpd _1lplidpf _px5oidpf _m5lyidpf _1oxkidpf _18alidpf _1mxvidpf _suiuidpf _1bc3idpf _tvjiidpf _1y56idpf _rjv6idpf _mbyhidpf",
    snippetOverride: "_syaz1kw7 _5fky1d4k _mavj1kw7",
    smartCardWrapper: "_4t3i1osq _wht71osq"
};
const $166f78176fd22bef$var$styles = {
    content: "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _4t3i1osq _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    imageCorner: "_2rko1mok",
    imageWithPadding: "_1reo15vq _18m915vq _4t3imgvx",
    imageNoPadding: "_1reo15vq _18m915vq _4t3iuuw1 _19pkmgjw _2hwxmgjw _18u0mgjw _n3td1b66",
    headerWithImagePadding: "_ca0qu2gc _19bvu2gc",
    headerWithImage: "_1e0c1txw _kqswstnw _154ipxbi _1ltvpxbi",
    unresolvedAction: "_1reo15vq _18m915vq _11c81d4k _1bsb1osq _1bto1l2s _syazazsu",
    static: "_kqswpfqs",
    relative: "_kqswh2mm"
};
const $166f78176fd22bef$var$MIN_TITLE_LINES = 3;
const $166f78176fd22bef$var$MAX_TITLE_LINES = 5;
const $166f78176fd22bef$var$MIN_DESCRIPTION_LINES = 3;
const $166f78176fd22bef$var$MAX_DESCRIPTION_LINES = 6;
const $166f78176fd22bef$var$getTitleDescriptionMaxLine = ({ hasImage: hasImage })=>{
    let titleMaxLine = $166f78176fd22bef$var$MIN_TITLE_LINES;
    let descriptionMaxLine = $166f78176fd22bef$var$MIN_DESCRIPTION_LINES;
    if (!hasImage) {
        titleMaxLine += 2;
        descriptionMaxLine += 3;
    }
    if (titleMaxLine > $166f78176fd22bef$var$MAX_TITLE_LINES) titleMaxLine = $166f78176fd22bef$var$MAX_TITLE_LINES;
    if (descriptionMaxLine > $166f78176fd22bef$var$MAX_DESCRIPTION_LINES) descriptionMaxLine = $166f78176fd22bef$var$MAX_DESCRIPTION_LINES;
    return {
        titleMaxLine: titleMaxLine,
        descriptionMaxLine: descriptionMaxLine
    };
};
const $166f78176fd22bef$export$a59c193ce67944a7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(63);
    const { cardDimensions: cardDimensions, cardId: cardId, link: link, isInViewMode: isInViewMode, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, imageSrc: imageSrc, imageAltText: imageAltText, contentId: contentId, title: title, description: description, label: label, isLabelHidden: isLabelHidden, labelColor: labelColor, isLabelShown: isLabelShown, isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, borderColor: borderColor, cornerStyle: cornerStyle, cornerRadius: cornerRadius, enableSnippetRenderer: enableSnippetRenderer, showDescription: showDescription } = t0;
    const hasLink = !!link;
    const hideCorner = cornerStyle === (0, $hjUDQ.CornerStyle).SQUARED;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    let t1;
    if ($[0] !== cornerRadius || $[1] !== cornerStyle || $[2] !== isCornerRadiusEnabled) {
        t1 = isCornerRadiusEnabled ? (0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) : undefined;
        $[0] = cornerRadius;
        $[1] = cornerStyle;
        $[2] = isCornerRadiusEnabled;
        $[3] = t1;
    } else t1 = $[3];
    const cornerRadiusOverride = t1;
    const cardMinHeight = cardDimensions.minHeight;
    const cardMaxHeight = cardDimensions.maxHeight;
    const t2 = isAvatarShown && hasLink;
    const t3 = isPublishDateShown && hasLink;
    const t4 = isSocialStatsShown && hasLink;
    let t5;
    if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
        t5 = {
            isOwnerInfoShown: t2,
            isModifiedOnShown: t3,
            isSocialStatsShown: t4
        };
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsOwnerNameAvailable: setIsOwnerNameAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderOwnerInfo: shouldRenderOwnerInfo, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials } = (0, $56bdef66f01f9e9c$export$28a088c1679c6579)(t5);
    const displayImageSrc = (0, $37d9cdf0819e0905$export$71956575015d1f5)(link, imageSrc);
    const { hasImage: hasImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $9QaSD.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $166f78176fd22bef$var$getTitleDescriptionMaxLine({
        hasImage: hasImage
    });
    const cardBodyItems = hasLink ? [
        title && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingMedium
        }, title),
        hasError && !title && !description && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            key: "unresolved-action",
            xcss: $166f78176fd22bef$var$styles.unresolvedAction
        }, /*#__PURE__*/ $cozmU.createElement((0, $7j5Rg.UnresolvedAction), null)),
        showDescription && enableSnippetRenderer && /*#__PURE__*/ $cozmU.createElement("div", {
            key: "snippet",
            className: (0, $hekY6.default)([
                $166f78176fd22bef$var$unboundedStyles.snippetOverride
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $es2gJ.default), {
            showFooter: false,
            maxLines: descriptionMaxLine,
            text: description
        })),
        showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).BodyLarge
        }, description)
    ].filter(Boolean) : [
        /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingMedium
        }, title || formatMessage((0, $0295777f01fea73a$export$defe85febe8b728c).emptyStatePlaceholderTitle)),
        description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).BodyLarge
        }, description)
    ].filter(Boolean);
    const T0 = (0, $iMnC5.default);
    const t6 = "large-card-v2-content";
    const t7 = hasLink ? $166f78176fd22bef$var$styles.static : $166f78176fd22bef$var$styles.relative;
    let t8;
    if ($[8] !== t7) {
        t8 = (0, $w6R6I.cx)($166f78176fd22bef$var$styles.content, t7);
        $[8] = t7;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== cardMaxHeight || $[11] !== cardMinHeight) {
        t9 = {
            minHeight: cardMinHeight,
            maxHeight: cardMaxHeight
        };
        $[10] = cardMaxHeight;
        $[11] = cardMinHeight;
        $[12] = t9;
    } else t9 = $[12];
    const T1 = (0, $dinVW.default);
    const t10 = "space-between";
    const t11 = "space.200";
    const t12 = "fill";
    const T2 = (0, $dinVW.default);
    const t13 = "space.200";
    const t14 = hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        testId: "large-card-v2-image",
        xcss: (0, $w6R6I.cx)(isPaddingEnabled ? $166f78176fd22bef$var$styles.imageWithPadding : $166f78176fd22bef$var$styles.imageNoPadding, !isCornerRadiusEnabled && !hideCorner && isPaddingEnabled && $166f78176fd22bef$var$styles.imageCorner),
        style: isCornerRadiusEnabled ? {
            borderRadius: isPaddingEnabled ? `calc(var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})/2)` : `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`
        } : undefined
    }, /*#__PURE__*/ $cozmU.createElement((0, $dhLnb.ImageRenderer), {
        contentId: contentId,
        imageSrc: displayImageSrc,
        imageAlt: imageAltText,
        shouldShowExternalSiteImage: hasLink
    }));
    const t15 = (isIconShown && hasLink || isLabelShown && !isLabelHidden) && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: (0, $w6R6I.cx)(hasImage && $166f78176fd22bef$var$styles.headerWithImage, hasImage && isPaddingEnabled && $166f78176fd22bef$var$styles.headerWithImagePadding)
    }, isIconShown && hasLink && /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
        link: link
    }), isLabelShown && !isLabelHidden && /*#__PURE__*/ $cozmU.createElement((0, $d187d3f4498a1480$export$bc1a48e1b7ed7af), {
        label: label,
        labelColor: labelColor
    }));
    let t16;
    if ($[13] !== cardBodyItems) {
        t16 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
            testId: "large-card-body",
            space: "space.100"
        }, cardBodyItems);
        $[13] = cardBodyItems;
        $[14] = t16;
    } else t16 = $[14];
    let t17;
    if ($[15] !== T2 || $[16] !== t14 || $[17] !== t15 || $[18] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement(T2, {
            space: t13
        }, t14, t15, t16);
        $[15] = T2;
        $[16] = t14;
        $[17] = t15;
        $[18] = t16;
        $[19] = t17;
    } else t17 = $[19];
    let t18;
    if ($[20] !== hasError || $[21] !== hasLink || $[22] !== isPublishDateShown || $[23] !== isResolved || $[24] !== setIsAvatarAvailable || $[25] !== setIsCommentCountAvailable || $[26] !== setIsModifiedOnAvailable || $[27] !== setIsOwnerNameAvailable || $[28] !== setIsReactCountAvailable || $[29] !== shouldRenderMetadata || $[30] !== shouldRenderOwnerInfo || $[31] !== shouldRenderSocials) {
        t18 = hasLink && !hasError && isResolved && (shouldRenderMetadata || shouldRenderSocials) && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            alignBlock: "center",
            spread: "space-between"
        }, shouldRenderMetadata && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            space: "space.050",
            separator: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), null, "\u2022"),
            alignBlock: "center"
        }, shouldRenderOwnerInfo && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $166f78176fd22bef$var$unboundedStyles.avatar
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $fEbt0.OwnedByGroupElement), {
            onRender: setIsAvatarAvailable
        })), /*#__PURE__*/ $cozmU.createElement((0, $6gjqU.OwnedByElement), {
            color: "inherit",
            hideFormat: true,
            onRender: setIsOwnerNameAvailable
        })), !!isPublishDateShown && /*#__PURE__*/ $cozmU.createElement((0, $4buyQ.ModifiedOnElement), {
            color: "inherit",
            hideDatePrefix: true,
            onRender: setIsModifiedOnAvailable
        })), shouldRenderSocials && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            space: "space.150"
        }, /*#__PURE__*/ $cozmU.createElement((0, $keB0x.ReactCountElement), {
            color: "inherit",
            onRender: setIsReactCountAvailable
        }), /*#__PURE__*/ $cozmU.createElement((0, $cvDI4.CommentCountElement), {
            color: "inherit",
            onRender: setIsCommentCountAvailable
        })));
        $[20] = hasError;
        $[21] = hasLink;
        $[22] = isPublishDateShown;
        $[23] = isResolved;
        $[24] = setIsAvatarAvailable;
        $[25] = setIsCommentCountAvailable;
        $[26] = setIsModifiedOnAvailable;
        $[27] = setIsOwnerNameAvailable;
        $[28] = setIsReactCountAvailable;
        $[29] = shouldRenderMetadata;
        $[30] = shouldRenderOwnerInfo;
        $[31] = shouldRenderSocials;
        $[32] = t18;
    } else t18 = $[32];
    let t19;
    if ($[33] !== T1 || $[34] !== t17 || $[35] !== t18) {
        t19 = /*#__PURE__*/ $cozmU.createElement(T1, {
            spread: t10,
            space: t11,
            grow: t12
        }, t17, t18);
        $[33] = T1;
        $[34] = t17;
        $[35] = t18;
        $[36] = t19;
    } else t19 = $[36];
    let t20;
    if ($[37] !== T0 || $[38] !== t19 || $[39] !== t8 || $[40] !== t9) {
        t20 = /*#__PURE__*/ $cozmU.createElement(T0, {
            testId: t6,
            xcss: t8,
            style: t9
        }, t19);
        $[37] = T0;
        $[38] = t19;
        $[39] = t8;
        $[40] = t9;
        $[41] = t20;
    } else t20 = $[41];
    const cardContent = t20;
    let t21;
    if ($[42] !== cardContent || $[43] !== cardId || $[44] !== enableSnippetRenderer || $[45] !== hasLink || $[46] !== isInViewMode || $[47] !== link || $[48] !== trackAndCategorizeError || $[49] !== trackSuccess) {
        t21 = hasLink ? /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $166f78176fd22bef$var$unboundedStyles.smartCardWrapper
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $QXwxo.CardSSR), {
            id: cardId,
            appearance: "inline",
            frameStyle: "show",
            ui: {
                theme: (0, $4yYAm.SmartLinkTheme).Black,
                clickableContainer: isInViewMode,
                size: (0, $4yYAm.SmartLinkSize).Large,
                removeBlockRestriction: true,
                hideBackground: true,
                hideElevation: true,
                hidePadding: true,
                enableSnippetRenderer: enableSnippetRenderer
            },
            url: link,
            onResolve: trackSuccess,
            onError: trackAndCategorizeError
        }, cardContent)) : cardContent;
        $[42] = cardContent;
        $[43] = cardId;
        $[44] = enableSnippetRenderer;
        $[45] = hasLink;
        $[46] = isInViewMode;
        $[47] = link;
        $[48] = trackAndCategorizeError;
        $[49] = trackSuccess;
        $[50] = t21;
    } else t21 = $[50];
    let t22;
    if ($[51] !== backgroundColor || $[52] !== borderColor || $[53] !== cardId || $[54] !== cornerRadiusOverride || $[55] !== cornerStyle || $[56] !== extensionLocalId || $[57] !== hasLink || $[58] !== isInViewMode || $[59] !== isManualVariant || $[60] !== t21 || $[61] !== textColor) {
        t22 = /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
            id: "large-card-v2-container",
            isInViewMode: isInViewMode,
            cardId: cardId,
            extensionLocalId: extensionLocalId,
            isEditable: isManualVariant,
            cornerStyle: cornerStyle,
            hasLink: hasLink,
            backgroundColor: backgroundColor,
            textColor: textColor,
            borderColor: borderColor,
            enableHubCornerRadius: true,
            cornerRadiusOverride: cornerRadiusOverride
        }, t21);
        $[51] = backgroundColor;
        $[52] = borderColor;
        $[53] = cardId;
        $[54] = cornerRadiusOverride;
        $[55] = cornerStyle;
        $[56] = extensionLocalId;
        $[57] = hasLink;
        $[58] = isInViewMode;
        $[59] = isManualVariant;
        $[60] = t21;
        $[61] = textColor;
        $[62] = t22;
    } else t22 = $[62];
    return t22;
} : ({ cardDimensions: cardDimensions, cardId: cardId, link: link, isInViewMode: isInViewMode, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, imageSrc: imageSrc, imageAltText: imageAltText, contentId: contentId, title: title, description: description, label: label, isLabelHidden: isLabelHidden, labelColor: labelColor, isLabelShown: isLabelShown, isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, borderColor: borderColor, cornerStyle: cornerStyle, cornerRadius: cornerRadius, enableSnippetRenderer: enableSnippetRenderer, showDescription: showDescription })=>{
    const hasLink = !!link;
    const hideCorner = cornerStyle === (0, $hjUDQ.CornerStyle).SQUARED;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const cornerRadiusOverride = isCornerRadiusEnabled ? (0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) : undefined;
    const cardMinHeight = cardDimensions.minHeight;
    const cardMaxHeight = cardDimensions.maxHeight;
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsOwnerNameAvailable: setIsOwnerNameAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderOwnerInfo: shouldRenderOwnerInfo, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials } = (0, $56bdef66f01f9e9c$export$28a088c1679c6579)({
        isOwnerInfoShown: isAvatarShown && hasLink,
        isModifiedOnShown: isPublishDateShown && hasLink,
        isSocialStatsShown: isSocialStatsShown && hasLink
    });
    const displayImageSrc = (0, $37d9cdf0819e0905$export$71956575015d1f5)(link, imageSrc);
    const { hasImage: hasImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $9QaSD.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $166f78176fd22bef$var$getTitleDescriptionMaxLine({
        hasImage: hasImage
    });
    const cardBodyItems = hasLink ? [
        // Title
        title && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingMedium
        }, title),
        // Unresolved action
        hasError && !title && !description && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            key: "unresolved-action",
            xcss: $166f78176fd22bef$var$styles.unresolvedAction
        }, /*#__PURE__*/ $cozmU.createElement((0, $7j5Rg.UnresolvedAction), null)),
        // Description
        // AI snippet
        showDescription && enableSnippetRenderer && /*#__PURE__*/ $cozmU.createElement("div", {
            key: "snippet",
            className: (0, $hekY6.default)([
                $166f78176fd22bef$var$unboundedStyles.snippetOverride
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $es2gJ.default), {
            showFooter: false,
            maxLines: descriptionMaxLine,
            text: description
        })),
        // normal description
        showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).BodyLarge
        }, description)
    ].filter(Boolean) : [
        // Title or placeholder
        /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingMedium
        }, title || formatMessage((0, $0295777f01fea73a$export$defe85febe8b728c).emptyStatePlaceholderTitle)),
        // Description
        description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).BodyLarge
        }, description)
    ].filter(Boolean);
    const cardContent = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        testId: "large-card-v2-content",
        xcss: (0, $w6R6I.cx)($166f78176fd22bef$var$styles.content, hasLink ? $166f78176fd22bef$var$styles.static : $166f78176fd22bef$var$styles.relative),
        style: {
            minHeight: cardMinHeight,
            maxHeight: cardMaxHeight
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
        spread: "space-between",
        space: "space.200",
        grow: "fill"
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
        space: "space.200"
    }, hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        testId: "large-card-v2-image",
        xcss: (0, $w6R6I.cx)(isPaddingEnabled ? $166f78176fd22bef$var$styles.imageWithPadding : $166f78176fd22bef$var$styles.imageNoPadding, !isCornerRadiusEnabled && !hideCorner && isPaddingEnabled && $166f78176fd22bef$var$styles.imageCorner),
        style: isCornerRadiusEnabled ? {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            borderRadius: isPaddingEnabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            `calc(var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})/2)` : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`
        } : undefined
    }, /*#__PURE__*/ $cozmU.createElement((0, $dhLnb.ImageRenderer), {
        contentId: contentId,
        imageSrc: displayImageSrc,
        imageAlt: imageAltText,
        shouldShowExternalSiteImage: hasLink
    })), (isIconShown && hasLink || isLabelShown && !isLabelHidden) && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: (0, $w6R6I.cx)(hasImage && $166f78176fd22bef$var$styles.headerWithImage, hasImage && isPaddingEnabled && $166f78176fd22bef$var$styles.headerWithImagePadding)
    }, isIconShown && hasLink && /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
        link: link
    }), isLabelShown && !isLabelHidden && /*#__PURE__*/ $cozmU.createElement((0, $d187d3f4498a1480$export$bc1a48e1b7ed7af), {
        label: label,
        labelColor: labelColor
    })), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
        testId: "large-card-body",
        space: "space.100"
    }, cardBodyItems)), hasLink && !hasError && isResolved && (shouldRenderMetadata || shouldRenderSocials) && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        alignBlock: "center",
        spread: "space-between"
    }, shouldRenderMetadata && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        space: "space.050",
        separator: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), null, "\u2022"),
        alignBlock: "center"
    }, shouldRenderOwnerInfo && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $166f78176fd22bef$var$unboundedStyles.avatar
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $fEbt0.OwnedByGroupElement), {
        onRender: setIsAvatarAvailable
    })), /*#__PURE__*/ $cozmU.createElement((0, $6gjqU.OwnedByElement), {
        color: "inherit",
        hideFormat: true,
        onRender: setIsOwnerNameAvailable
    })), !!isPublishDateShown && /*#__PURE__*/ $cozmU.createElement((0, $4buyQ.ModifiedOnElement), {
        color: "inherit",
        hideDatePrefix: true,
        onRender: setIsModifiedOnAvailable
    })), shouldRenderSocials && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $keB0x.ReactCountElement), {
        color: "inherit",
        onRender: setIsReactCountAvailable
    }), /*#__PURE__*/ $cozmU.createElement((0, $cvDI4.CommentCountElement), {
        color: "inherit",
        onRender: setIsCommentCountAvailable
    })))));
    return /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
        id: "large-card-v2-container",
        isInViewMode: isInViewMode,
        cardId: cardId,
        extensionLocalId: extensionLocalId,
        isEditable: isManualVariant,
        cornerStyle: cornerStyle,
        hasLink: hasLink,
        backgroundColor: backgroundColor,
        textColor: textColor,
        borderColor: borderColor,
        enableHubCornerRadius: true,
        cornerRadiusOverride: cornerRadiusOverride
    }, hasLink ? /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $166f78176fd22bef$var$unboundedStyles.smartCardWrapper
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $QXwxo.CardSSR), {
        id: cardId,
        appearance: "inline",
        frameStyle: "show",
        ui: {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: isInViewMode,
            size: (0, $4yYAm.SmartLinkSize).Large,
            removeBlockRestriction: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            enableSnippetRenderer: enableSnippetRenderer
        },
        url: link,
        onResolve: trackSuccess,
        onError: trackAndCategorizeError
    }, cardContent)) : cardContent);
};



































































const $5e28c8f1464f076b$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.card-extensions.large-card.large-card-v1.empty-state.title-placeholder",
        defaultMessage: "Give your card a title"
    }
});


const $dabbc9a27c7fab5d$var$unboundedStyles = {
    avatar: "_c71l1tcg _19pkmyb0 _1lplidpf _px5oidpf _m5lyidpf _1oxkidpf _18alidpf _1mxvidpf _suiuidpf _1bc3idpf _tvjiidpf _1y56idpf _rjv6idpf _mbyhidpf",
    snippetOverride: "_syaz1kw7 _5fky1d4k _mavj1kw7"
};
const $dabbc9a27c7fab5d$var$styles = {
    content: "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4",
    image: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dl1wug _4t3i1osq",
    floatingIcon: "_1reoewfl _18m9ewfl _bozgpxbi _154ixmi2 _4t3iidpf _kqswh2mm",
    body: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    socials: "_19pk1wug",
    unresolvedAction: "_1reo15vq _18m915vq _11c81d4k _1bsb1osq _1bto1l2s _syazazsu"
};
const $dabbc9a27c7fab5d$var$MIN_TITLE_LINES = 2;
const $dabbc9a27c7fab5d$var$MAX_TITLE_LINES = 4;
const $dabbc9a27c7fab5d$var$MIN_DESCRIPTION_LINES = 3;
const $dabbc9a27c7fab5d$var$MAX_DESCRIPTION_LINES = 6;
const $dabbc9a27c7fab5d$var$getTitleDescriptionMaxLine = ({ hasImage: hasImage, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials })=>{
    let titleMaxLine = $dabbc9a27c7fab5d$var$MIN_TITLE_LINES;
    let descriptionMaxLine = $dabbc9a27c7fab5d$var$MIN_DESCRIPTION_LINES;
    if (!hasImage) {
        titleMaxLine += 1;
        descriptionMaxLine += 1;
        if (!shouldRenderMetadata) {
            titleMaxLine += 1;
            descriptionMaxLine += 1;
        }
        if (!shouldRenderSocials) descriptionMaxLine += 1;
    }
    if (titleMaxLine > $dabbc9a27c7fab5d$var$MAX_TITLE_LINES) titleMaxLine = $dabbc9a27c7fab5d$var$MAX_TITLE_LINES;
    if (descriptionMaxLine > $dabbc9a27c7fab5d$var$MAX_DESCRIPTION_LINES) descriptionMaxLine = $dabbc9a27c7fab5d$var$MAX_DESCRIPTION_LINES;
    return {
        titleMaxLine: titleMaxLine,
        descriptionMaxLine: descriptionMaxLine
    };
};
const $dabbc9a27c7fab5d$export$299421c7aa71f32d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(74);
    const { contentId: contentId, cardId: cardId, link: link, title: title, imageSrc: imageSrc, cardDimensions: cardDimensions, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, description: description, showDescription: showDescription, isInViewMode: isInViewMode, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, imageAltText: imageAltText, extensionLocalId: extensionLocalId, isManualVariant: isManualVariant, backgroundColor: backgroundColor, textColor: textColor, cornerStyle: cornerStyle, cornerRadius: cornerRadius, enableSnippetRenderer: enableSnippetRenderer } = t0;
    const hasLink = !!link;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    let t1;
    if ($[0] !== cornerRadius || $[1] !== cornerStyle || $[2] !== isCornerRadiusEnabled) {
        t1 = isCornerRadiusEnabled ? (0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) : undefined;
        $[0] = cornerRadius;
        $[1] = cornerStyle;
        $[2] = isCornerRadiusEnabled;
        $[3] = t1;
    } else t1 = $[3];
    const cornerRadiusOverride = t1;
    const cardHeight = cardDimensions.height;
    const t2 = isAvatarShown && hasLink;
    const t3 = isPublishDateShown && hasLink;
    const t4 = isSocialStatsShown && hasLink;
    let t5;
    if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
        t5 = {
            isOwnerInfoShown: t2,
            isModifiedOnShown: t3,
            isSocialStatsShown: t4
        };
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsOwnerNameAvailable: setIsOwnerNameAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderOwnerInfo: shouldRenderOwnerInfo, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials } = (0, $56bdef66f01f9e9c$export$28a088c1679c6579)(t5);
    const displayImageSrc = (0, $37d9cdf0819e0905$export$71956575015d1f5)(link, imageSrc);
    const { hasImage: hasImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $9QaSD.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $dabbc9a27c7fab5d$var$getTitleDescriptionMaxLine({
        hasImage: hasImage,
        shouldRenderMetadata: shouldRenderMetadata,
        shouldRenderSocials: shouldRenderSocials
    });
    let t6;
    if ($[8] !== description || $[9] !== descriptionMaxLine || $[10] !== enableSnippetRenderer || $[11] !== formatMessage || $[12] !== hasError || $[13] !== hasImage || $[14] !== hasLink || $[15] !== isIconShown || $[16] !== isPublishDateShown || $[17] !== isResolved || $[18] !== link || $[19] !== setIsAvatarAvailable || $[20] !== setIsCommentCountAvailable || $[21] !== setIsModifiedOnAvailable || $[22] !== setIsOwnerNameAvailable || $[23] !== setIsReactCountAvailable || $[24] !== shouldRenderMetadata || $[25] !== shouldRenderOwnerInfo || $[26] !== shouldRenderSocials || $[27] !== showDescription || $[28] !== title || $[29] !== titleMaxLine) {
        t6 = hasLink ? [
            isIconShown && !hasImage && /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
                key: "link-icon",
                link: link
            }),
            title && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
                key: "title",
                maxLine: titleMaxLine,
                fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingMedium
            }, title),
            hasError && !title && !description && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
                key: "unresolved-action",
                xcss: (0, $w6R6I.cx)($dabbc9a27c7fab5d$var$styles.unresolvedAction)
            }, /*#__PURE__*/ $cozmU.createElement((0, $7j5Rg.UnresolvedAction), null)),
            isResolved && !hasError && shouldRenderMetadata && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
                testId: "large-card-v1-metadata",
                key: "metadata",
                space: "space.050",
                separator: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), null, "\u2022"),
                alignBlock: "center"
            }, shouldRenderOwnerInfo && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    $dabbc9a27c7fab5d$var$unboundedStyles.avatar
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $fEbt0.OwnedByGroupElement), {
                onRender: setIsAvatarAvailable
            })), /*#__PURE__*/ $cozmU.createElement((0, $6gjqU.OwnedByElement), {
                color: "inherit",
                hideFormat: true,
                onRender: setIsOwnerNameAvailable
            })), !!isPublishDateShown && /*#__PURE__*/ $cozmU.createElement((0, $4buyQ.ModifiedOnElement), {
                color: "inherit",
                onRender: (hasData)=>setIsModifiedOnAvailable(hasData)
            })),
            showDescription && enableSnippetRenderer && /*#__PURE__*/ $cozmU.createElement("div", {
                key: "snippet",
                className: (0, $hekY6.default)([
                    $dabbc9a27c7fab5d$var$unboundedStyles.snippetOverride
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $es2gJ.default), {
                showFooter: false,
                maxLines: descriptionMaxLine,
                text: description
            })),
            showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
                key: "description",
                maxLine: descriptionMaxLine,
                fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).BodyLarge
            }, description),
            isResolved && !hasError && shouldRenderSocials && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
                testId: "large-card-v1-socials",
                key: "socials",
                space: "space.150",
                xcss: $dabbc9a27c7fab5d$var$styles.socials
            }, /*#__PURE__*/ $cozmU.createElement((0, $keB0x.ReactCountElement), {
                color: "inherit",
                onRender: setIsReactCountAvailable
            }), /*#__PURE__*/ $cozmU.createElement((0, $cvDI4.CommentCountElement), {
                color: "inherit",
                onRender: setIsCommentCountAvailable
            }))
        ].filter(Boolean) : [
            /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
                key: "title",
                maxLine: titleMaxLine,
                fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingMedium
            }, title || formatMessage((0, $5e28c8f1464f076b$export$defe85febe8b728c).emptyStatePlaceholderTitle)),
            description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
                key: "description",
                maxLine: descriptionMaxLine,
                fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).BodyLarge
            }, description)
        ].filter(Boolean);
        $[8] = description;
        $[9] = descriptionMaxLine;
        $[10] = enableSnippetRenderer;
        $[11] = formatMessage;
        $[12] = hasError;
        $[13] = hasImage;
        $[14] = hasLink;
        $[15] = isIconShown;
        $[16] = isPublishDateShown;
        $[17] = isResolved;
        $[18] = link;
        $[19] = setIsAvatarAvailable;
        $[20] = setIsCommentCountAvailable;
        $[21] = setIsModifiedOnAvailable;
        $[22] = setIsOwnerNameAvailable;
        $[23] = setIsReactCountAvailable;
        $[24] = shouldRenderMetadata;
        $[25] = shouldRenderOwnerInfo;
        $[26] = shouldRenderSocials;
        $[27] = showDescription;
        $[28] = title;
        $[29] = titleMaxLine;
        $[30] = t6;
    } else t6 = $[30];
    const cardBodyItems = t6;
    let t7;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $w6R6I.cx)($dabbc9a27c7fab5d$var$styles.content);
        $[31] = t7;
    } else t7 = $[31];
    let t8;
    if ($[32] !== cardHeight) {
        t8 = {
            height: cardHeight
        };
        $[32] = cardHeight;
        $[33] = t8;
    } else t8 = $[33];
    let t9;
    if ($[34] !== contentId || $[35] !== displayImageSrc || $[36] !== hasImage || $[37] !== hasLink || $[38] !== imageAltText) {
        t9 = hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: (0, $w6R6I.cx)($dabbc9a27c7fab5d$var$styles.image)
        }, /*#__PURE__*/ $cozmU.createElement((0, $dhLnb.ImageRenderer), {
            contentId: contentId,
            imageSrc: displayImageSrc,
            imageAlt: imageAltText,
            shouldShowExternalSiteImage: hasLink
        }));
        $[34] = contentId;
        $[35] = displayImageSrc;
        $[36] = hasImage;
        $[37] = hasLink;
        $[38] = imageAltText;
        $[39] = t9;
    } else t9 = $[39];
    let t10;
    if ($[40] !== hasImage || $[41] !== hasLink || $[42] !== isIconShown || $[43] !== link) {
        t10 = isIconShown && hasLink && hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: (0, $w6R6I.cx)($dabbc9a27c7fab5d$var$styles.floatingIcon)
        }, /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
            link: link
        }));
        $[40] = hasImage;
        $[41] = hasLink;
        $[42] = isIconShown;
        $[43] = link;
        $[44] = t10;
    } else t10 = $[44];
    let t11;
    if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $w6R6I.cx)($dabbc9a27c7fab5d$var$styles.body);
        $[45] = t11;
    } else t11 = $[45];
    let t12;
    if ($[46] !== cardBodyItems) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
            testId: "large-card-body",
            space: "space.100",
            grow: "fill",
            xcss: t11
        }, cardBodyItems);
        $[46] = cardBodyItems;
        $[47] = t12;
    } else t12 = $[47];
    let t13;
    if ($[48] !== t10 || $[49] !== t12 || $[50] !== t8 || $[51] !== t9) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            testId: "large-card-content",
            xcss: t7,
            style: t8
        }, t9, t10, t12);
        $[48] = t10;
        $[49] = t12;
        $[50] = t8;
        $[51] = t9;
        $[52] = t13;
    } else t13 = $[52];
    const cardContent = t13;
    let t14;
    if ($[53] !== cardContent || $[54] !== cardId || $[55] !== enableSnippetRenderer || $[56] !== hasLink || $[57] !== isInViewMode || $[58] !== link || $[59] !== trackAndCategorizeError || $[60] !== trackSuccess) {
        t14 = hasLink ? /*#__PURE__*/ $cozmU.createElement((0, $QXwxo.CardSSR), {
            id: cardId,
            appearance: "inline",
            frameStyle: "show",
            ui: {
                theme: (0, $4yYAm.SmartLinkTheme).Black,
                clickableContainer: isInViewMode,
                size: (0, $4yYAm.SmartLinkSize).XLarge,
                removeBlockRestriction: true,
                hideBackground: true,
                hideElevation: true,
                hidePadding: true,
                enableSnippetRenderer: enableSnippetRenderer
            },
            url: link,
            onResolve: trackSuccess,
            onError: trackAndCategorizeError
        }, cardContent) : cardContent;
        $[53] = cardContent;
        $[54] = cardId;
        $[55] = enableSnippetRenderer;
        $[56] = hasLink;
        $[57] = isInViewMode;
        $[58] = link;
        $[59] = trackAndCategorizeError;
        $[60] = trackSuccess;
        $[61] = t14;
    } else t14 = $[61];
    let t15;
    if ($[62] !== backgroundColor || $[63] !== cardHeight || $[64] !== cardId || $[65] !== cornerRadiusOverride || $[66] !== cornerStyle || $[67] !== extensionLocalId || $[68] !== hasLink || $[69] !== isInViewMode || $[70] !== isManualVariant || $[71] !== t14 || $[72] !== textColor) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
            id: "large-card-v1-container",
            cardHeight: cardHeight,
            isInViewMode: isInViewMode,
            cardId: cardId,
            extensionLocalId: extensionLocalId,
            isEditable: isManualVariant,
            cornerStyle: cornerStyle,
            enableHubCornerRadius: true,
            cornerRadiusOverride: cornerRadiusOverride,
            hasLink: hasLink,
            backgroundColor: backgroundColor,
            textColor: textColor
        }, t14);
        $[62] = backgroundColor;
        $[63] = cardHeight;
        $[64] = cardId;
        $[65] = cornerRadiusOverride;
        $[66] = cornerStyle;
        $[67] = extensionLocalId;
        $[68] = hasLink;
        $[69] = isInViewMode;
        $[70] = isManualVariant;
        $[71] = t14;
        $[72] = textColor;
        $[73] = t15;
    } else t15 = $[73];
    return t15;
} : ({ contentId: contentId, cardId: cardId, link: link, title: title, imageSrc: imageSrc, cardDimensions: cardDimensions, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, description: description, showDescription: showDescription, isInViewMode: isInViewMode, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, imageAltText: imageAltText, extensionLocalId: extensionLocalId, isManualVariant: isManualVariant, backgroundColor: backgroundColor, textColor: textColor, cornerStyle: cornerStyle, cornerRadius: cornerRadius, enableSnippetRenderer: enableSnippetRenderer })=>{
    const hasLink = !!link;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const cornerRadiusOverride = isCornerRadiusEnabled ? (0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) : undefined;
    const cardHeight = cardDimensions.height;
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsOwnerNameAvailable: setIsOwnerNameAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderOwnerInfo: shouldRenderOwnerInfo, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials } = (0, $56bdef66f01f9e9c$export$28a088c1679c6579)({
        isOwnerInfoShown: isAvatarShown && hasLink,
        isModifiedOnShown: isPublishDateShown && hasLink,
        isSocialStatsShown: isSocialStatsShown && hasLink
    });
    const displayImageSrc = (0, $37d9cdf0819e0905$export$71956575015d1f5)(link, imageSrc);
    const { hasImage: hasImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $9QaSD.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $dabbc9a27c7fab5d$var$getTitleDescriptionMaxLine({
        hasImage: hasImage,
        shouldRenderMetadata: shouldRenderMetadata,
        shouldRenderSocials: shouldRenderSocials
    });
    const cardBodyItems = hasLink ? [
        // Icon for non-image cards
        isIconShown && !hasImage && /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
            key: "link-icon",
            link: link
        }),
        // Title
        title && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingMedium
        }, title),
        // Unresolved action if there is error and no title and no description
        hasError && !title && !description && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            key: "unresolved-action",
            xcss: (0, $w6R6I.cx)($dabbc9a27c7fab5d$var$styles.unresolvedAction)
        }, /*#__PURE__*/ $cozmU.createElement((0, $7j5Rg.UnresolvedAction), null)),
        // Avatar and Publish Date
        isResolved && !hasError && shouldRenderMetadata && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            testId: "large-card-v1-metadata",
            key: "metadata",
            space: "space.050",
            separator: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), null, "\u2022"),
            alignBlock: "center"
        }, shouldRenderOwnerInfo && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $dabbc9a27c7fab5d$var$unboundedStyles.avatar
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $fEbt0.OwnedByGroupElement), {
            onRender: setIsAvatarAvailable
        })), /*#__PURE__*/ $cozmU.createElement((0, $6gjqU.OwnedByElement), {
            color: "inherit",
            hideFormat: true,
            onRender: setIsOwnerNameAvailable
        })), !!isPublishDateShown && /*#__PURE__*/ $cozmU.createElement((0, $4buyQ.ModifiedOnElement), {
            color: "inherit",
            onRender: (hasData)=>setIsModifiedOnAvailable(hasData)
        })),
        // Description
        // AI snippet
        showDescription && enableSnippetRenderer && /*#__PURE__*/ $cozmU.createElement("div", {
            key: "snippet",
            className: (0, $hekY6.default)([
                $dabbc9a27c7fab5d$var$unboundedStyles.snippetOverride
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $es2gJ.default), {
            showFooter: false,
            maxLines: descriptionMaxLine,
            text: description
        })),
        // normal description
        showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).BodyLarge
        }, description),
        // Socials
        isResolved && !hasError && shouldRenderSocials && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            testId: "large-card-v1-socials",
            key: "socials",
            space: "space.150",
            xcss: $dabbc9a27c7fab5d$var$styles.socials
        }, /*#__PURE__*/ $cozmU.createElement((0, $keB0x.ReactCountElement), {
            color: "inherit",
            onRender: setIsReactCountAvailable
        }), /*#__PURE__*/ $cozmU.createElement((0, $cvDI4.CommentCountElement), {
            color: "inherit",
            onRender: setIsCommentCountAvailable
        }))
    ].filter(Boolean) : [
        // Title or placeholder
        /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingMedium
        }, title || formatMessage((0, $5e28c8f1464f076b$export$defe85febe8b728c).emptyStatePlaceholderTitle)),
        // Description
        description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).BodyLarge
        }, description)
    ].filter(Boolean);
    const cardContent = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        testId: "large-card-content",
        xcss: (0, $w6R6I.cx)($dabbc9a27c7fab5d$var$styles.content),
        style: {
            height: cardHeight
        }
    }, hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($dabbc9a27c7fab5d$var$styles.image)
    }, /*#__PURE__*/ $cozmU.createElement((0, $dhLnb.ImageRenderer), {
        contentId: contentId,
        imageSrc: displayImageSrc,
        imageAlt: imageAltText,
        shouldShowExternalSiteImage: hasLink
    })), isIconShown && hasLink && hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($dabbc9a27c7fab5d$var$styles.floatingIcon)
    }, /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
        link: link
    })), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
        testId: "large-card-body",
        space: "space.100",
        grow: "fill",
        xcss: (0, $w6R6I.cx)($dabbc9a27c7fab5d$var$styles.body)
    }, cardBodyItems));
    return /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
        id: "large-card-v1-container",
        cardHeight: cardHeight,
        isInViewMode: isInViewMode,
        cardId: cardId,
        extensionLocalId: extensionLocalId,
        isEditable: isManualVariant,
        cornerStyle: cornerStyle,
        enableHubCornerRadius: true,
        cornerRadiusOverride: cornerRadiusOverride,
        hasLink: hasLink,
        backgroundColor: backgroundColor,
        textColor: textColor
    }, hasLink ? /*#__PURE__*/ $cozmU.createElement((0, $QXwxo.CardSSR), {
        id: cardId,
        appearance: "inline",
        frameStyle: "show",
        ui: {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: isInViewMode,
            size: (0, $4yYAm.SmartLinkSize).XLarge,
            removeBlockRestriction: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            enableSnippetRenderer: enableSnippetRenderer
        },
        url: link,
        onResolve: trackSuccess,
        onError: trackAndCategorizeError
    }, cardContent) : cardContent);
};



































































const $7f5a4eebb6cb4a95$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.card-extensions.medium-card.medium-card-v2.empty-state.title-placeholder",
        defaultMessage: "Give your card a title"
    }
});


const $47140f834e4043e2$var$unboundedStyles = {
    avatar: "_c71l1tcg _1lplidpf _px5oidpf _m5lyidpf _1oxkidpf _18alidpf _1mxvidpf _suiuidpf _1bc3idpf _tvjiidpf _1y56idpf _rjv6idpf _mbyhidpf",
    snippetOverride: "_syaz1kw7 _5fkyfhey _mavj1kw7",
    smartCardWrapper: "_4t3i1osq _wht71osq"
};
const $47140f834e4043e2$var$styles = {
    content: "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _4t3i1osq _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    imageCorner: "_2rko1mok",
    imageWithPadding: "_1reo15vq _18m915vq _4t3iautk",
    imageNoPadding: "_1reo15vq _18m915vq _4t3i11ux _19pkmgjw _2hwxmgjw _18u0mgjw",
    headerWithImagePadding: "_ca0qu2gc _19bvu2gc",
    headerWithImage: "_1e0c1txw _kqswstnw _154ipxbi _1ltvpxbi",
    unresolvedAction: "_1reo15vq _18m915vq _11c8fhey _1bsb1osq _1bto1l2s _syazazsu",
    static: "_kqswpfqs",
    relative: "_kqswh2mm"
};
const $47140f834e4043e2$var$MIN_TITLE_LINES = 3;
const $47140f834e4043e2$var$MIN_DESCRIPTION_LINES = 3;
const $47140f834e4043e2$var$getTitleDescriptionMaxLine = ({ hasImage: hasImage })=>{
    let titleMaxLine = $47140f834e4043e2$var$MIN_TITLE_LINES;
    let descriptionMaxLine = $47140f834e4043e2$var$MIN_DESCRIPTION_LINES;
    if (!hasImage) {
        titleMaxLine += 1;
        descriptionMaxLine += 2;
    }
    return {
        titleMaxLine: titleMaxLine,
        descriptionMaxLine: descriptionMaxLine
    };
};
const $47140f834e4043e2$export$b38e9910221b4e7e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(62);
    const { cardDimensions: cardDimensions, cardId: cardId, link: link, isInViewMode: isInViewMode, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, imageSrc: imageSrc, imageAltText: imageAltText, contentId: contentId, title: title, description: description, label: label, isLabelHidden: isLabelHidden, labelColor: labelColor, isLabelShown: isLabelShown, isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, borderColor: borderColor, cornerStyle: cornerStyle, cornerRadius: cornerRadius, enableSnippetRenderer: enableSnippetRenderer, showDescription: showDescription } = t0;
    const hasLink = !!link;
    const hideCorner = cornerStyle === (0, $hjUDQ.CornerStyle).SQUARED;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    let t1;
    if ($[0] !== cornerRadius || $[1] !== cornerStyle || $[2] !== isCornerRadiusEnabled) {
        t1 = isCornerRadiusEnabled ? (0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) : undefined;
        $[0] = cornerRadius;
        $[1] = cornerStyle;
        $[2] = isCornerRadiusEnabled;
        $[3] = t1;
    } else t1 = $[3];
    const cornerRadiusOverride = t1;
    const cardMinHeight = cardDimensions.minHeight;
    const cardMaxHeight = cardDimensions.maxHeight;
    const t2 = isAvatarShown && hasLink;
    const t3 = isPublishDateShown && hasLink;
    const t4 = isSocialStatsShown && hasLink;
    let t5;
    if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
        t5 = {
            isOwnerInfoShown: t2,
            isModifiedOnShown: t3,
            isSocialStatsShown: t4
        };
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials, shouldRenderOwnerInfo: shouldRenderOwnerInfo } = (0, $56bdef66f01f9e9c$export$28a088c1679c6579)(t5);
    const displayImageSrc = (0, $37d9cdf0819e0905$export$71956575015d1f5)(link, imageSrc);
    const { hasImage: hasImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $9QaSD.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $47140f834e4043e2$var$getTitleDescriptionMaxLine({
        hasImage: hasImage
    });
    const cardBodyItems = hasLink ? [
        title && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingSmall
        }, title),
        hasError && !title && !description && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            key: "unresolved-action",
            xcss: $47140f834e4043e2$var$styles.unresolvedAction
        }, /*#__PURE__*/ $cozmU.createElement((0, $7j5Rg.UnresolvedAction), null)),
        showDescription && enableSnippetRenderer && /*#__PURE__*/ $cozmU.createElement("div", {
            key: "snippet",
            className: (0, $hekY6.default)([
                $47140f834e4043e2$var$unboundedStyles.snippetOverride
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $es2gJ.default), {
            showFooter: false,
            maxLines: descriptionMaxLine,
            text: description
        })),
        showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).Body
        }, description)
    ].filter(Boolean) : [
        /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingSmall
        }, title || formatMessage((0, $7f5a4eebb6cb4a95$export$defe85febe8b728c).emptyStatePlaceholderTitle)),
        description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).Body
        }, description)
    ].filter(Boolean);
    const T0 = (0, $iMnC5.default);
    const t6 = "medium-card-v2-content";
    const t7 = hasLink ? $47140f834e4043e2$var$styles.static : $47140f834e4043e2$var$styles.relative;
    let t8;
    if ($[8] !== t7) {
        t8 = (0, $w6R6I.cx)($47140f834e4043e2$var$styles.content, t7);
        $[8] = t7;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== cardMaxHeight || $[11] !== cardMinHeight) {
        t9 = {
            minHeight: cardMinHeight,
            maxHeight: cardMaxHeight
        };
        $[10] = cardMaxHeight;
        $[11] = cardMinHeight;
        $[12] = t9;
    } else t9 = $[12];
    const T1 = (0, $dinVW.default);
    const t10 = "space-between";
    const t11 = "space.150";
    const t12 = "fill";
    const T2 = (0, $dinVW.default);
    const t13 = "space.150";
    const t14 = hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        testId: "medium-card-v2-image",
        xcss: (0, $w6R6I.cx)(isPaddingEnabled ? $47140f834e4043e2$var$styles.imageWithPadding : $47140f834e4043e2$var$styles.imageNoPadding, !isCornerRadiusEnabled && !hideCorner && isPaddingEnabled && $47140f834e4043e2$var$styles.imageCorner),
        style: isCornerRadiusEnabled ? {
            borderRadius: isPaddingEnabled ? `calc(var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})/2)` : `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`
        } : undefined
    }, /*#__PURE__*/ $cozmU.createElement((0, $dhLnb.ImageRenderer), {
        contentId: contentId,
        imageSrc: displayImageSrc,
        imageAlt: imageAltText,
        shouldShowExternalSiteImage: hasLink
    }));
    const t15 = (isIconShown && hasLink || isLabelShown && !isLabelHidden) && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: (0, $w6R6I.cx)(hasImage && $47140f834e4043e2$var$styles.headerWithImage, hasImage && isPaddingEnabled && $47140f834e4043e2$var$styles.headerWithImagePadding)
    }, isIconShown && hasLink && /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
        link: link
    }), isLabelShown && !isLabelHidden && /*#__PURE__*/ $cozmU.createElement((0, $d187d3f4498a1480$export$bc1a48e1b7ed7af), {
        label: label,
        labelColor: labelColor
    }));
    let t16;
    if ($[13] !== cardBodyItems) {
        t16 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
            testId: "medium-card-body",
            space: "space.100"
        }, cardBodyItems);
        $[13] = cardBodyItems;
        $[14] = t16;
    } else t16 = $[14];
    let t17;
    if ($[15] !== T2 || $[16] !== t14 || $[17] !== t15 || $[18] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement(T2, {
            space: t13
        }, t14, t15, t16);
        $[15] = T2;
        $[16] = t14;
        $[17] = t15;
        $[18] = t16;
        $[19] = t17;
    } else t17 = $[19];
    let t18;
    if ($[20] !== hasError || $[21] !== hasLink || $[22] !== isPublishDateShown || $[23] !== isResolved || $[24] !== setIsAvatarAvailable || $[25] !== setIsCommentCountAvailable || $[26] !== setIsModifiedOnAvailable || $[27] !== setIsReactCountAvailable || $[28] !== shouldRenderMetadata || $[29] !== shouldRenderOwnerInfo || $[30] !== shouldRenderSocials) {
        t18 = hasLink && !hasError && isResolved && (shouldRenderMetadata || shouldRenderSocials) && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            alignBlock: "center",
            spread: "space-between"
        }, shouldRenderMetadata && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            space: "space.050",
            alignBlock: "center"
        }, shouldRenderOwnerInfo && /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $47140f834e4043e2$var$unboundedStyles.avatar
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $fEbt0.OwnedByGroupElement), {
            onRender: setIsAvatarAvailable
        })), !!isPublishDateShown && /*#__PURE__*/ $cozmU.createElement((0, $4buyQ.ModifiedOnElement), {
            color: "inherit",
            hideDatePrefix: true,
            onRender: setIsModifiedOnAvailable
        })), shouldRenderSocials && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            space: "space.150"
        }, /*#__PURE__*/ $cozmU.createElement((0, $keB0x.ReactCountElement), {
            color: "inherit",
            onRender: setIsReactCountAvailable
        }), /*#__PURE__*/ $cozmU.createElement((0, $cvDI4.CommentCountElement), {
            color: "inherit",
            onRender: setIsCommentCountAvailable
        })));
        $[20] = hasError;
        $[21] = hasLink;
        $[22] = isPublishDateShown;
        $[23] = isResolved;
        $[24] = setIsAvatarAvailable;
        $[25] = setIsCommentCountAvailable;
        $[26] = setIsModifiedOnAvailable;
        $[27] = setIsReactCountAvailable;
        $[28] = shouldRenderMetadata;
        $[29] = shouldRenderOwnerInfo;
        $[30] = shouldRenderSocials;
        $[31] = t18;
    } else t18 = $[31];
    let t19;
    if ($[32] !== T1 || $[33] !== t17 || $[34] !== t18) {
        t19 = /*#__PURE__*/ $cozmU.createElement(T1, {
            spread: t10,
            space: t11,
            grow: t12
        }, t17, t18);
        $[32] = T1;
        $[33] = t17;
        $[34] = t18;
        $[35] = t19;
    } else t19 = $[35];
    let t20;
    if ($[36] !== T0 || $[37] !== t19 || $[38] !== t8 || $[39] !== t9) {
        t20 = /*#__PURE__*/ $cozmU.createElement(T0, {
            testId: t6,
            xcss: t8,
            style: t9
        }, t19);
        $[36] = T0;
        $[37] = t19;
        $[38] = t8;
        $[39] = t9;
        $[40] = t20;
    } else t20 = $[40];
    const cardContent = t20;
    let t21;
    if ($[41] !== cardContent || $[42] !== cardId || $[43] !== enableSnippetRenderer || $[44] !== hasLink || $[45] !== isInViewMode || $[46] !== link || $[47] !== trackAndCategorizeError || $[48] !== trackSuccess) {
        t21 = hasLink ? /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $47140f834e4043e2$var$unboundedStyles.smartCardWrapper
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $QXwxo.CardSSR), {
            id: cardId,
            appearance: "inline",
            frameStyle: "show",
            ui: {
                theme: (0, $4yYAm.SmartLinkTheme).Black,
                clickableContainer: isInViewMode,
                size: (0, $4yYAm.SmartLinkSize).Medium,
                removeBlockRestriction: true,
                hideBackground: true,
                hideElevation: true,
                hidePadding: true,
                enableSnippetRenderer: enableSnippetRenderer
            },
            url: link,
            onResolve: trackSuccess,
            onError: trackAndCategorizeError
        }, cardContent)) : cardContent;
        $[41] = cardContent;
        $[42] = cardId;
        $[43] = enableSnippetRenderer;
        $[44] = hasLink;
        $[45] = isInViewMode;
        $[46] = link;
        $[47] = trackAndCategorizeError;
        $[48] = trackSuccess;
        $[49] = t21;
    } else t21 = $[49];
    let t22;
    if ($[50] !== backgroundColor || $[51] !== borderColor || $[52] !== cardId || $[53] !== cornerRadiusOverride || $[54] !== cornerStyle || $[55] !== extensionLocalId || $[56] !== hasLink || $[57] !== isInViewMode || $[58] !== isManualVariant || $[59] !== t21 || $[60] !== textColor) {
        t22 = /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
            id: "medium-card-v2-container",
            isInViewMode: isInViewMode,
            cardId: cardId,
            extensionLocalId: extensionLocalId,
            isEditable: isManualVariant,
            cornerStyle: cornerStyle,
            hasLink: hasLink,
            backgroundColor: backgroundColor,
            textColor: textColor,
            borderColor: borderColor,
            enableHubCornerRadius: true,
            cornerRadiusOverride: cornerRadiusOverride
        }, t21);
        $[50] = backgroundColor;
        $[51] = borderColor;
        $[52] = cardId;
        $[53] = cornerRadiusOverride;
        $[54] = cornerStyle;
        $[55] = extensionLocalId;
        $[56] = hasLink;
        $[57] = isInViewMode;
        $[58] = isManualVariant;
        $[59] = t21;
        $[60] = textColor;
        $[61] = t22;
    } else t22 = $[61];
    return t22;
} : ({ cardDimensions: cardDimensions, cardId: cardId, link: link, isInViewMode: isInViewMode, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, imageSrc: imageSrc, imageAltText: imageAltText, contentId: contentId, title: title, description: description, label: label, isLabelHidden: isLabelHidden, labelColor: labelColor, isLabelShown: isLabelShown, isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, borderColor: borderColor, cornerStyle: cornerStyle, cornerRadius: cornerRadius, enableSnippetRenderer: enableSnippetRenderer, showDescription: showDescription })=>{
    const hasLink = !!link;
    const hideCorner = cornerStyle === (0, $hjUDQ.CornerStyle).SQUARED;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const cornerRadiusOverride = isCornerRadiusEnabled ? (0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) : undefined;
    const cardMinHeight = cardDimensions.minHeight;
    const cardMaxHeight = cardDimensions.maxHeight;
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials, shouldRenderOwnerInfo: shouldRenderOwnerInfo } = (0, $56bdef66f01f9e9c$export$28a088c1679c6579)({
        isOwnerInfoShown: isAvatarShown && hasLink,
        isModifiedOnShown: isPublishDateShown && hasLink,
        isSocialStatsShown: isSocialStatsShown && hasLink
    });
    const displayImageSrc = (0, $37d9cdf0819e0905$export$71956575015d1f5)(link, imageSrc);
    const { hasImage: hasImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $9QaSD.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $47140f834e4043e2$var$getTitleDescriptionMaxLine({
        hasImage: hasImage
    });
    const cardBodyItems = hasLink ? [
        // Title
        title && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingSmall
        }, title),
        // Unresolved action
        hasError && !title && !description && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            key: "unresolved-action",
            xcss: $47140f834e4043e2$var$styles.unresolvedAction
        }, /*#__PURE__*/ $cozmU.createElement((0, $7j5Rg.UnresolvedAction), null)),
        // Description
        showDescription && enableSnippetRenderer && /*#__PURE__*/ $cozmU.createElement("div", {
            key: "snippet",
            className: (0, $hekY6.default)([
                $47140f834e4043e2$var$unboundedStyles.snippetOverride
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $es2gJ.default), {
            showFooter: false,
            maxLines: descriptionMaxLine,
            text: description
        })),
        // normal description
        showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).Body
        }, description)
    ].filter(Boolean) : [
        // Title or placeholder
        /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingSmall
        }, title || formatMessage((0, $7f5a4eebb6cb4a95$export$defe85febe8b728c).emptyStatePlaceholderTitle)),
        // Description
        description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).Body
        }, description)
    ].filter(Boolean);
    const cardContent = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        testId: "medium-card-v2-content",
        xcss: (0, $w6R6I.cx)($47140f834e4043e2$var$styles.content, hasLink ? $47140f834e4043e2$var$styles.static : $47140f834e4043e2$var$styles.relative),
        style: {
            minHeight: cardMinHeight,
            maxHeight: cardMaxHeight
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
        spread: "space-between",
        space: "space.150",
        grow: "fill"
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
        space: "space.150"
    }, hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        testId: "medium-card-v2-image",
        xcss: (0, $w6R6I.cx)(isPaddingEnabled ? $47140f834e4043e2$var$styles.imageWithPadding : $47140f834e4043e2$var$styles.imageNoPadding, !isCornerRadiusEnabled && !hideCorner && isPaddingEnabled && $47140f834e4043e2$var$styles.imageCorner),
        style: isCornerRadiusEnabled ? {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            borderRadius: isPaddingEnabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            `calc(var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})/2)` : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`
        } : undefined
    }, /*#__PURE__*/ $cozmU.createElement((0, $dhLnb.ImageRenderer), {
        contentId: contentId,
        imageSrc: displayImageSrc,
        imageAlt: imageAltText,
        shouldShowExternalSiteImage: hasLink
    })), (isIconShown && hasLink || isLabelShown && !isLabelHidden) && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: (0, $w6R6I.cx)(hasImage && $47140f834e4043e2$var$styles.headerWithImage, hasImage && isPaddingEnabled && $47140f834e4043e2$var$styles.headerWithImagePadding)
    }, isIconShown && hasLink && /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
        link: link
    }), isLabelShown && !isLabelHidden && /*#__PURE__*/ $cozmU.createElement((0, $d187d3f4498a1480$export$bc1a48e1b7ed7af), {
        label: label,
        labelColor: labelColor
    })), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
        testId: "medium-card-body",
        space: "space.100"
    }, cardBodyItems)), hasLink && !hasError && isResolved && (shouldRenderMetadata || shouldRenderSocials) && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        alignBlock: "center",
        spread: "space-between"
    }, shouldRenderMetadata && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        space: "space.050",
        alignBlock: "center"
    }, shouldRenderOwnerInfo && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $47140f834e4043e2$var$unboundedStyles.avatar
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $fEbt0.OwnedByGroupElement), {
        onRender: setIsAvatarAvailable
    })), !!isPublishDateShown && /*#__PURE__*/ $cozmU.createElement((0, $4buyQ.ModifiedOnElement), {
        color: "inherit",
        hideDatePrefix: true,
        onRender: setIsModifiedOnAvailable
    })), shouldRenderSocials && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $keB0x.ReactCountElement), {
        color: "inherit",
        onRender: setIsReactCountAvailable
    }), /*#__PURE__*/ $cozmU.createElement((0, $cvDI4.CommentCountElement), {
        color: "inherit",
        onRender: setIsCommentCountAvailable
    })))));
    return /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
        id: "medium-card-v2-container",
        isInViewMode: isInViewMode,
        cardId: cardId,
        extensionLocalId: extensionLocalId,
        isEditable: isManualVariant,
        cornerStyle: cornerStyle,
        hasLink: hasLink,
        backgroundColor: backgroundColor,
        textColor: textColor,
        borderColor: borderColor,
        enableHubCornerRadius: true,
        cornerRadiusOverride: cornerRadiusOverride
    }, hasLink ? /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $47140f834e4043e2$var$unboundedStyles.smartCardWrapper
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $QXwxo.CardSSR), {
        id: cardId,
        appearance: "inline",
        frameStyle: "show",
        ui: {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: isInViewMode,
            size: (0, $4yYAm.SmartLinkSize).Medium,
            removeBlockRestriction: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            enableSnippetRenderer: enableSnippetRenderer
        },
        url: link,
        onResolve: trackSuccess,
        onError: trackAndCategorizeError
    }, cardContent)) : cardContent);
};



































































const $442c4fd68a480cb2$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.card-extensions.medium-card.medium-card-v1.empty-state.title-placeholder",
        defaultMessage: "Give your card a title"
    }
});


const $3f1cee5e0d0614d4$var$unboundedStyles = {
    avatar: "_c71l1tcg _19pkmyb0 _1lplidpf _px5oidpf _m5lyidpf _1oxkidpf _18alidpf _1mxvidpf _suiuidpf _1bc3idpf _tvjiidpf _1y56idpf _rjv6idpf _mbyhidpf",
    snippetOverride: "_syaz1kw7 _5fkyfhey _mavj1kw7"
};
const $3f1cee5e0d0614d4$var$styles = {
    content: "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4",
    image: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dl1wug _4t3i1osq",
    floatingIcon: "_1reoewfl _18m9ewfl _bozgpxbi _154ixmi2 _4t3iidpf _kqswh2mm",
    body: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    socials: "_19pk1wug",
    unresolvedAction: "_1reo15vq _18m915vq _11c8fhey _1bsb1osq _1bto1l2s _syazazsu"
};
const $3f1cee5e0d0614d4$var$MIN_TITLE_LINES = 2;
const $3f1cee5e0d0614d4$var$MAX_TITLE_LINES = 5;
const $3f1cee5e0d0614d4$var$MIN_DESCRIPTION_LINES = 3;
const $3f1cee5e0d0614d4$var$MAX_DESCRIPTION_LINES = 7;
const $3f1cee5e0d0614d4$var$getTitleDescriptionMaxLine = ({ hasImage: hasImage, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials })=>{
    let titleMaxLine = $3f1cee5e0d0614d4$var$MIN_TITLE_LINES;
    let descriptionMaxLine = $3f1cee5e0d0614d4$var$MIN_DESCRIPTION_LINES;
    if (!hasImage) {
        descriptionMaxLine += 2;
        titleMaxLine += 2;
        if (!shouldRenderMetadata) {
            descriptionMaxLine += 1;
            titleMaxLine += 1;
        }
        if (!shouldRenderSocials) descriptionMaxLine += 1;
    }
    if (titleMaxLine > $3f1cee5e0d0614d4$var$MAX_TITLE_LINES) titleMaxLine = $3f1cee5e0d0614d4$var$MAX_TITLE_LINES;
    if (descriptionMaxLine > $3f1cee5e0d0614d4$var$MAX_DESCRIPTION_LINES) descriptionMaxLine = $3f1cee5e0d0614d4$var$MAX_DESCRIPTION_LINES;
    return {
        titleMaxLine: titleMaxLine,
        descriptionMaxLine: descriptionMaxLine
    };
};
const $3f1cee5e0d0614d4$export$42440eb4dfc95ce7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(74);
    const { cardDimensions: cardDimensions, cardId: cardId, link: link, isInViewMode: isInViewMode, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, imageSrc: imageSrc, imageAltText: imageAltText, contentId: contentId, title: title, description: description, showDescription: showDescription, enableSnippetRenderer: enableSnippetRenderer, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, cornerStyle: cornerStyle, cornerRadius: cornerRadius } = t0;
    const hasLink = !!link;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    let t1;
    if ($[0] !== cornerRadius || $[1] !== cornerStyle || $[2] !== isCornerRadiusEnabled) {
        t1 = isCornerRadiusEnabled ? (0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) : undefined;
        $[0] = cornerRadius;
        $[1] = cornerStyle;
        $[2] = isCornerRadiusEnabled;
        $[3] = t1;
    } else t1 = $[3];
    const cornerRadiusOverride = t1;
    const cardHeight = cardDimensions.height;
    const t2 = isAvatarShown && hasLink;
    const t3 = isPublishDateShown && hasLink;
    const t4 = isSocialStatsShown && hasLink;
    let t5;
    if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
        t5 = {
            isOwnerInfoShown: t2,
            isModifiedOnShown: t3,
            isSocialStatsShown: t4
        };
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsOwnerNameAvailable: setIsOwnerNameAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials, shouldRenderOwnerInfo: shouldRenderOwnerInfo } = (0, $56bdef66f01f9e9c$export$28a088c1679c6579)(t5);
    const displayImageSrc = (0, $37d9cdf0819e0905$export$71956575015d1f5)(link, imageSrc);
    const { hasImage: hasImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $9QaSD.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $3f1cee5e0d0614d4$var$getTitleDescriptionMaxLine({
        hasImage: hasImage,
        shouldRenderMetadata: shouldRenderMetadata,
        shouldRenderSocials: shouldRenderSocials
    });
    let t6;
    if ($[8] !== description || $[9] !== descriptionMaxLine || $[10] !== enableSnippetRenderer || $[11] !== formatMessage || $[12] !== hasError || $[13] !== hasImage || $[14] !== hasLink || $[15] !== isIconShown || $[16] !== isPublishDateShown || $[17] !== isResolved || $[18] !== link || $[19] !== setIsAvatarAvailable || $[20] !== setIsCommentCountAvailable || $[21] !== setIsModifiedOnAvailable || $[22] !== setIsOwnerNameAvailable || $[23] !== setIsReactCountAvailable || $[24] !== shouldRenderMetadata || $[25] !== shouldRenderOwnerInfo || $[26] !== shouldRenderSocials || $[27] !== showDescription || $[28] !== title || $[29] !== titleMaxLine) {
        t6 = hasLink ? [
            isIconShown && !hasImage && /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
                key: "link-icon",
                link: link
            }),
            title && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
                key: "title",
                maxLine: titleMaxLine,
                fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingSmall
            }, title),
            hasError && !title && !description && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
                key: "unresolved-action",
                xcss: (0, $w6R6I.cx)($3f1cee5e0d0614d4$var$styles.unresolvedAction)
            }, /*#__PURE__*/ $cozmU.createElement((0, $7j5Rg.UnresolvedAction), null)),
            isResolved && !hasError && shouldRenderMetadata && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
                testId: "medium-card-v1-metadata",
                key: "metadata",
                space: "space.050",
                separator: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), null, "\u2022"),
                alignBlock: "center"
            }, shouldRenderOwnerInfo && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    $3f1cee5e0d0614d4$var$unboundedStyles.avatar
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $fEbt0.OwnedByGroupElement), {
                onRender: setIsAvatarAvailable
            })), /*#__PURE__*/ $cozmU.createElement((0, $6gjqU.OwnedByElement), {
                color: "inherit",
                hideFormat: true,
                onRender: setIsOwnerNameAvailable
            })), !!isPublishDateShown && /*#__PURE__*/ $cozmU.createElement((0, $4buyQ.ModifiedOnElement), {
                color: "inherit",
                hideDatePrefix: true,
                onRender: setIsModifiedOnAvailable
            })),
            showDescription && enableSnippetRenderer && /*#__PURE__*/ $cozmU.createElement("div", {
                key: "snippet",
                className: (0, $hekY6.default)([
                    $3f1cee5e0d0614d4$var$unboundedStyles.snippetOverride
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $es2gJ.default), {
                showFooter: false,
                maxLines: descriptionMaxLine,
                text: description
            })),
            showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
                key: "description",
                maxLine: descriptionMaxLine,
                fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).Body
            }, description),
            isResolved && !hasError && shouldRenderSocials && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
                testId: "medium-card-v1-socials",
                key: "socials",
                space: "space.150",
                xcss: $3f1cee5e0d0614d4$var$styles.socials
            }, /*#__PURE__*/ $cozmU.createElement((0, $keB0x.ReactCountElement), {
                color: "inherit",
                onRender: setIsReactCountAvailable
            }), /*#__PURE__*/ $cozmU.createElement((0, $cvDI4.CommentCountElement), {
                color: "inherit",
                onRender: setIsCommentCountAvailable
            }))
        ].filter(Boolean) : [
            /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
                key: "title",
                maxLine: titleMaxLine,
                fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingSmall
            }, title || formatMessage((0, $442c4fd68a480cb2$export$defe85febe8b728c).emptyStatePlaceholderTitle)),
            description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
                key: "description",
                maxLine: descriptionMaxLine,
                fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).Body
            }, description)
        ].filter(Boolean);
        $[8] = description;
        $[9] = descriptionMaxLine;
        $[10] = enableSnippetRenderer;
        $[11] = formatMessage;
        $[12] = hasError;
        $[13] = hasImage;
        $[14] = hasLink;
        $[15] = isIconShown;
        $[16] = isPublishDateShown;
        $[17] = isResolved;
        $[18] = link;
        $[19] = setIsAvatarAvailable;
        $[20] = setIsCommentCountAvailable;
        $[21] = setIsModifiedOnAvailable;
        $[22] = setIsOwnerNameAvailable;
        $[23] = setIsReactCountAvailable;
        $[24] = shouldRenderMetadata;
        $[25] = shouldRenderOwnerInfo;
        $[26] = shouldRenderSocials;
        $[27] = showDescription;
        $[28] = title;
        $[29] = titleMaxLine;
        $[30] = t6;
    } else t6 = $[30];
    const cardBodyItems = t6;
    let t7;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $w6R6I.cx)($3f1cee5e0d0614d4$var$styles.content);
        $[31] = t7;
    } else t7 = $[31];
    let t8;
    if ($[32] !== cardHeight) {
        t8 = {
            height: cardHeight
        };
        $[32] = cardHeight;
        $[33] = t8;
    } else t8 = $[33];
    let t9;
    if ($[34] !== contentId || $[35] !== displayImageSrc || $[36] !== hasImage || $[37] !== hasLink || $[38] !== imageAltText) {
        t9 = hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: (0, $w6R6I.cx)($3f1cee5e0d0614d4$var$styles.image)
        }, /*#__PURE__*/ $cozmU.createElement((0, $dhLnb.ImageRenderer), {
            contentId: contentId,
            imageSrc: displayImageSrc,
            imageAlt: imageAltText,
            shouldShowExternalSiteImage: hasLink
        }));
        $[34] = contentId;
        $[35] = displayImageSrc;
        $[36] = hasImage;
        $[37] = hasLink;
        $[38] = imageAltText;
        $[39] = t9;
    } else t9 = $[39];
    let t10;
    if ($[40] !== hasImage || $[41] !== hasLink || $[42] !== isIconShown || $[43] !== link) {
        t10 = isIconShown && hasLink && hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: (0, $w6R6I.cx)($3f1cee5e0d0614d4$var$styles.floatingIcon)
        }, /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
            link: link
        }));
        $[40] = hasImage;
        $[41] = hasLink;
        $[42] = isIconShown;
        $[43] = link;
        $[44] = t10;
    } else t10 = $[44];
    let t11;
    if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $w6R6I.cx)($3f1cee5e0d0614d4$var$styles.body);
        $[45] = t11;
    } else t11 = $[45];
    let t12;
    if ($[46] !== cardBodyItems) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
            testId: "medium-card-body",
            space: "space.100",
            grow: "fill",
            xcss: t11
        }, cardBodyItems);
        $[46] = cardBodyItems;
        $[47] = t12;
    } else t12 = $[47];
    let t13;
    if ($[48] !== t10 || $[49] !== t12 || $[50] !== t8 || $[51] !== t9) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            testId: "medium-card-v1-content",
            xcss: t7,
            style: t8
        }, t9, t10, t12);
        $[48] = t10;
        $[49] = t12;
        $[50] = t8;
        $[51] = t9;
        $[52] = t13;
    } else t13 = $[52];
    const cardContent = t13;
    let t14;
    if ($[53] !== cardContent || $[54] !== cardId || $[55] !== enableSnippetRenderer || $[56] !== hasLink || $[57] !== isInViewMode || $[58] !== link || $[59] !== trackAndCategorizeError || $[60] !== trackSuccess) {
        t14 = hasLink ? /*#__PURE__*/ $cozmU.createElement((0, $QXwxo.CardSSR), {
            id: cardId,
            appearance: "inline",
            frameStyle: "show",
            ui: {
                theme: (0, $4yYAm.SmartLinkTheme).Black,
                clickableContainer: isInViewMode,
                size: (0, $4yYAm.SmartLinkSize).Medium,
                removeBlockRestriction: true,
                hideBackground: true,
                hideElevation: true,
                hidePadding: true,
                enableSnippetRenderer: enableSnippetRenderer
            },
            url: link,
            onResolve: trackSuccess,
            onError: trackAndCategorizeError
        }, cardContent) : cardContent;
        $[53] = cardContent;
        $[54] = cardId;
        $[55] = enableSnippetRenderer;
        $[56] = hasLink;
        $[57] = isInViewMode;
        $[58] = link;
        $[59] = trackAndCategorizeError;
        $[60] = trackSuccess;
        $[61] = t14;
    } else t14 = $[61];
    let t15;
    if ($[62] !== backgroundColor || $[63] !== cardHeight || $[64] !== cardId || $[65] !== cornerRadiusOverride || $[66] !== cornerStyle || $[67] !== extensionLocalId || $[68] !== hasLink || $[69] !== isInViewMode || $[70] !== isManualVariant || $[71] !== t14 || $[72] !== textColor) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
            id: "medium-card-v1-container",
            cardHeight: cardHeight,
            isInViewMode: isInViewMode,
            cardId: cardId,
            extensionLocalId: extensionLocalId,
            isEditable: isManualVariant,
            cornerStyle: cornerStyle,
            enableHubCornerRadius: true,
            cornerRadiusOverride: cornerRadiusOverride,
            hasLink: hasLink,
            backgroundColor: backgroundColor,
            textColor: textColor
        }, t14);
        $[62] = backgroundColor;
        $[63] = cardHeight;
        $[64] = cardId;
        $[65] = cornerRadiusOverride;
        $[66] = cornerStyle;
        $[67] = extensionLocalId;
        $[68] = hasLink;
        $[69] = isInViewMode;
        $[70] = isManualVariant;
        $[71] = t14;
        $[72] = textColor;
        $[73] = t15;
    } else t15 = $[73];
    return t15;
} : ({ cardDimensions: cardDimensions, cardId: cardId, link: link, isInViewMode: isInViewMode, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, imageSrc: imageSrc, imageAltText: imageAltText, contentId: contentId, title: title, description: description, showDescription: showDescription, enableSnippetRenderer: enableSnippetRenderer, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, cornerStyle: cornerStyle, cornerRadius: cornerRadius })=>{
    const hasLink = !!link;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const cornerRadiusOverride = isCornerRadiusEnabled ? (0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) : undefined;
    const cardHeight = cardDimensions.height;
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsOwnerNameAvailable: setIsOwnerNameAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, setIsReactCountAvailable: setIsReactCountAvailable, setIsCommentCountAvailable: setIsCommentCountAvailable, shouldRenderMetadata: shouldRenderMetadata, shouldRenderSocials: shouldRenderSocials, shouldRenderOwnerInfo: shouldRenderOwnerInfo } = (0, $56bdef66f01f9e9c$export$28a088c1679c6579)({
        isOwnerInfoShown: isAvatarShown && hasLink,
        isModifiedOnShown: isPublishDateShown && hasLink,
        isSocialStatsShown: isSocialStatsShown && hasLink
    });
    const displayImageSrc = (0, $37d9cdf0819e0905$export$71956575015d1f5)(link, imageSrc);
    const { hasImage: hasImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const { isResolved: isResolved, errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $9QaSD.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const { titleMaxLine: titleMaxLine, descriptionMaxLine: descriptionMaxLine } = $3f1cee5e0d0614d4$var$getTitleDescriptionMaxLine({
        hasImage: hasImage,
        shouldRenderMetadata: shouldRenderMetadata,
        shouldRenderSocials: shouldRenderSocials
    });
    const cardBodyItems = hasLink ? [
        // Icon for non-image cards
        isIconShown && !hasImage && /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
            key: "link-icon",
            link: link
        }),
        // Title
        title && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingSmall
        }, title),
        // Unresolved action if there is error and no title and no description
        hasError && !title && !description && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            key: "unresolved-action",
            xcss: (0, $w6R6I.cx)($3f1cee5e0d0614d4$var$styles.unresolvedAction)
        }, /*#__PURE__*/ $cozmU.createElement((0, $7j5Rg.UnresolvedAction), null)),
        // Avatar and Publish Date
        isResolved && !hasError && shouldRenderMetadata && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            testId: "medium-card-v1-metadata",
            key: "metadata",
            space: "space.050",
            separator: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), null, "\u2022"),
            alignBlock: "center"
        }, shouldRenderOwnerInfo && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $3f1cee5e0d0614d4$var$unboundedStyles.avatar
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $fEbt0.OwnedByGroupElement), {
            onRender: setIsAvatarAvailable
        })), /*#__PURE__*/ $cozmU.createElement((0, $6gjqU.OwnedByElement), {
            color: "inherit",
            hideFormat: true,
            onRender: setIsOwnerNameAvailable
        })), !!isPublishDateShown && /*#__PURE__*/ $cozmU.createElement((0, $4buyQ.ModifiedOnElement), {
            color: "inherit",
            hideDatePrefix: true,
            onRender: setIsModifiedOnAvailable
        })),
        // Description
        // AI snippet
        showDescription && enableSnippetRenderer && /*#__PURE__*/ $cozmU.createElement("div", {
            key: "snippet",
            className: (0, $hekY6.default)([
                $3f1cee5e0d0614d4$var$unboundedStyles.snippetOverride
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $es2gJ.default), {
            showFooter: false,
            maxLines: descriptionMaxLine,
            text: description
        })),
        // normal description
        showDescription && !enableSnippetRenderer && description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).Body
        }, description),
        // Socials
        isResolved && !hasError && shouldRenderSocials && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            testId: "medium-card-v1-socials",
            key: "socials",
            space: "space.150",
            xcss: $3f1cee5e0d0614d4$var$styles.socials
        }, /*#__PURE__*/ $cozmU.createElement((0, $keB0x.ReactCountElement), {
            color: "inherit",
            onRender: setIsReactCountAvailable
        }), /*#__PURE__*/ $cozmU.createElement((0, $cvDI4.CommentCountElement), {
            color: "inherit",
            onRender: setIsCommentCountAvailable
        }))
    ].filter(Boolean) : [
        // Title or placeholder
        /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: titleMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingSmall
        }, title || formatMessage((0, $442c4fd68a480cb2$export$defe85febe8b728c).emptyStatePlaceholderTitle)),
        // Description
        description && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$16e0ed4cb97c00d4), {
            key: "description",
            maxLine: descriptionMaxLine,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).Body
        }, description)
    ].filter(Boolean);
    const cardContent = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        testId: "medium-card-v1-content",
        xcss: (0, $w6R6I.cx)($3f1cee5e0d0614d4$var$styles.content),
        style: {
            height: cardHeight
        }
    }, hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($3f1cee5e0d0614d4$var$styles.image)
    }, /*#__PURE__*/ $cozmU.createElement((0, $dhLnb.ImageRenderer), {
        contentId: contentId,
        imageSrc: displayImageSrc,
        imageAlt: imageAltText,
        shouldShowExternalSiteImage: hasLink
    })), isIconShown && hasLink && hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($3f1cee5e0d0614d4$var$styles.floatingIcon)
    }, /*#__PURE__*/ $cozmU.createElement((0, $7f30d41a2009de7e$export$69387b41dfc808f7), {
        link: link
    })), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
        testId: "medium-card-body",
        space: "space.100",
        grow: "fill",
        xcss: (0, $w6R6I.cx)($3f1cee5e0d0614d4$var$styles.body)
    }, cardBodyItems));
    return /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
        id: "medium-card-v1-container",
        cardHeight: cardHeight,
        isInViewMode: isInViewMode,
        cardId: cardId,
        extensionLocalId: extensionLocalId,
        isEditable: isManualVariant,
        cornerStyle: cornerStyle,
        enableHubCornerRadius: true,
        cornerRadiusOverride: cornerRadiusOverride,
        hasLink: hasLink,
        backgroundColor: backgroundColor,
        textColor: textColor
    }, hasLink ? /*#__PURE__*/ $cozmU.createElement((0, $QXwxo.CardSSR), {
        id: cardId,
        appearance: "inline",
        frameStyle: "show",
        ui: {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: isInViewMode,
            size: (0, $4yYAm.SmartLinkSize).Medium,
            removeBlockRestriction: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            enableSnippetRenderer: enableSnippetRenderer
        },
        url: link,
        onResolve: trackSuccess,
        onError: trackAndCategorizeError
    }, cardContent) : cardContent);
};


























































const $31e75c2dfb5de843$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.card-extensions.small-card.small-card-v1.empty-state.title-placeholder",
        defaultMessage: "Give your card a title"
    }
});


const $ddb6d1b8eae6067e$var$unboundedStyles = {
    content: "_1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _4cvrv2br",
    avatar: "_c71l1tcg _19pkmyb0 _1lplidpf _px5oidpf _m5lyidpf _1oxkidpf _18alidpf _1mxvidpf _suiuidpf _1bc3idpf _tvjiidpf _1y56idpf _rjv6idpf _mbyhidpf"
};
const $ddb6d1b8eae6067e$var$styles = {
    body: "_1reo15vq _18m915vq _ca0qu2gc _n3tdu2gc _4t3i1osq",
    bodyWithImage: "_16jlidpf _1o9zidpf _i0dl1wug _19bvu2gc _u5f3u2gc _p12fif8e _1e0c1txw",
    bodyWithoutImage: "_19bvpxbi _u5f3pxbi",
    image: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dli9or _4t3i1osq _p12fi9or _1e0c1txw",
    unresolvedAction: "_1reo15vq _18m915vq _11c8fhey _1bsb1osq _1bto1l2s _syazazsu"
};
const $ddb6d1b8eae6067e$export$5c35843a47cb7bc4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(76);
    const { cardDimensions: cardDimensions, cardId: cardId, link: link, title: title, imageSrc: imageSrc, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isInViewMode: isInViewMode, imageAltText: imageAltText, contentId: contentId, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, cornerStyle: cornerStyle, cornerRadius: cornerRadius } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    let t1;
    if ($[0] !== cornerRadius || $[1] !== cornerStyle || $[2] !== isCornerRadiusEnabled) {
        t1 = isCornerRadiusEnabled ? (0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) : undefined;
        $[0] = cornerRadius;
        $[1] = cornerStyle;
        $[2] = isCornerRadiusEnabled;
        $[3] = t1;
    } else t1 = $[3];
    const cornerRadiusOverride = t1;
    const cardHeight = cardDimensions.height;
    const hasLink = !!link;
    const { errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess, isResolved: isResolved } = (0, $9QaSD.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const t2 = isAvatarShown && hasLink;
    const t3 = isPublishDateShown && hasLink;
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
        t4 = {
            isOwnerInfoShown: t2,
            isModifiedOnShown: t3
        };
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, shouldRenderMetadata: shouldRenderMetadata, shouldRenderOwnerInfo: shouldRenderOwnerInfo } = (0, $56bdef66f01f9e9c$export$28a088c1679c6579)(t4);
    const displayImageSrc = (0, $37d9cdf0819e0905$export$71956575015d1f5)(link, imageSrc);
    let T0;
    let cardBodyItem;
    let t10;
    let t11;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[7] !== cardHeight || $[8] !== contentId || $[9] !== displayImageSrc || $[10] !== formatMessage || $[11] !== hasError || $[12] !== hasLink || $[13] !== imageAltText || $[14] !== isPublishDateShown || $[15] !== isResolved || $[16] !== setIsAvatarAvailable || $[17] !== setIsModifiedOnAvailable || $[18] !== shouldRenderMetadata || $[19] !== shouldRenderOwnerInfo || $[20] !== title) {
        const { hasImage: hasImage } = (0, $iMYjN.getImageTypeToShow)({
            imageSrc: displayImageSrc
        });
        let t12;
        if ($[30] !== formatMessage || $[31] !== hasError || $[32] !== hasLink || $[33] !== isPublishDateShown || $[34] !== isResolved || $[35] !== setIsAvatarAvailable || $[36] !== setIsModifiedOnAvailable || $[37] !== shouldRenderMetadata || $[38] !== shouldRenderOwnerInfo || $[39] !== title) {
            t12 = hasLink ? [
                title && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
                    key: "title",
                    maxLine: shouldRenderMetadata ? 2 : 3,
                    fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingXSmall
                }, title),
                hasError && !title && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
                    key: "unresolved-action",
                    xcss: (0, $w6R6I.cx)($ddb6d1b8eae6067e$var$styles.unresolvedAction)
                }, /*#__PURE__*/ $cozmU.createElement((0, $7j5Rg.UnresolvedAction), null)),
                isResolved && !hasError && shouldRenderMetadata && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
                    testId: "small-card-v1-metadata",
                    key: "metadata",
                    space: "space.050",
                    alignBlock: "center"
                }, shouldRenderOwnerInfo && /*#__PURE__*/ $cozmU.createElement("div", {
                    className: (0, $hekY6.default)([
                        $ddb6d1b8eae6067e$var$unboundedStyles.avatar
                    ])
                }, /*#__PURE__*/ $cozmU.createElement((0, $fEbt0.OwnedByGroupElement), {
                    onRender: setIsAvatarAvailable
                })), !!isPublishDateShown && /*#__PURE__*/ $cozmU.createElement((0, $4buyQ.ModifiedOnElement), {
                    color: "inherit",
                    onRender: setIsModifiedOnAvailable
                }))
            ].filter(Boolean) : [
                /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
                    key: "title",
                    maxLine: 3,
                    fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingXSmall
                }, title || formatMessage((0, $31e75c2dfb5de843$export$defe85febe8b728c).emptyStatePlaceholderTitle))
            ].filter(Boolean);
            $[30] = formatMessage;
            $[31] = hasError;
            $[32] = hasLink;
            $[33] = isPublishDateShown;
            $[34] = isResolved;
            $[35] = setIsAvatarAvailable;
            $[36] = setIsModifiedOnAvailable;
            $[37] = shouldRenderMetadata;
            $[38] = shouldRenderOwnerInfo;
            $[39] = title;
            $[40] = t12;
        } else t12 = $[40];
        cardBodyItem = t12;
        t8 = "small-card-content";
        if ($[41] !== cardHeight) {
            t9 = {
                height: cardHeight
            };
            $[41] = cardHeight;
            $[42] = t9;
        } else t9 = $[42];
        if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
            t10 = (0, $hekY6.default)([
                $ddb6d1b8eae6067e$var$unboundedStyles.content
            ]);
            $[43] = t10;
        } else t10 = $[43];
        t11 = hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: (0, $w6R6I.cx)($ddb6d1b8eae6067e$var$styles.image)
        }, /*#__PURE__*/ $cozmU.createElement((0, $dhLnb.ImageRenderer), {
            contentId: contentId,
            imageSrc: displayImageSrc,
            imageAlt: imageAltText,
            shouldShowExternalSiteImage: hasLink
        }));
        T0 = (0, $dinVW.default);
        t5 = "small-card-body";
        t6 = "space.100";
        t7 = (0, $w6R6I.cx)($ddb6d1b8eae6067e$var$styles.body, hasImage && $ddb6d1b8eae6067e$var$styles.bodyWithImage, !hasImage && $ddb6d1b8eae6067e$var$styles.bodyWithoutImage);
        $[7] = cardHeight;
        $[8] = contentId;
        $[9] = displayImageSrc;
        $[10] = formatMessage;
        $[11] = hasError;
        $[12] = hasLink;
        $[13] = imageAltText;
        $[14] = isPublishDateShown;
        $[15] = isResolved;
        $[16] = setIsAvatarAvailable;
        $[17] = setIsModifiedOnAvailable;
        $[18] = shouldRenderMetadata;
        $[19] = shouldRenderOwnerInfo;
        $[20] = title;
        $[21] = T0;
        $[22] = cardBodyItem;
        $[23] = t10;
        $[24] = t11;
        $[25] = t5;
        $[26] = t6;
        $[27] = t7;
        $[28] = t8;
        $[29] = t9;
    } else {
        T0 = $[21];
        cardBodyItem = $[22];
        t10 = $[23];
        t11 = $[24];
        t5 = $[25];
        t6 = $[26];
        t7 = $[27];
        t8 = $[28];
        t9 = $[29];
    }
    let t12;
    if ($[44] !== T0 || $[45] !== cardBodyItem || $[46] !== t5 || $[47] !== t6 || $[48] !== t7) {
        t12 = /*#__PURE__*/ $cozmU.createElement(T0, {
            testId: t5,
            space: t6,
            xcss: t7,
            alignBlock: "center",
            alignInline: "start"
        }, cardBodyItem);
        $[44] = T0;
        $[45] = cardBodyItem;
        $[46] = t5;
        $[47] = t6;
        $[48] = t7;
        $[49] = t12;
    } else t12 = $[49];
    let t13;
    if ($[50] !== t10 || $[51] !== t11 || $[52] !== t12 || $[53] !== t8 || $[54] !== t9) {
        t13 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": t8,
            style: t9,
            className: t10
        }, t11, t12);
        $[50] = t10;
        $[51] = t11;
        $[52] = t12;
        $[53] = t8;
        $[54] = t9;
        $[55] = t13;
    } else t13 = $[55];
    const cardContent = t13;
    let t14;
    if ($[56] !== cardContent || $[57] !== cardId || $[58] !== hasLink || $[59] !== isInViewMode || $[60] !== link || $[61] !== trackAndCategorizeError || $[62] !== trackSuccess) {
        t14 = hasLink ? /*#__PURE__*/ $cozmU.createElement((0, $QXwxo.CardSSR), {
            id: cardId,
            appearance: "inline",
            frameStyle: "show",
            ui: {
                theme: (0, $4yYAm.SmartLinkTheme).Black,
                clickableContainer: isInViewMode,
                size: (0, $4yYAm.SmartLinkSize).Large,
                removeBlockRestriction: true,
                hideBackground: true,
                hideElevation: true,
                hidePadding: true
            },
            url: link,
            onResolve: trackSuccess,
            onError: trackAndCategorizeError
        }, cardContent) : cardContent;
        $[56] = cardContent;
        $[57] = cardId;
        $[58] = hasLink;
        $[59] = isInViewMode;
        $[60] = link;
        $[61] = trackAndCategorizeError;
        $[62] = trackSuccess;
        $[63] = t14;
    } else t14 = $[63];
    let t15;
    if ($[64] !== backgroundColor || $[65] !== cardHeight || $[66] !== cardId || $[67] !== cornerRadiusOverride || $[68] !== cornerStyle || $[69] !== extensionLocalId || $[70] !== hasLink || $[71] !== isInViewMode || $[72] !== isManualVariant || $[73] !== t14 || $[74] !== textColor) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
            id: "small-card-v1-container",
            cardHeight: cardHeight,
            isInViewMode: isInViewMode,
            cardId: cardId,
            extensionLocalId: extensionLocalId,
            isEditable: isManualVariant,
            cornerStyle: cornerStyle,
            enableHubCornerRadius: true,
            cornerRadiusOverride: cornerRadiusOverride,
            hasLink: hasLink,
            backgroundColor: backgroundColor,
            textColor: textColor
        }, t14);
        $[64] = backgroundColor;
        $[65] = cardHeight;
        $[66] = cardId;
        $[67] = cornerRadiusOverride;
        $[68] = cornerStyle;
        $[69] = extensionLocalId;
        $[70] = hasLink;
        $[71] = isInViewMode;
        $[72] = isManualVariant;
        $[73] = t14;
        $[74] = textColor;
        $[75] = t15;
    } else t15 = $[75];
    return t15;
} : ({ cardDimensions: cardDimensions, cardId: cardId, link: link, title: title, imageSrc: imageSrc, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isInViewMode: isInViewMode, imageAltText: imageAltText, contentId: contentId, isManualVariant: isManualVariant, extensionLocalId: extensionLocalId, onCardSucceeded: onCardSucceeded, onCardFailed: onCardFailed, backgroundColor: backgroundColor, textColor: textColor, cornerStyle: cornerStyle, cornerRadius: cornerRadius })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const cornerRadiusOverride = isCornerRadiusEnabled ? (0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) : undefined;
    const cardHeight = cardDimensions.height;
    const hasLink = !!link;
    const { errorCardStatus: hasError, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess, isResolved: isResolved } = (0, $9QaSD.useTrackedSmartCardState)(cardId, link, onCardSucceeded, onCardFailed);
    const { setIsAvatarAvailable: setIsAvatarAvailable, setIsModifiedOnAvailable: setIsModifiedOnAvailable, shouldRenderMetadata: shouldRenderMetadata, shouldRenderOwnerInfo: shouldRenderOwnerInfo } = (0, $56bdef66f01f9e9c$export$28a088c1679c6579)({
        isOwnerInfoShown: isAvatarShown && hasLink,
        isModifiedOnShown: isPublishDateShown && hasLink
    });
    const displayImageSrc = (0, $37d9cdf0819e0905$export$71956575015d1f5)(link, imageSrc);
    const { hasImage: hasImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: displayImageSrc
    });
    const cardBodyItem = hasLink ? [
        title && /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: shouldRenderMetadata ? 2 : 3,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingXSmall
        }, title),
        hasError && !title && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            key: "unresolved-action",
            xcss: (0, $w6R6I.cx)($ddb6d1b8eae6067e$var$styles.unresolvedAction)
        }, /*#__PURE__*/ $cozmU.createElement((0, $7j5Rg.UnresolvedAction), null)),
        isResolved && !hasError && shouldRenderMetadata && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            testId: "small-card-v1-metadata",
            key: "metadata",
            space: "space.050",
            alignBlock: "center"
        }, shouldRenderOwnerInfo && /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $ddb6d1b8eae6067e$var$unboundedStyles.avatar
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $fEbt0.OwnedByGroupElement), {
            onRender: setIsAvatarAvailable
        })), !!isPublishDateShown && /*#__PURE__*/ $cozmU.createElement((0, $4buyQ.ModifiedOnElement), {
            color: "inherit",
            onRender: setIsModifiedOnAvailable
        }))
    ].filter(Boolean) : [
        /*#__PURE__*/ $cozmU.createElement((0, $68e47287a83f3aa2$export$474db65c3c394e1c), {
            key: "title",
            maxLine: 3,
            fontVariant: (0, $68e47287a83f3aa2$export$6eeb615c261d1c6b).HeadingXSmall
        }, title || formatMessage((0, $31e75c2dfb5de843$export$defe85febe8b728c).emptyStatePlaceholderTitle))
    ].filter(Boolean);
    const cardContent = /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "small-card-content",
        style: {
            height: cardHeight
        },
        className: (0, $hekY6.default)([
            $ddb6d1b8eae6067e$var$unboundedStyles.content
        ])
    }, hasImage && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($ddb6d1b8eae6067e$var$styles.image)
    }, /*#__PURE__*/ $cozmU.createElement((0, $dhLnb.ImageRenderer), {
        contentId: contentId,
        imageSrc: displayImageSrc,
        imageAlt: imageAltText,
        shouldShowExternalSiteImage: hasLink
    })), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
        testId: "small-card-body",
        space: "space.100",
        xcss: (0, $w6R6I.cx)($ddb6d1b8eae6067e$var$styles.body, hasImage && $ddb6d1b8eae6067e$var$styles.bodyWithImage, !hasImage && $ddb6d1b8eae6067e$var$styles.bodyWithoutImage),
        alignBlock: "center",
        alignInline: "start"
    }, cardBodyItem));
    return /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
        id: "small-card-v1-container",
        cardHeight: cardHeight,
        isInViewMode: isInViewMode,
        cardId: cardId,
        extensionLocalId: extensionLocalId,
        isEditable: isManualVariant,
        cornerStyle: cornerStyle,
        enableHubCornerRadius: true,
        cornerRadiusOverride: cornerRadiusOverride,
        hasLink: hasLink,
        backgroundColor: backgroundColor,
        textColor: textColor
    }, hasLink ? /*#__PURE__*/ $cozmU.createElement((0, $QXwxo.CardSSR), {
        id: cardId,
        appearance: "inline",
        frameStyle: "show",
        ui: {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: isInViewMode,
            size: (0, $4yYAm.SmartLinkSize).Large,
            removeBlockRestriction: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true
        },
        url: link,
        onResolve: trackSuccess,
        onError: trackAndCategorizeError
    }, cardContent) : cardContent);
};


















var $cJ0FD = parcelRequire("cJ0FD");







var $2cd66bff04bdca7b$exports = {};
$2cd66bff04bdca7b$exports = new URL("General.d0402e27.svg", import.meta.url).toString();


var $8ngiY = parcelRequire("8ngiY");









const $185c8639eab033dc$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    noResultsTitle: {
        id: "company-hub.cards-extension.dynamic-card-empty-state.no-results-title",
        defaultMessage: "Nothing yet. Check back soon."
    },
    noFilterTitle: {
        id: "company-hub.cards-extension.dynamic-card-empty-state.no-filter-title",
        defaultMessage: "Add filters to populate cards."
    }
});


const $7ba972e52fd00d2a$var$styles = {
    container: "_4t3i1osq",
    imageBase: "_bfhkysee",
    imageFlexibleHeight: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tkeidpf",
    imageFixedHeightMedium: "_4t3i11ux",
    imageFixedHeightLarge: "_4t3iuuw1",
    innerImageSmall: "_1bsb1wqb _4t3i1wqb _ca0q1b66 _u5f3u2gc _n3tdu2gc _19bv1b66",
    titleBase: "_11c8fhey _u5f3utpp _19bvutpp _ca0qutpp _n3tdutpp _syazi7uo",
    largeFont: "_11c81d4k",
    titleBlock: "_4t3ickbl",
    imageInline: "_1ul9ys9h _4t3i1osq",
    titleInline: "_4t3i1osq"
};
const $7ba972e52fd00d2a$var$SmallCard = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { imageSrc: imageSrc, title: title } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($7ba972e52fd00d2a$var$styles.imageBase, $7ba972e52fd00d2a$var$styles.imageInline);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== imageSrc) {
        t2 = imageSrc && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            alignBlock: "center",
            alignInline: "center",
            xcss: $7ba972e52fd00d2a$var$styles.innerImageSmall
        }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            src: imageSrc,
            alt: "no-result",
            testId: "no-result-image"
        }));
        $[1] = imageSrc;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            alignBlock: "center",
            alignInline: "center",
            xcss: t1
        }, t2);
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $w6R6I.cx)($7ba972e52fd00d2a$var$styles.titleBase, $7ba972e52fd00d2a$var$styles.titleInline);
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== title) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            alignBlock: "center",
            xcss: t4
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), title));
        $[6] = title;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== t3 || $[9] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            testId: "no-result-card-small",
            xcss: $7ba972e52fd00d2a$var$styles.container
        }, t3, t5);
        $[8] = t3;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : ({ imageSrc: imageSrc, title: title })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        testId: "no-result-card-small",
        xcss: $7ba972e52fd00d2a$var$styles.container
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        alignBlock: "center",
        alignInline: "center",
        xcss: (0, $w6R6I.cx)($7ba972e52fd00d2a$var$styles.imageBase, $7ba972e52fd00d2a$var$styles.imageInline)
    }, imageSrc && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $7ba972e52fd00d2a$var$styles.innerImageSmall
    }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
        src: imageSrc,
        alt: "no-result",
        testId: "no-result-image"
    }))), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        alignBlock: "center",
        xcss: (0, $w6R6I.cx)($7ba972e52fd00d2a$var$styles.titleBase, $7ba972e52fd00d2a$var$styles.titleInline)
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), title)));
};
const $7ba972e52fd00d2a$var$MediumLargeCard = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isImageFixedHeight: isImageFixedHeight, cardSize: t1, imageSrc: imageSrc, title: title } = t0;
    const cardSize = t1 === undefined ? (0, $hjUDQ.Height).MEDIUM : t1;
    const isLargeCard = cardSize === (0, $hjUDQ.Height).LARGE;
    const t2 = isImageFixedHeight ? isLargeCard ? $7ba972e52fd00d2a$var$styles.imageFixedHeightLarge : $7ba972e52fd00d2a$var$styles.imageFixedHeightMedium : $7ba972e52fd00d2a$var$styles.imageFlexibleHeight;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)($7ba972e52fd00d2a$var$styles.imageBase, t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== imageSrc) {
        t4 = imageSrc && /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
            src: imageSrc,
            alt: "no-result",
            testId: "no-result-image"
        });
        $[2] = imageSrc;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== t3 || $[5] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            alignBlock: "center",
            alignInline: "center",
            xcss: t3
        }, t4);
        $[4] = t3;
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    const t6 = isLargeCard && $7ba972e52fd00d2a$var$styles.largeFont;
    let t7;
    if ($[7] !== t6) {
        t7 = (0, $w6R6I.cx)($7ba972e52fd00d2a$var$styles.titleBase, $7ba972e52fd00d2a$var$styles.titleBlock, t6);
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== title) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), title);
        $[9] = title;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] !== t7 || $[12] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            alignBlock: "center",
            alignInline: "center",
            xcss: t7
        }, t8);
        $[11] = t7;
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== t5 || $[15] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
            testId: "no-result-card",
            space: "space.025",
            xcss: $7ba972e52fd00d2a$var$styles.container
        }, t5, t9);
        $[14] = t5;
        $[15] = t9;
        $[16] = t10;
    } else t10 = $[16];
    return t10;
} : ({ isImageFixedHeight: isImageFixedHeight, cardSize: cardSize = (0, $hjUDQ.Height).MEDIUM, imageSrc: imageSrc, title: title })=>{
    const isLargeCard = cardSize === (0, $hjUDQ.Height).LARGE;
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
        testId: "no-result-card",
        space: "space.025",
        xcss: $7ba972e52fd00d2a$var$styles.container
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        alignBlock: "center",
        alignInline: "center",
        xcss: (0, $w6R6I.cx)($7ba972e52fd00d2a$var$styles.imageBase, isImageFixedHeight ? isLargeCard ? $7ba972e52fd00d2a$var$styles.imageFixedHeightLarge : $7ba972e52fd00d2a$var$styles.imageFixedHeightMedium : $7ba972e52fd00d2a$var$styles.imageFlexibleHeight)
    }, imageSrc && /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
        src: imageSrc,
        alt: "no-result",
        testId: "no-result-image"
    })), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        alignBlock: "center",
        alignInline: "center",
        xcss: (0, $w6R6I.cx)($7ba972e52fd00d2a$var$styles.titleBase, $7ba972e52fd00d2a$var$styles.titleBlock, isLargeCard && $7ba972e52fd00d2a$var$styles.largeFont)
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), title)));
};
var $7ba972e52fd00d2a$export$fddf379e22a74b00 = /*#__PURE__*/ function(EmptyState) {
    EmptyState["NO_FILTER"] = "noFilter";
    EmptyState["NO_RESULTS"] = "noResults";
    return EmptyState;
}({});
const $7ba972e52fd00d2a$var$getStateContent = (state)=>{
    if (state === "noFilter") return {
        imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($8ngiY))),
        title: (0, $185c8639eab033dc$export$defe85febe8b728c).noFilterTitle
    };
    return {
        imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($2cd66bff04bdca7b$exports))),
        title: (0, $185c8639eab033dc$export$defe85febe8b728c).noResultsTitle
    };
};
const $7ba972e52fd00d2a$export$15b55049a5f7f585 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { cardSize: cardSize, layout: layout, cardDimensions: cardDimensions, state: state } = t0;
    const { height: height, minHeight: minHeight, maxHeight: maxHeight } = cardDimensions;
    let t1;
    if ($[0] !== state) {
        t1 = $7ba972e52fd00d2a$var$getStateContent(state);
        $[0] = state;
        $[1] = t1;
    } else t1 = $[1];
    const { imageSrc: imageSrc, title: title } = t1;
    if (layout === (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT && cardSize !== (0, $hjUDQ.Height).SMALL) {
        let t2;
        if ($[2] !== maxHeight || $[3] !== minHeight) {
            t2 = {
                minHeight: minHeight,
                maxHeight: maxHeight
            };
            $[2] = maxHeight;
            $[3] = minHeight;
            $[4] = t2;
        } else t2 = $[4];
        let t3;
        if ($[5] !== cardSize || $[6] !== imageSrc || $[7] !== title) {
            t3 = /*#__PURE__*/ $cozmU.createElement($7ba972e52fd00d2a$var$MediumLargeCard, {
                isImageFixedHeight: true,
                cardSize: cardSize,
                imageSrc: imageSrc,
                title: title
            });
            $[5] = cardSize;
            $[6] = imageSrc;
            $[7] = title;
            $[8] = t3;
        } else t3 = $[8];
        let t4;
        if ($[9] !== t2 || $[10] !== t3) {
            t4 = /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), null, /*#__PURE__*/ $cozmU.createElement("div", {
                style: t2
            }, t3));
            $[9] = t2;
            $[10] = t3;
            $[11] = t4;
        } else t4 = $[11];
        return t4;
    }
    let t2;
    if ($[12] !== cardSize || $[13] !== imageSrc || $[14] !== title) {
        t2 = cardSize === (0, $hjUDQ.Height).SMALL ? /*#__PURE__*/ $cozmU.createElement($7ba972e52fd00d2a$var$SmallCard, {
            imageSrc: imageSrc,
            title: title
        }) : /*#__PURE__*/ $cozmU.createElement($7ba972e52fd00d2a$var$MediumLargeCard, {
            imageSrc: imageSrc,
            title: title
        });
        $[12] = cardSize;
        $[13] = imageSrc;
        $[14] = title;
        $[15] = t2;
    } else t2 = $[15];
    let t3;
    if ($[16] !== height || $[17] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
            cardHeight: height
        }, t2);
        $[16] = height;
        $[17] = t2;
        $[18] = t3;
    } else t3 = $[18];
    return t3;
} : ({ cardSize: cardSize, layout: layout, cardDimensions: cardDimensions, state: state })=>{
    const { height: height, minHeight: minHeight, maxHeight: maxHeight } = cardDimensions;
    const { imageSrc: imageSrc, title: title } = $7ba972e52fd00d2a$var$getStateContent(state);
    if (layout === (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT && cardSize !== (0, $hjUDQ.Height).SMALL) return /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), null, /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            minHeight: minHeight,
            maxHeight: maxHeight
        }
    }, /*#__PURE__*/ $cozmU.createElement($7ba972e52fd00d2a$var$MediumLargeCard, {
        isImageFixedHeight: true,
        cardSize: cardSize,
        imageSrc: imageSrc,
        title: title
    })));
    return /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
        cardHeight: height
    }, cardSize === (0, $hjUDQ.Height).SMALL ? /*#__PURE__*/ $cozmU.createElement($7ba972e52fd00d2a$var$SmallCard, {
        imageSrc: imageSrc,
        title: title
    }) : /*#__PURE__*/ $cozmU.createElement($7ba972e52fd00d2a$var$MediumLargeCard, {
        imageSrc: imageSrc,
        title: title
    }));
};

















var $4ez2K = parcelRequire("4ez2K");









const $ddecac981a5dbce2$var$placeholderBackgroundColor = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $ddecac981a5dbce2$var$styles = {
    content: "_4t3i1osq",
    image: "_bfhkysee",
    imageFixedHeightMedium: "_4t3i11ux",
    imageFixedHeightLarge: "_4t3iuuw1",
    imageFlexibleHeight: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tkeidpf",
    imageSmall: "_1ul9i9or",
    body: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    bodySmall: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    itemCommon: "_4t3iftgi _bfhkysee",
    title: "_1bsbldb6",
    publishedDate: "_1bsb1osq",
    descriptionFirstLine: "_1bsbs0l4",
    descriptionSecondLine: "_1bsb1ame",
    titleLarge: "_1bsb12am",
    descriptionFirstLineLarge: "_1bsbuuw1",
    descriptionSecondLineLarge: "_1bsb1178"
};
const $ddecac981a5dbce2$var$ContentSmall = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.image, $ddecac981a5dbce2$var$styles.imageSmall)
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.body, $ddecac981a5dbce2$var$styles.bodySmall);
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, $ddecac981a5dbce2$var$styles.title)
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.default), {
            xcss: $ddecac981a5dbce2$var$styles.content
        }, t0, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
            space: "space.050",
            xcss: t1,
            alignBlock: "center"
        }, t2, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, $ddecac981a5dbce2$var$styles.publishedDate)
        })));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>/*#__PURE__*/ $cozmU.createElement((0, $4ez2K.default), {
        xcss: $ddecac981a5dbce2$var$styles.content
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.image, $ddecac981a5dbce2$var$styles.imageSmall)
    }), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
        space: "space.050",
        xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.body, $ddecac981a5dbce2$var$styles.bodySmall),
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, $ddecac981a5dbce2$var$styles.title)
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, $ddecac981a5dbce2$var$styles.publishedDate)
    })));
const $ddecac981a5dbce2$var$Content = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { isImageFixedHeight: isImageFixedHeight, cardSize: cardSize } = t0;
    const isLargeCard = cardSize === (0, $hjUDQ.Height).LARGE;
    const t1 = isImageFixedHeight ? isLargeCard ? $ddecac981a5dbce2$var$styles.imageFixedHeightLarge : $ddecac981a5dbce2$var$styles.imageFixedHeightMedium : $ddecac981a5dbce2$var$styles.imageFlexibleHeight;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.image, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: t2
        });
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const t4 = isLargeCard ? $ddecac981a5dbce2$var$styles.titleLarge : $ddecac981a5dbce2$var$styles.title;
    let t5;
    if ($[4] !== t4) {
        t5 = (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, t4);
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: t5
        });
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, $ddecac981a5dbce2$var$styles.publishedDate)
        });
        $[8] = t7;
    } else t7 = $[8];
    const t8 = isLargeCard ? $ddecac981a5dbce2$var$styles.descriptionFirstLineLarge : $ddecac981a5dbce2$var$styles.descriptionFirstLine;
    let t9;
    if ($[9] !== t8) {
        t9 = (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, t8);
        $[9] = t8;
        $[10] = t9;
    } else t9 = $[10];
    let t10;
    if ($[11] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: t9
        });
        $[11] = t9;
        $[12] = t10;
    } else t10 = $[12];
    const t11 = isLargeCard ? $ddecac981a5dbce2$var$styles.descriptionSecondLineLarge : $ddecac981a5dbce2$var$styles.descriptionSecondLine;
    let t12;
    if ($[13] !== t11) {
        t12 = (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, t11);
        $[13] = t11;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== t12) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: t12
        });
        $[15] = t12;
        $[16] = t13;
    } else t13 = $[16];
    let t14;
    if ($[17] !== t10 || $[18] !== t13 || $[19] !== t6) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
            space: "space.075",
            xcss: $ddecac981a5dbce2$var$styles.body
        }, t6, t7, t10, t13);
        $[17] = t10;
        $[18] = t13;
        $[19] = t6;
        $[20] = t14;
    } else t14 = $[20];
    let t15;
    if ($[21] !== t14 || $[22] !== t3) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.default), {
            direction: "column",
            xcss: $ddecac981a5dbce2$var$styles.content
        }, t3, t14);
        $[21] = t14;
        $[22] = t3;
        $[23] = t15;
    } else t15 = $[23];
    return t15;
} : ({ isImageFixedHeight: isImageFixedHeight, cardSize: cardSize })=>{
    const isLargeCard = cardSize === (0, $hjUDQ.Height).LARGE;
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.default), {
        direction: "column",
        xcss: $ddecac981a5dbce2$var$styles.content
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.image, isImageFixedHeight ? isLargeCard ? $ddecac981a5dbce2$var$styles.imageFixedHeightLarge : $ddecac981a5dbce2$var$styles.imageFixedHeightMedium : $ddecac981a5dbce2$var$styles.imageFlexibleHeight)
    }), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
        space: "space.075",
        xcss: $ddecac981a5dbce2$var$styles.body
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, isLargeCard ? $ddecac981a5dbce2$var$styles.titleLarge : $ddecac981a5dbce2$var$styles.title)
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, $ddecac981a5dbce2$var$styles.publishedDate)
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, isLargeCard ? $ddecac981a5dbce2$var$styles.descriptionFirstLineLarge : $ddecac981a5dbce2$var$styles.descriptionFirstLine)
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($ddecac981a5dbce2$var$styles.itemCommon, isLargeCard ? $ddecac981a5dbce2$var$styles.descriptionSecondLineLarge : $ddecac981a5dbce2$var$styles.descriptionSecondLine)
    })));
};
const $ddecac981a5dbce2$export$f67f215fe23c6b24 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { cardDimensions: cardDimensions, cardSize: cardSize, layout: layout } = t0;
    const { height: height, minHeight: minHeight, maxHeight: maxHeight } = cardDimensions;
    const containerId = `${cardSize}-card-loading-state`;
    if (layout === (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT && cardSize !== (0, $hjUDQ.Height).SMALL) {
        const t1 = `${containerId}-v2`;
        let t2;
        if ($[0] !== maxHeight || $[1] !== minHeight) {
            t2 = {
                minHeight: minHeight,
                maxHeight: maxHeight
            };
            $[0] = maxHeight;
            $[1] = minHeight;
            $[2] = t2;
        } else t2 = $[2];
        let t3;
        if ($[3] !== cardSize) {
            t3 = /*#__PURE__*/ $cozmU.createElement($ddecac981a5dbce2$var$Content, {
                isImageFixedHeight: true,
                cardSize: cardSize
            });
            $[3] = cardSize;
            $[4] = t3;
        } else t3 = $[4];
        let t4;
        if ($[5] !== t2 || $[6] !== t3) {
            t4 = /*#__PURE__*/ $cozmU.createElement("div", {
                style: t2
            }, t3);
            $[5] = t2;
            $[6] = t3;
            $[7] = t4;
        } else t4 = $[7];
        let t5;
        if ($[8] !== t1 || $[9] !== t4) {
            t5 = /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
                id: t1
            }, t4);
            $[8] = t1;
            $[9] = t4;
            $[10] = t5;
        } else t5 = $[10];
        return t5;
    }
    const t1 = `${containerId}-v1`;
    let t2;
    if ($[11] !== cardSize) {
        t2 = cardSize === (0, $hjUDQ.Height).SMALL ? /*#__PURE__*/ $cozmU.createElement($ddecac981a5dbce2$var$ContentSmall, null) : /*#__PURE__*/ $cozmU.createElement($ddecac981a5dbce2$var$Content, {
            cardSize: cardSize
        });
        $[11] = cardSize;
        $[12] = t2;
    } else t2 = $[12];
    let t3;
    if ($[13] !== height || $[14] !== t1 || $[15] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
            id: t1,
            cardHeight: height
        }, t2);
        $[13] = height;
        $[14] = t1;
        $[15] = t2;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
} : ({ cardDimensions: cardDimensions, cardSize: cardSize, layout: layout })=>{
    const { height: height, minHeight: minHeight, maxHeight: maxHeight } = cardDimensions;
    const containerId = `${cardSize}-card-loading-state`;
    if (layout === (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT && cardSize !== (0, $hjUDQ.Height).SMALL) return /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
        id: `${containerId}-v2`
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            minHeight: minHeight,
            maxHeight: maxHeight
        }
    }, /*#__PURE__*/ $cozmU.createElement($ddecac981a5dbce2$var$Content, {
        isImageFixedHeight: true,
        cardSize: cardSize
    })));
    return /*#__PURE__*/ $cozmU.createElement((0, $a962904bbde7c9a2$export$8a23e74e5cf3ca41), {
        id: `${containerId}-v1`,
        cardHeight: height
    }, cardSize === (0, $hjUDQ.Height).SMALL ? /*#__PURE__*/ $cozmU.createElement($ddecac981a5dbce2$var$ContentSmall, null) : /*#__PURE__*/ $cozmU.createElement($ddecac981a5dbce2$var$Content, {
        cardSize: cardSize
    }));
};





















var $kdlgT = parcelRequire("kdlgT");


var $aRvnq = parcelRequire("aRvnq");










const $a33e106b66cb0e0f$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    previous: {
        id: "company-hub.cards-extension.row-orientation.previous",
        defaultMessage: "Previous"
    },
    next: {
        id: "company-hub.cards-extension.row-orientation.next",
        defaultMessage: "Next"
    }
});


const $7583eda5bec7c437$var$styles = {
    footer: "_1bah1yb4 _4cvr1h6o _ca0q12x7",
    footerNav: "_zulp1b66 _18u01wug",
    iconBackgroundColor: "_2rko1rr0 _bfhk1bhr"
};
const $7583eda5bec7c437$export$d1f75a226e49cd83 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { isStacked: isStacked, showAIDisclaimer: showAIDisclaimer, allCardsShown: allCardsShown, isAtBeginning: isAtBeginning, isAtEnd: isAtEnd, scrollToPrevious: scrollToPrevious, scrollToNext: scrollToNext } = t0;
    const showFooter = showAIDisclaimer || !isStacked && !allCardsShown;
    if (!showFooter) return null;
    const t1 = isStacked && !showAIDisclaimer && $7583eda5bec7c437$var$styles.footerNav;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $w6R6I.cx)($7583eda5bec7c437$var$styles.footer, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== showAIDisclaimer) {
        t3 = showAIDisclaimer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $32chb.CardsAIDisclaimer), null);
        $[2] = showAIDisclaimer;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== allCardsShown || $[5] !== isAtBeginning || $[6] !== isAtEnd || $[7] !== isStacked || $[8] !== scrollToNext || $[9] !== scrollToPrevious) {
        t4 = !isStacked && !allCardsShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            xcss: $7583eda5bec7c437$var$styles.footerNav
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            xcss: $7583eda5bec7c437$var$styles.iconBackgroundColor
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            shape: "circle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
            isDisabled: isAtBeginning,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a33e106b66cb0e0f$export$defe85febe8b728c).previous),
            onClick: scrollToPrevious
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            xcss: $7583eda5bec7c437$var$styles.iconBackgroundColor
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            shape: "circle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
            isDisabled: isAtEnd,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a33e106b66cb0e0f$export$defe85febe8b728c).next),
            onClick: scrollToNext
        })));
        $[4] = allCardsShown;
        $[5] = isAtBeginning;
        $[6] = isAtEnd;
        $[7] = isStacked;
        $[8] = scrollToNext;
        $[9] = scrollToPrevious;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.050",
            testId: "link-cards-content-cards-row-navigation",
            xcss: t2
        }, t3, t4);
        $[11] = t2;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
} : ({ isStacked: isStacked, showAIDisclaimer: showAIDisclaimer, allCardsShown: allCardsShown, isAtBeginning: isAtBeginning, isAtEnd: isAtEnd, scrollToPrevious: scrollToPrevious, scrollToNext: scrollToNext })=>{
    const showFooter = showAIDisclaimer || !isStacked && !allCardsShown;
    if (!showFooter) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.050",
        testId: "link-cards-content-cards-row-navigation",
        xcss: (0, $w6R6I.cx)($7583eda5bec7c437$var$styles.footer, isStacked && !showAIDisclaimer && $7583eda5bec7c437$var$styles.footerNav)
    }, showAIDisclaimer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $32chb.CardsAIDisclaimer), null), !isStacked && !allCardsShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        xcss: $7583eda5bec7c437$var$styles.footerNav
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        xcss: $7583eda5bec7c437$var$styles.iconBackgroundColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        shape: "circle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
        isDisabled: isAtBeginning,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a33e106b66cb0e0f$export$defe85febe8b728c).previous),
        onClick: scrollToPrevious
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        xcss: $7583eda5bec7c437$var$styles.iconBackgroundColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        shape: "circle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
        isDisabled: isAtEnd,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a33e106b66cb0e0f$export$defe85febe8b728c).next),
        onClick: scrollToNext
    }))));
};


const $acbc23a21ff09bf1$var$styles = {
    cardWrapper: "_4t3i1osq"
};
const $acbc23a21ff09bf1$var$CARD_SIZE_FLEXIBLE_MAP = {
    [(0, $hjUDQ.Height).SMALL]: (0, $ddb6d1b8eae6067e$export$5c35843a47cb7bc4),
    [(0, $hjUDQ.Height).MEDIUM]: (0, $3f1cee5e0d0614d4$export$42440eb4dfc95ce7),
    [(0, $hjUDQ.Height).LARGE]: (0, $dabbc9a27c7fab5d$export$299421c7aa71f32d)
};
const $acbc23a21ff09bf1$var$CARD_SIZE_FIXED_MAP = {
    [(0, $hjUDQ.Height).SMALL]: (0, $ddb6d1b8eae6067e$export$5c35843a47cb7bc4),
    [(0, $hjUDQ.Height).MEDIUM]: (0, $47140f834e4043e2$export$b38e9910221b4e7e),
    [(0, $hjUDQ.Height).LARGE]: (0, $166f78176fd22bef$export$a59c193ce67944a7)
};
const $acbc23a21ff09bf1$var$getCardComponent = (cardSize, layout)=>{
    if (layout === (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT) return $acbc23a21ff09bf1$var$CARD_SIZE_FIXED_MAP[cardSize] ?? (0, $47140f834e4043e2$export$b38e9910221b4e7e);
     // Default to flexible cards (used for FLEXIBLE_IMAGE_HEIGHT and undefined layout)
    return $acbc23a21ff09bf1$var$CARD_SIZE_FLEXIBLE_MAP[cardSize] ?? (0, $3f1cee5e0d0614d4$export$42440eb4dfc95ce7);
};
const $acbc23a21ff09bf1$export$bab15f92b6d84cb6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { extensionLocalId: extensionLocalId, parameters: parameters, isCompanyHub: isCompanyHub, isTargetAudience: isTargetAudience, isInViewMode: isInViewMode, contentId: contentId } = t0;
    const validatedCardParams = (0, $f73aa100a9fdb106$export$9a666555160249c1)(parameters);
    const { renderVariant: renderVariant, size: size, isDescriptionShown: isDescriptionShown, layout: layout } = validatedCardParams;
    const isDynamicCards = renderVariant === (0, $hjUDQ.RenderVariant).DYNAMIC;
    let t1;
    if ($[0] !== layout || $[1] !== size) {
        t1 = (0, $7ee74d072d6273e0$export$90cc9ab68d35b5b9)({
            cardSize: size,
            layout: layout
        });
        $[0] = layout;
        $[1] = size;
        $[2] = t1;
    } else t1 = $[2];
    const cardDimensions = t1;
    let t2;
    if ($[3] !== layout || $[4] !== size) {
        t2 = $acbc23a21ff09bf1$var$getCardComponent(size, layout);
        $[3] = layout;
        $[4] = size;
        $[5] = t2;
    } else t2 = $[5];
    const CardComponent = t2;
    const showDescription = renderVariant === (0, $hjUDQ.RenderVariant).MANUAL || isDescriptionShown !== false;
    const shouldAutoscrollCards = Boolean(isCompanyHub && validatedCardParams.isAutoscrollEnabled && isInViewMode);
    const CardsContentComponent = isDynamicCards ? $acbc23a21ff09bf1$var$DynamicCardsContent : $acbc23a21ff09bf1$var$ManualCardsContent;
    let t3;
    if ($[6] !== CardComponent || $[7] !== CardsContentComponent || $[8] !== cardDimensions || $[9] !== contentId || $[10] !== extensionLocalId || $[11] !== isCompanyHub || $[12] !== isInViewMode || $[13] !== isTargetAudience || $[14] !== shouldAutoscrollCards || $[15] !== showDescription || $[16] !== validatedCardParams) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CardsContentComponent, {
            extensionLocalId: extensionLocalId,
            parameters: validatedCardParams,
            isCompanyHub: isCompanyHub,
            isTargetAudience: isTargetAudience,
            isInViewMode: isInViewMode,
            contentId: contentId,
            cardDimensions: cardDimensions,
            shouldAutoscrollCards: shouldAutoscrollCards,
            CardComponent: CardComponent,
            showDescription: showDescription
        });
        $[6] = CardComponent;
        $[7] = CardsContentComponent;
        $[8] = cardDimensions;
        $[9] = contentId;
        $[10] = extensionLocalId;
        $[11] = isCompanyHub;
        $[12] = isInViewMode;
        $[13] = isTargetAudience;
        $[14] = shouldAutoscrollCards;
        $[15] = showDescription;
        $[16] = validatedCardParams;
        $[17] = t3;
    } else t3 = $[17];
    return t3;
} : ({ extensionLocalId: extensionLocalId, parameters: parameters, isCompanyHub: isCompanyHub, isTargetAudience: isTargetAudience, isInViewMode: isInViewMode, contentId: contentId })=>{
    const validatedCardParams = (0, $f73aa100a9fdb106$export$9a666555160249c1)(parameters);
    const { renderVariant: renderVariant, size: size, isDescriptionShown: isDescriptionShown, layout: layout } = validatedCardParams;
    const isDynamicCards = renderVariant === (0, $hjUDQ.RenderVariant).DYNAMIC;
    const cardDimensions = (0, $7ee74d072d6273e0$export$90cc9ab68d35b5b9)({
        cardSize: size,
        layout: layout
    });
    const CardComponent = $acbc23a21ff09bf1$var$getCardComponent(size, layout); // checking specifically if isDescriptionShown is false because if it's undefined,
    // it means that the dynamic cards were created from before and we want to show the descriptions they had
    const showDescription = renderVariant === (0, $hjUDQ.RenderVariant).MANUAL || isDescriptionShown !== false; /* only autoscroll cards when all below conditions meet:
                                                                                                   * 1. is in company hub
                                                                                                   * 2. orientation is in row (handled in validateCardParams)
                                                                                                   * 3. Autoscroll toggle is on
                                                                                                   * 4. user is in renderer
                                                                                                   * cards macro now includes features that are company hub specific. These features will be hidden for macros in non-hub pages
                                                                                                   * for more details refer to https://hello.atlassian.net/wiki/spaces/CLI/pages/4436003008/Hub+only+features
                                                                                                   */ 
    const shouldAutoscrollCards = Boolean(isCompanyHub && validatedCardParams.isAutoscrollEnabled && isInViewMode);
    const CardsContentComponent = isDynamicCards ? $acbc23a21ff09bf1$var$DynamicCardsContent : $acbc23a21ff09bf1$var$ManualCardsContent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CardsContentComponent, {
        extensionLocalId: extensionLocalId,
        parameters: validatedCardParams,
        isCompanyHub: isCompanyHub,
        isTargetAudience: isTargetAudience,
        isInViewMode: isInViewMode,
        contentId: contentId,
        cardDimensions: cardDimensions,
        shouldAutoscrollCards: shouldAutoscrollCards,
        CardComponent: CardComponent,
        showDescription: showDescription
    });
};
const $acbc23a21ff09bf1$var$CardsContainer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { extensionLocalId: extensionLocalId, numberOfCards: numberOfCards, cardDimensions: cardDimensions, isStacked: isStacked, alignment: alignment, cards: cards, renderCard: renderCard, isInViewMode: isInViewMode, shouldAutoscrollCards: shouldAutoscrollCards, showAIDisclaimer: showAIDisclaimer } = t0;
    let t1;
    if ($[0] !== alignment || $[1] !== cardDimensions || $[2] !== cards || $[3] !== extensionLocalId || $[4] !== isInViewMode || $[5] !== isStacked || $[6] !== numberOfCards || $[7] !== renderCard || $[8] !== shouldAutoscrollCards || $[9] !== showAIDisclaimer) {
        t1 = shouldAutoscrollCards ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $508f24952640e58a$export$ac70d6b7d7a09503), {
            testId: "cards-extension",
            numberOfCards: numberOfCards,
            cardDimensions: cardDimensions,
            cards: cards,
            renderCard: renderCard,
            showAIDisclaimer: showAIDisclaimer
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1036ce2280d59186$export$37f8d84bb48ae4b7), {
            testId: "cards-extension",
            extensionLocalId: extensionLocalId,
            numberOfCards: numberOfCards,
            cardDimensions: cardDimensions,
            isStacked: isStacked,
            isInViewMode: isInViewMode,
            alignment: alignment,
            cards: cards,
            renderCard: renderCard,
            showAIDisclaimer: showAIDisclaimer,
            cardsContentFooter: (0, $7583eda5bec7c437$export$d1f75a226e49cd83)
        });
        $[0] = alignment;
        $[1] = cardDimensions;
        $[2] = cards;
        $[3] = extensionLocalId;
        $[4] = isInViewMode;
        $[5] = isStacked;
        $[6] = numberOfCards;
        $[7] = renderCard;
        $[8] = shouldAutoscrollCards;
        $[9] = showAIDisclaimer;
        $[10] = t1;
    } else t1 = $[10];
    return t1;
} : ({ extensionLocalId: extensionLocalId, numberOfCards: numberOfCards, cardDimensions: cardDimensions, isStacked: isStacked, alignment: alignment, cards: cards, renderCard: renderCard, isInViewMode: isInViewMode, shouldAutoscrollCards: shouldAutoscrollCards, showAIDisclaimer: showAIDisclaimer })=>shouldAutoscrollCards ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $508f24952640e58a$export$ac70d6b7d7a09503), {
        testId: "cards-extension",
        numberOfCards: numberOfCards,
        cardDimensions: cardDimensions,
        cards: cards,
        renderCard: renderCard,
        showAIDisclaimer: showAIDisclaimer
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1036ce2280d59186$export$37f8d84bb48ae4b7), {
        testId: "cards-extension",
        extensionLocalId: extensionLocalId,
        numberOfCards: numberOfCards,
        cardDimensions: cardDimensions,
        isStacked: isStacked,
        isInViewMode: isInViewMode,
        alignment: alignment,
        cards: cards,
        renderCard: renderCard,
        showAIDisclaimer: showAIDisclaimer,
        cardsContentFooter: (0, $7583eda5bec7c437$export$d1f75a226e49cd83)
    });
const $acbc23a21ff09bf1$var$ManualCardsContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(53);
    const { extensionLocalId: extensionLocalId, parameters: parameters, contentId: contentId, cardDimensions: cardDimensions, CardComponent: CardComponent, shouldAutoscrollCards: shouldAutoscrollCards, isCompanyHub: isCompanyHub, isTargetAudience: isTargetAudience, isInViewMode: t1, showDescription: t2 } = t0;
    const isInViewMode = t1 === undefined ? false : t1;
    const showDescription = t2 === undefined ? true : t2;
    const { isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, cards: cards, isSegmentationShown: isSegmentationShown, isLabelShown: isLabelShown, orientation: orientation, alignment: alignment, audienceSegmentationGroupIds: audienceSegmentationGroupIds, segmentationTarget: segmentationTarget, renderVariant: renderVariant, backgroundColor: backgroundColor, textColor: textColor, borderColor: borderColor, cornerRadius: cornerRadius, cornerStyle: cornerStyle } = parameters;
    const { areAllItemsLoaded: areAllItemsLoaded, itemFailureError: itemFailureError, onItemSucceeded: onItemSucceeded, onItemFailed: onItemFailed } = (0, $b2481ad40679111c$export$c6c5cac0793c45d9)(cards);
    let t3;
    if ($[0] !== audienceSegmentationGroupIds || $[1] !== cards || $[2] !== isCompanyHub || $[3] !== isInViewMode || $[4] !== isSegmentationShown || $[5] !== isTargetAudience || $[6] !== renderVariant || $[7] !== segmentationTarget) {
        t3 = {
            isCompanyHub: isCompanyHub,
            isSegmentationShown: isSegmentationShown,
            isTargetAudience: isTargetAudience,
            cards: cards,
            isInViewMode: isInViewMode,
            segmentationTarget: segmentationTarget,
            audienceSegmentationGroupIds: audienceSegmentationGroupIds,
            renderVariant: renderVariant
        };
        $[0] = audienceSegmentationGroupIds;
        $[1] = cards;
        $[2] = isCompanyHub;
        $[3] = isInViewMode;
        $[4] = isSegmentationShown;
        $[5] = isTargetAudience;
        $[6] = renderVariant;
        $[7] = segmentationTarget;
        $[8] = t3;
    } else t3 = $[8];
    const { filteredCards: filteredCards } = (0, $e4389e92f972a9fa$export$93c098ff84870fcb)(t3);
    const { experienceSuccessComponent: experienceSuccessComponent, experienceStopComponent: experienceStopComponent } = (0, $cfM7x.useProductDependencies)();
    let t4;
    if ($[9] !== experienceSuccessComponent) {
        t4 = experienceSuccessComponent || $acbc23a21ff09bf1$var$_temp;
        $[9] = experienceSuccessComponent;
        $[10] = t4;
    } else t4 = $[10];
    const ExperienceSuccess = t4;
    let t5;
    if ($[11] !== experienceStopComponent) {
        t5 = experienceStopComponent || $acbc23a21ff09bf1$var$_temp2;
        $[11] = experienceStopComponent;
        $[12] = t5;
    } else t5 = $[12];
    const ExperienceError = t5;
    const numberOfCards = filteredCards.length;
    let t6;
    if ($[13] !== CardComponent || $[14] !== backgroundColor || $[15] !== borderColor || $[16] !== cardDimensions || $[17] !== contentId || $[18] !== cornerRadius || $[19] !== cornerStyle || $[20] !== extensionLocalId || $[21] !== isAvatarShown || $[22] !== isIconShown || $[23] !== isInViewMode || $[24] !== isLabelShown || $[25] !== isPaddingEnabled || $[26] !== isPublishDateShown || $[27] !== isSocialStatsShown || $[28] !== onItemFailed || $[29] !== onItemSucceeded || $[30] !== showDescription || $[31] !== textColor) {
        t6 = (card)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
                space: "space.075",
                key: card.cardId,
                xcss: (0, $w6R6I.cx)($acbc23a21ff09bf1$var$styles.cardWrapper)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CardComponent, {
                contentId: contentId,
                cardDimensions: cardDimensions,
                isPaddingEnabled: isPaddingEnabled,
                isAvatarShown: isAvatarShown,
                isPublishDateShown: isPublishDateShown,
                isSocialStatsShown: isSocialStatsShown,
                isIconShown: isIconShown,
                isInViewMode: isInViewMode,
                isLabelShown: isLabelShown,
                onCardSucceeded: onItemSucceeded,
                onCardFailed: onItemFailed,
                isManualVariant: true,
                extensionLocalId: extensionLocalId,
                backgroundColor: backgroundColor,
                textColor: textColor,
                borderColor: borderColor,
                cornerRadius: cornerRadius,
                cornerStyle: cornerStyle,
                showDescription: showDescription,
                ...card
            }));
        $[13] = CardComponent;
        $[14] = backgroundColor;
        $[15] = borderColor;
        $[16] = cardDimensions;
        $[17] = contentId;
        $[18] = cornerRadius;
        $[19] = cornerStyle;
        $[20] = extensionLocalId;
        $[21] = isAvatarShown;
        $[22] = isIconShown;
        $[23] = isInViewMode;
        $[24] = isLabelShown;
        $[25] = isPaddingEnabled;
        $[26] = isPublishDateShown;
        $[27] = isSocialStatsShown;
        $[28] = onItemFailed;
        $[29] = onItemSucceeded;
        $[30] = showDescription;
        $[31] = textColor;
        $[32] = t6;
    } else t6 = $[32];
    const renderManualCard = t6;
    const t7 = orientation === (0, $ikd73.Orientation).STACKED;
    let t8;
    if ($[33] !== alignment || $[34] !== cardDimensions || $[35] !== extensionLocalId || $[36] !== filteredCards || $[37] !== isInViewMode || $[38] !== numberOfCards || $[39] !== renderManualCard || $[40] !== shouldAutoscrollCards || $[41] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($acbc23a21ff09bf1$var$CardsContainer, {
            shouldAutoscrollCards: shouldAutoscrollCards,
            numberOfCards: numberOfCards,
            cardDimensions: cardDimensions,
            isStacked: t7,
            isInViewMode: isInViewMode,
            alignment: alignment,
            extensionLocalId: extensionLocalId,
            cards: filteredCards,
            renderCard: renderManualCard
        });
        $[33] = alignment;
        $[34] = cardDimensions;
        $[35] = extensionLocalId;
        $[36] = filteredCards;
        $[37] = isInViewMode;
        $[38] = numberOfCards;
        $[39] = renderManualCard;
        $[40] = shouldAutoscrollCards;
        $[41] = t7;
        $[42] = t8;
    } else t8 = $[42];
    let t9;
    if ($[43] !== ExperienceSuccess || $[44] !== areAllItemsLoaded) {
        t9 = areAllItemsLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceSuccess, null);
        $[43] = ExperienceSuccess;
        $[44] = areAllItemsLoaded;
        $[45] = t9;
    } else t9 = $[45];
    let t10;
    if ($[46] !== ExperienceError || $[47] !== itemFailureError) {
        t10 = !!itemFailureError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceError, {
            error: itemFailureError
        });
        $[46] = ExperienceError;
        $[47] = itemFailureError;
        $[48] = t10;
    } else t10 = $[48];
    let t11;
    if ($[49] !== t10 || $[50] !== t8 || $[51] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t8, t9, t10);
        $[49] = t10;
        $[50] = t8;
        $[51] = t9;
        $[52] = t11;
    } else t11 = $[52];
    return t11;
} : ({ extensionLocalId: extensionLocalId, parameters: parameters, contentId: contentId, cardDimensions: cardDimensions, CardComponent: CardComponent, shouldAutoscrollCards: shouldAutoscrollCards, isCompanyHub: isCompanyHub, isTargetAudience: isTargetAudience, isInViewMode: isInViewMode = false, showDescription: showDescription = true })=>{
    const { isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, cards: cards, isSegmentationShown: isSegmentationShown, isLabelShown: isLabelShown, orientation: orientation, alignment: alignment, audienceSegmentationGroupIds: audienceSegmentationGroupIds, segmentationTarget: segmentationTarget, renderVariant: renderVariant, backgroundColor: backgroundColor, textColor: textColor, borderColor: borderColor, cornerRadius: cornerRadius, cornerStyle: cornerStyle } = parameters;
    const { areAllItemsLoaded: areAllItemsLoaded, itemFailureError: itemFailureError, onItemSucceeded: onItemSucceeded, onItemFailed: onItemFailed } = (0, $b2481ad40679111c$export$c6c5cac0793c45d9)(cards);
    const { filteredCards: filteredCards } = (0, $e4389e92f972a9fa$export$93c098ff84870fcb)({
        isCompanyHub: isCompanyHub,
        isSegmentationShown: isSegmentationShown,
        isTargetAudience: isTargetAudience,
        cards: cards,
        isInViewMode: isInViewMode,
        segmentationTarget: segmentationTarget,
        audienceSegmentationGroupIds: audienceSegmentationGroupIds,
        renderVariant: renderVariant
    });
    const { experienceSuccessComponent: experienceSuccessComponent, experienceStopComponent: experienceStopComponent } = (0, $cfM7x.useProductDependencies)();
    const ExperienceSuccess = experienceSuccessComponent || (()=>null);
    const ExperienceError = experienceStopComponent || (()=>null);
    const numberOfCards = filteredCards.length;
    const renderManualCard = (0, $cozmU.useCallback)((card)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.075",
            key: card.cardId,
            xcss: (0, $w6R6I.cx)($acbc23a21ff09bf1$var$styles.cardWrapper)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CardComponent, {
            contentId: contentId,
            cardDimensions: cardDimensions,
            isPaddingEnabled: isPaddingEnabled,
            isAvatarShown: isAvatarShown,
            isPublishDateShown: isPublishDateShown,
            isSocialStatsShown: isSocialStatsShown,
            isIconShown: isIconShown,
            isInViewMode: isInViewMode,
            isLabelShown: isLabelShown,
            onCardSucceeded: onItemSucceeded,
            onCardFailed: onItemFailed,
            isManualVariant: true,
            extensionLocalId: extensionLocalId,
            backgroundColor: backgroundColor,
            textColor: textColor,
            borderColor: borderColor,
            cornerRadius: cornerRadius,
            cornerStyle: cornerStyle,
            showDescription: showDescription,
            ...card
        }));
    }, [
        extensionLocalId,
        contentId,
        cardDimensions,
        isPaddingEnabled,
        isAvatarShown,
        isPublishDateShown,
        isLabelShown,
        isSocialStatsShown,
        isIconShown,
        showDescription,
        isInViewMode,
        onItemSucceeded,
        onItemFailed,
        CardComponent,
        backgroundColor,
        textColor,
        borderColor,
        cornerRadius,
        cornerStyle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($acbc23a21ff09bf1$var$CardsContainer, {
        shouldAutoscrollCards: shouldAutoscrollCards,
        numberOfCards: numberOfCards,
        cardDimensions: cardDimensions,
        isStacked: orientation === (0, $ikd73.Orientation).STACKED,
        isInViewMode: isInViewMode,
        alignment: alignment,
        extensionLocalId: extensionLocalId,
        cards: filteredCards,
        renderCard: renderManualCard
    }), areAllItemsLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceSuccess, null), !!itemFailureError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceError, {
        error: itemFailureError
    }));
};
const $acbc23a21ff09bf1$var$DynamicCardsContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(60);
    const { extensionLocalId: extensionLocalId, parameters: parameters, contentId: contentId, cardDimensions: cardDimensions, CardComponent: CardComponent, shouldAutoscrollCards: shouldAutoscrollCards, isCompanyHub: isCompanyHub, isTargetAudience: isTargetAudience, isInViewMode: t1, showDescription: showDescription } = t0;
    const isInViewMode = t1 === undefined ? false : t1;
    const { size: size, orientation: orientation, alignment: alignment, isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, filters: filters, isSegmentationShown: isSegmentationShown, audienceSegmentationGroupIds: audienceSegmentationGroupIds, segmentationTarget: segmentationTarget, renderVariant: renderVariant, backgroundColor: backgroundColor, textColor: textColor, borderColor: borderColor, cornerStyle: cornerStyle, layout: layout } = parameters;
    const { cards: cards, loading: loading, error: error } = (0, $6d3e30142bf823a9$export$5fe928848609fec7)(parameters);
    const { areAllItemsLoaded: areAllItemsLoaded, itemFailureError: itemFailureError, onItemSucceeded: onItemSucceeded, onItemFailed: onItemFailed } = (0, $b2481ad40679111c$export$c6c5cac0793c45d9)(cards);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $cfM7x.useProductDependencies)();
    const { experienceSuccessComponent: experienceSuccessComponent, experienceStopComponent: experienceStopComponent } = (0, $cfM7x.useProductDependencies)();
    let t2;
    if ($[0] !== experienceSuccessComponent) {
        t2 = experienceSuccessComponent || $acbc23a21ff09bf1$var$_temp3;
        $[0] = experienceSuccessComponent;
        $[1] = t2;
    } else t2 = $[1];
    const ExperienceSuccess = t2;
    let t3;
    if ($[2] !== experienceStopComponent) {
        t3 = experienceStopComponent || $acbc23a21ff09bf1$var$_temp4;
        $[2] = experienceStopComponent;
        $[3] = t3;
    } else t3 = $[3];
    const ExperienceError = t3;
    const numberOfCards = cards.length;
    const showAIDisclaimer = isAdminHubAIEnabled && showDescription && numberOfCards > 0 && size !== (0, $hjUDQ.Height).SMALL;
    let cardsWithEmptyDefault = cards;
    if (!filters || !numberOfCards || loading) {
        let t4;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = (0, (/*@__PURE__*/$parcel$interopDefault($6461dd9a11ba8e64$exports)))(3, $acbc23a21ff09bf1$var$_temp5);
            $[4] = t4;
        } else t4 = $[4];
        cardsWithEmptyDefault = t4;
    }
    let t4;
    if ($[5] !== audienceSegmentationGroupIds || $[6] !== cardsWithEmptyDefault || $[7] !== isCompanyHub || $[8] !== isInViewMode || $[9] !== isSegmentationShown || $[10] !== isTargetAudience || $[11] !== renderVariant || $[12] !== segmentationTarget) {
        t4 = {
            isCompanyHub: isCompanyHub,
            isSegmentationShown: isSegmentationShown,
            isTargetAudience: isTargetAudience,
            cards: cardsWithEmptyDefault,
            isInViewMode: isInViewMode,
            segmentationTarget: segmentationTarget,
            audienceSegmentationGroupIds: audienceSegmentationGroupIds,
            renderVariant: renderVariant
        };
        $[5] = audienceSegmentationGroupIds;
        $[6] = cardsWithEmptyDefault;
        $[7] = isCompanyHub;
        $[8] = isInViewMode;
        $[9] = isSegmentationShown;
        $[10] = isTargetAudience;
        $[11] = renderVariant;
        $[12] = segmentationTarget;
        $[13] = t4;
    } else t4 = $[13];
    const { filteredCards: filteredCards } = (0, $e4389e92f972a9fa$export$93c098ff84870fcb)(t4);
    let t5;
    if ($[14] !== CardComponent || $[15] !== backgroundColor || $[16] !== borderColor || $[17] !== cardDimensions || $[18] !== contentId || $[19] !== cornerStyle || $[20] !== filters || $[21] !== isAvatarShown || $[22] !== isIconShown || $[23] !== isInViewMode || $[24] !== isPaddingEnabled || $[25] !== isPublishDateShown || $[26] !== isSocialStatsShown || $[27] !== layout || $[28] !== loading || $[29] !== numberOfCards || $[30] !== onItemFailed || $[31] !== onItemSucceeded || $[32] !== showDescription || $[33] !== size || $[34] !== textColor) {
        t5 = (card)=>{
            const isResultEmpty = !numberOfCards || !card?.link;
            if (!filters) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ba972e52fd00d2a$export$15b55049a5f7f585), {
                cardDimensions: cardDimensions,
                cardSize: size,
                layout: layout,
                state: (0, $7ba972e52fd00d2a$export$fddf379e22a74b00).NO_FILTER
            });
            if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ddecac981a5dbce2$export$f67f215fe23c6b24), {
                cardDimensions: cardDimensions,
                cardSize: size,
                layout: layout
            });
            if (isResultEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ba972e52fd00d2a$export$15b55049a5f7f585), {
                cardDimensions: cardDimensions,
                cardSize: size,
                layout: layout,
                state: (0, $7ba972e52fd00d2a$export$fddf379e22a74b00).NO_RESULTS
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
                space: "space.075",
                key: card.cardId,
                xcss: (0, $w6R6I.cx)($acbc23a21ff09bf1$var$styles.cardWrapper)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CardComponent, {
                contentId: contentId,
                cardDimensions: cardDimensions,
                isPaddingEnabled: isPaddingEnabled,
                isAvatarShown: isAvatarShown,
                isPublishDateShown: isPublishDateShown,
                isSocialStatsShown: isSocialStatsShown,
                isIconShown: isIconShown,
                isInViewMode: !!isInViewMode,
                onCardSucceeded: onItemSucceeded,
                onCardFailed: onItemFailed,
                backgroundColor: backgroundColor,
                textColor: textColor,
                borderColor: borderColor,
                cornerStyle: cornerStyle,
                enableSnippetRenderer: true,
                showDescription: showDescription,
                ...card
            }));
        };
        $[14] = CardComponent;
        $[15] = backgroundColor;
        $[16] = borderColor;
        $[17] = cardDimensions;
        $[18] = contentId;
        $[19] = cornerStyle;
        $[20] = filters;
        $[21] = isAvatarShown;
        $[22] = isIconShown;
        $[23] = isInViewMode;
        $[24] = isPaddingEnabled;
        $[25] = isPublishDateShown;
        $[26] = isSocialStatsShown;
        $[27] = layout;
        $[28] = loading;
        $[29] = numberOfCards;
        $[30] = onItemFailed;
        $[31] = onItemSucceeded;
        $[32] = showDescription;
        $[33] = size;
        $[34] = textColor;
        $[35] = t5;
    } else t5 = $[35];
    const renderDynamicCard = t5;
    const t6 = orientation === (0, $ikd73.Orientation).STACKED;
    let t7;
    if ($[36] !== alignment || $[37] !== cardDimensions || $[38] !== extensionLocalId || $[39] !== filteredCards || $[40] !== isInViewMode || $[41] !== numberOfCards || $[42] !== renderDynamicCard || $[43] !== shouldAutoscrollCards || $[44] !== showAIDisclaimer || $[45] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($acbc23a21ff09bf1$var$CardsContainer, {
            shouldAutoscrollCards: shouldAutoscrollCards,
            numberOfCards: numberOfCards,
            cardDimensions: cardDimensions,
            isStacked: t6,
            isInViewMode: isInViewMode,
            alignment: alignment,
            extensionLocalId: extensionLocalId,
            cards: filteredCards,
            renderCard: renderDynamicCard,
            showAIDisclaimer: showAIDisclaimer
        });
        $[36] = alignment;
        $[37] = cardDimensions;
        $[38] = extensionLocalId;
        $[39] = filteredCards;
        $[40] = isInViewMode;
        $[41] = numberOfCards;
        $[42] = renderDynamicCard;
        $[43] = shouldAutoscrollCards;
        $[44] = showAIDisclaimer;
        $[45] = t6;
        $[46] = t7;
    } else t7 = $[46];
    let t8;
    if ($[47] !== error) {
        t8 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f15264ed5f302311$export$533cd3269e981a31), {
            error: error
        });
        $[47] = error;
        $[48] = t8;
    } else t8 = $[48];
    let t9;
    if ($[49] !== ExperienceSuccess || $[50] !== areAllItemsLoaded) {
        t9 = areAllItemsLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceSuccess, null);
        $[49] = ExperienceSuccess;
        $[50] = areAllItemsLoaded;
        $[51] = t9;
    } else t9 = $[51];
    let t10;
    if ($[52] !== ExperienceError || $[53] !== itemFailureError) {
        t10 = !!itemFailureError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceError, {
            error: itemFailureError
        });
        $[52] = ExperienceError;
        $[53] = itemFailureError;
        $[54] = t10;
    } else t10 = $[54];
    let t11;
    if ($[55] !== t10 || $[56] !== t7 || $[57] !== t8 || $[58] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t7, t8, t9, t10);
        $[55] = t10;
        $[56] = t7;
        $[57] = t8;
        $[58] = t9;
        $[59] = t11;
    } else t11 = $[59];
    return t11;
} : ({ extensionLocalId: extensionLocalId, parameters: parameters, contentId: contentId, cardDimensions: cardDimensions, CardComponent: CardComponent, shouldAutoscrollCards: shouldAutoscrollCards, isCompanyHub: isCompanyHub, isTargetAudience: isTargetAudience, isInViewMode: isInViewMode = false, showDescription: showDescription })=>{
    const { size: size, orientation: orientation, alignment: alignment, isPaddingEnabled: isPaddingEnabled, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, filters: filters, isSegmentationShown: isSegmentationShown, audienceSegmentationGroupIds: audienceSegmentationGroupIds, segmentationTarget: segmentationTarget, renderVariant: renderVariant, backgroundColor: backgroundColor, textColor: textColor, borderColor: borderColor, cornerStyle: cornerStyle, layout: layout } = parameters;
    const { cards: cards, loading: loading, error: error } = (0, $6d3e30142bf823a9$export$5fe928848609fec7)(parameters);
    const { areAllItemsLoaded: areAllItemsLoaded, itemFailureError: itemFailureError, onItemSucceeded: onItemSucceeded, onItemFailed: onItemFailed } = (0, $b2481ad40679111c$export$c6c5cac0793c45d9)(cards);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $cfM7x.useProductDependencies)();
    const { experienceSuccessComponent: experienceSuccessComponent, experienceStopComponent: experienceStopComponent } = (0, $cfM7x.useProductDependencies)();
    const ExperienceSuccess = experienceSuccessComponent || (()=>null);
    const ExperienceError = experienceStopComponent || (()=>null);
    const numberOfCards = cards.length;
    const showAIDisclaimer = isAdminHubAIEnabled && showDescription && numberOfCards > 0 && size !== (0, $hjUDQ.Height).SMALL;
    let cardsWithEmptyDefault = cards;
    if (!filters || !numberOfCards || loading) cardsWithEmptyDefault = (0, (/*@__PURE__*/$parcel$interopDefault($6461dd9a11ba8e64$exports)))(3, ()=>({
            cardId: '',
            link: ''
        }));
    const { filteredCards: filteredCards } = (0, $e4389e92f972a9fa$export$93c098ff84870fcb)({
        isCompanyHub: isCompanyHub,
        isSegmentationShown: isSegmentationShown,
        isTargetAudience: isTargetAudience,
        cards: cardsWithEmptyDefault,
        isInViewMode: isInViewMode,
        segmentationTarget: segmentationTarget,
        audienceSegmentationGroupIds: audienceSegmentationGroupIds,
        renderVariant: renderVariant
    });
    const renderDynamicCard = (0, $cozmU.useCallback)((card)=>{
        const isResultEmpty = !numberOfCards || !card?.link;
        if (!filters) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ba972e52fd00d2a$export$15b55049a5f7f585), {
            cardDimensions: cardDimensions,
            cardSize: size,
            layout: layout,
            state: (0, $7ba972e52fd00d2a$export$fddf379e22a74b00).NO_FILTER
        });
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ddecac981a5dbce2$export$f67f215fe23c6b24), {
            cardDimensions: cardDimensions,
            cardSize: size,
            layout: layout
        });
        if (isResultEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ba972e52fd00d2a$export$15b55049a5f7f585), {
            cardDimensions: cardDimensions,
            cardSize: size,
            layout: layout,
            state: (0, $7ba972e52fd00d2a$export$fddf379e22a74b00).NO_RESULTS
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.075",
            key: card.cardId,
            xcss: (0, $w6R6I.cx)($acbc23a21ff09bf1$var$styles.cardWrapper)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CardComponent, {
            contentId: contentId,
            cardDimensions: cardDimensions,
            isPaddingEnabled: isPaddingEnabled,
            isAvatarShown: isAvatarShown,
            isPublishDateShown: isPublishDateShown,
            isSocialStatsShown: isSocialStatsShown,
            isIconShown: isIconShown,
            isInViewMode: !!isInViewMode,
            onCardSucceeded: onItemSucceeded,
            onCardFailed: onItemFailed,
            backgroundColor: backgroundColor,
            textColor: textColor,
            borderColor: borderColor,
            cornerStyle: cornerStyle,
            enableSnippetRenderer: true,
            showDescription: showDescription,
            ...card
        }));
    }, [
        isPaddingEnabled,
        isAvatarShown,
        isPublishDateShown,
        isSocialStatsShown,
        isIconShown,
        showDescription,
        filters,
        size,
        contentId,
        cardDimensions,
        isInViewMode,
        onItemSucceeded,
        onItemFailed,
        CardComponent,
        loading,
        backgroundColor,
        textColor,
        borderColor,
        cornerStyle,
        layout,
        numberOfCards
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($acbc23a21ff09bf1$var$CardsContainer, {
        shouldAutoscrollCards: shouldAutoscrollCards,
        numberOfCards: numberOfCards,
        cardDimensions: cardDimensions,
        isStacked: orientation === (0, $ikd73.Orientation).STACKED,
        isInViewMode: isInViewMode,
        alignment: alignment,
        extensionLocalId: extensionLocalId,
        cards: filteredCards,
        renderCard: renderDynamicCard,
        showAIDisclaimer: showAIDisclaimer
    }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f15264ed5f302311$export$533cd3269e981a31), {
        error: error
    }), areAllItemsLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceSuccess, null), !!itemFailureError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceError, {
        error: itemFailureError
    }));
};
function $acbc23a21ff09bf1$var$_temp() {
    return null;
}
function $acbc23a21ff09bf1$var$_temp2() {
    return null;
}
function $acbc23a21ff09bf1$var$_temp3() {
    return null;
}
function $acbc23a21ff09bf1$var$_temp4() {
    return null;
}
function $acbc23a21ff09bf1$var$_temp5() {
    return {
        cardId: "",
        link: ""
    };
}


const $e1207a88999a131e$export$9db933359d5c5243 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { extensionNode: extensionNode, contentId: contentId, mode: t1 } = t0;
    const mode = t1 === undefined ? (0, $hjUDQ.ExtensionMode).RENDERER : t1;
    const { isTargetAudience: isTargetAudience, isCompanyHub: isCompanyHub, smartCardProviderComponent: smartCardProviderComponent } = (0, $cfM7x.useProductDependencies)();
    const SmartCardProvider = smartCardProviderComponent || (0, $cozmU.Fragment);
    let t2;
    if ($[0] !== extensionNode) {
        t2 = extensionNode || {};
        $[0] = extensionNode;
        $[1] = t2;
    } else t2 = $[1];
    const { parameters: parameters, localId: t3 } = t2;
    const localId = t3 === undefined ? "" : t3;
    if (!parameters) return null;
    const t4 = !parameters;
    const t5 = parameters?.renderVariant;
    const t6 = parameters?.version;
    const t7 = parameters?.isSegmentationShown;
    let t8;
    if ($[2] !== isCompanyHub || $[3] !== t5 || $[4] !== t6 || $[5] !== t7) {
        t8 = {
            renderVariant: t5,
            version: t6,
            isCompanyHub: isCompanyHub,
            hubSegementationApplied: t7
        };
        $[2] = isCompanyHub;
        $[3] = t5;
        $[4] = t6;
        $[5] = t7;
        $[6] = t8;
    } else t8 = $[6];
    const t9 = mode === (0, $hjUDQ.ExtensionMode).RENDERER;
    let t10;
    if ($[7] !== contentId || $[8] !== isCompanyHub || $[9] !== isTargetAudience || $[10] !== localId || $[11] !== parameters || $[12] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acbc23a21ff09bf1$export$bab15f92b6d84cb6), {
            extensionLocalId: localId,
            parameters: parameters,
            isCompanyHub: isCompanyHub,
            isTargetAudience: isTargetAudience,
            isInViewMode: t9,
            contentId: contentId
        });
        $[7] = contentId;
        $[8] = isCompanyHub;
        $[9] = isTargetAudience;
        $[10] = localId;
        $[11] = parameters;
        $[12] = t9;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] !== SmartCardProvider || $[15] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SmartCardProvider, null, t10);
        $[14] = SmartCardProvider;
        $[15] = t10;
        $[16] = t11;
    } else t11 = $[16];
    let t12;
    if ($[17] !== contentId || $[18] !== extensionNode || $[19] !== mode || $[20] !== t11 || $[21] !== t4 || $[22] !== t8) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5RH40.HubExtensionsWrapper), {
            mode: mode,
            extensionNode: extensionNode,
            contentId: contentId,
            showNoDataState: t4,
            packageName: "cards-extension",
            analyticsAttributes: t8
        }, t11);
        $[17] = contentId;
        $[18] = extensionNode;
        $[19] = mode;
        $[20] = t11;
        $[21] = t4;
        $[22] = t8;
        $[23] = t12;
    } else t12 = $[23];
    return t12;
} : ({ extensionNode: extensionNode, contentId: contentId, mode: mode = (0, $hjUDQ.ExtensionMode).RENDERER })=>{
    const { isTargetAudience: isTargetAudience, isCompanyHub: isCompanyHub, smartCardProviderComponent: smartCardProviderComponent } = (0, $cfM7x.useProductDependencies)();
    const SmartCardProvider = smartCardProviderComponent || (0, $cozmU.Fragment);
    const { parameters: parameters, localId: localId = '' } = extensionNode || {};
    if (!parameters) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5RH40.HubExtensionsWrapper), {
        mode: mode,
        extensionNode: extensionNode,
        contentId: contentId,
        showNoDataState: !parameters,
        packageName: "cards-extension",
        analyticsAttributes: {
            renderVariant: parameters?.renderVariant,
            version: parameters?.version,
            isCompanyHub: isCompanyHub,
            hubSegementationApplied: parameters?.isSegmentationShown
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SmartCardProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acbc23a21ff09bf1$export$bab15f92b6d84cb6), {
        extensionLocalId: localId,
        parameters: parameters,
        isCompanyHub: isCompanyHub,
        isTargetAudience: isTargetAudience,
        isInViewMode: mode === (0, $hjUDQ.ExtensionMode).RENDERER,
        contentId: contentId
    })));
};
const $e1207a88999a131e$export$4956ae2d90a2bbeb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    let PropsProvider;
    let props;
    if ($[0] !== t0) {
        ({ propsProvider: PropsProvider, ...props } = t0);
        $[0] = t0;
        $[1] = PropsProvider;
        $[2] = props;
    } else {
        PropsProvider = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e1207a88999a131e$export$9db933359d5c5243, props);
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== PropsProvider || $[6] !== props || $[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PropsProvider, props, t1);
        $[5] = PropsProvider;
        $[6] = props;
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ propsProvider: PropsProvider, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PropsProvider, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e1207a88999a131e$export$9db933359d5c5243, props));
module.exports["CardsExtensionBase"] = $e1207a88999a131e$export$9db933359d5c5243;
module.exports["CardsExtension"] = $e1207a88999a131e$export$4956ae2d90a2bbeb;

});

parcelRegister("5RH40", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $a1L5E = parcelRequire("a1L5E");


var $cfM7x = parcelRequire("cfM7x");


var $hjUDQ = parcelRequire("hjUDQ");


var $d6u4w = parcelRequire("d6u4w");


var $3eDML = parcelRequire("3eDML");


var $ame4Z = parcelRequire("ame4Z");


var $2t092 = parcelRequire("2t092");

const $c10f9c6572a37e37$export$1b8348eac06ebe09 = ({ extensionNode: extensionNode, contentId: contentId, analyticsAttributes: analyticsAttributes, children: children, showNoDataState: showNoDataState, mode: mode = (0, $hjUDQ.ExtensionMode).RENDERER, packageName: packageName })=>{
    const { analyticsContext: analyticsContext, errorBoundaryComponent: errorBoundaryComponent, experienceStartComponent: experienceStartComponent } = (0, $cfM7x.useProductDependencies)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { extensionKey: extensionKey, parameters: parameters } = extensionNode || {};
    const hasParameters = !showNoDataState || parameters;
    const ExperienceStart = experienceStartComponent || (0, $cozmU.Fragment);
    const ErrorBoundaryComponent = errorBoundaryComponent || (0, $ame4Z.HubErrorBoundary);
    const errorBoundaryProps = errorBoundaryComponent ? {} : {
        id: extensionKey ?? contentId,
        packageName: packageName,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eDML.GenericErrorPage), null)
    };
    (0, $cozmU.useEffect)(()=>{
        if (mode === (0, $hjUDQ.ExtensionMode).RENDERER) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'macro',
                actionSubjectId: extensionKey,
                source: 'viewPageScreen',
                attributes: {
                    ...analyticsAttributes,
                    ...analyticsContext,
                    hasParameters: !!parameters,
                    contentId: contentId
                }
            }
        }).fire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: extensionKey || 'unknown-hub-extension'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ErrorBoundaryComponent, {
        ...errorBoundaryProps,
        shouldForceError: (0, $2t092.EXTENSIONS_CRITICAL_FOR_PAGE_LOAD).has(extensionKey || '')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceStart, null), hasParameters ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6u4w.NoExtensionData), {
        source: extensionKey
    })));
};
module.exports["HubExtensionsWrapper"] = $c10f9c6572a37e37$export$1b8348eac06ebe09;

});

parcelRegister("d6u4w", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $RfroO = parcelRequire("RfroO");


var $iMnC5 = parcelRequire("iMnC5");


var $cfM7x = parcelRequire("cfM7x");


var $iP3ib = parcelRequire("iP3ib");


var $icRfg = parcelRequire("icRfg");

const $f11bc349985cedb8$var$styles = {
    baseStyles: "_1e0c1txw _1bah1h6o _4cvr1h6o",
    configPanelStyles: "_4t3i1vuk",
    extensionStyles: "_4t3i1osq"
};
const $f11bc349985cedb8$export$dd91c9257a0f1cd4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { source: t1, isConfigPanel: isConfigPanel } = t0;
    const source = t1 === undefined ? "" : t1;
    const intl = (0, $kSwu1.useIntl)();
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    let t2;
    if ($[0] !== source) {
        t2 = source?.charAt(0).toUpperCase();
        $[0] = source;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== source) {
        t3 = source?.slice(1);
        $[2] = source;
        $[3] = t3;
    } else t3 = $[3];
    const extensionSourceName = t2 + t3;
    let t4;
    let t5;
    if ($[4] !== extensionSourceName || $[5] !== isConfigPanel || $[6] !== submitError) {
        t4 = ()=>{
            const errorMessage = `${extensionSourceName} ${isConfigPanel ? "config panel" : "extension"} failed to render. No parameters.`;
            submitError?.(new Error(errorMessage));
        };
        t5 = [
            extensionSourceName,
            isConfigPanel,
            submitError
        ];
        $[4] = extensionSourceName;
        $[5] = isConfigPanel;
        $[6] = submitError;
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, $cozmU.useEffect)(t4, t5);
    const t6 = isConfigPanel ? $f11bc349985cedb8$var$styles.configPanelStyles : $f11bc349985cedb8$var$styles.extensionStyles;
    let t7;
    if ($[9] !== t6) {
        t7 = (0, $w6R6I.cx)($f11bc349985cedb8$var$styles.baseStyles, t6);
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== intl) {
        t8 = intl.formatMessage((0, $icRfg.messages).noDataStateHeaderText);
        $[11] = intl;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $icRfg.messages).noDataStateDescription);
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== t8) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $RfroO.default), {
            header: t8,
            description: t9,
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($iP3ib)))
        });
        $[14] = t8;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== t10 || $[17] !== t7) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t7
        }, t10);
        $[16] = t10;
        $[17] = t7;
        $[18] = t11;
    } else t11 = $[18];
    return t11;
} : ({ source: source = '', isConfigPanel: isConfigPanel })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    const extensionSourceName = source?.charAt(0).toUpperCase() + source?.slice(1);
    (0, $cozmU.useEffect)(()=>{
        const errorMessage = `${extensionSourceName} ${isConfigPanel ? 'config panel' : 'extension'} failed to render. No parameters.`;
        submitError?.(new Error(errorMessage));
    }, [
        extensionSourceName,
        isConfigPanel,
        submitError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($f11bc349985cedb8$var$styles.baseStyles, isConfigPanel ? $f11bc349985cedb8$var$styles.configPanelStyles : $f11bc349985cedb8$var$styles.extensionStyles)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $RfroO.default), {
        header: intl.formatMessage((0, $icRfg.messages).noDataStateHeaderText),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $icRfg.messages).noDataStateDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($iP3ib)))
    }));
};
module.exports["NoExtensionData"] = $f11bc349985cedb8$export$dd91c9257a0f1cd4;

});

parcelRegister("iP3ib", function(module, exports) {
module.exports = new URL("Warning.e56d4e3e.svg", import.meta.url).toString();

});

parcelRegister("icRfg", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $8e4fbaddba5526c6$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    noDataStateHeaderText: {
        id: "company-hub.company-hub-common.link-cards.error-states.no-data.header-text",
        defaultMessage: "No data to display"
    },
    noDataStateDescription: {
        id: "company-hub.company-hub-common.link-cards.error-states.no-data.description-text",
        defaultMessage: "Try deleting this macro and creating a new one."
    }
});
module.exports["messages"] = $8e4fbaddba5526c6$export$defe85febe8b728c;

});

parcelRegister("2t092", function(module, exports) {
// we have made a copy of the extension keys to avoid importing the constants from the extensions packages
// this is a temporary solution to avoid the bundle size increase
// todo: we will have to create a new package for the constants and import it here
const $123f2f203b618ce4$export$3617e2677e53ded6 = new Set([
    'links-menu',
    'cards',
    'spotlight',
    'carousel',
    'hub-section',
    'jsm-help'
]);
module.exports["EXTENSIONS_CRITICAL_FOR_PAGE_LOAD"] = $123f2f203b618ce4$export$3617e2677e53ded6;

});

parcelRegister("fZvv3", function(module, exports) {

var $coD4j = parcelRequire("coD4j");

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $ba44fcbbb2d24900$var$castFunction(value) {
    return typeof value == 'function' ? value : $coD4j;
}
module.exports = $ba44fcbbb2d24900$var$castFunction;

});

parcelRegister("k5vii", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0545074a7ad6867d320b793a6025aac2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e9fc8c9ec2597c1b$var$_react = $e9fc8c9ec2597c1b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $e9fc8c9ec2597c1b$var$_baseNew = $e9fc8c9ec2597c1b$var$_interopRequireDefault((parcelRequire("gElAV")));
function $e9fc8c9ec2597c1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPause".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pause video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e9fc8c9ec2597c1b$var$VideoPauseIcon = (props)=>/*#__PURE__*/ $e9fc8c9ec2597c1b$var$_react.default.createElement($e9fc8c9ec2597c1b$var$_baseNew.default, Object.assign({
        name: "VideoPauseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$e9fc8c9ec2597c1b$var$VideoPauseIcon.displayName = 'VideoPauseIcon';
var $e9fc8c9ec2597c1b$var$_default = module.exports.default = $e9fc8c9ec2597c1b$var$VideoPauseIcon;

});

parcelRegister("cvDI4", function(module, exports) {
/**
 * Public API — exported externally. Do not add props without external support intent.
 */ 
var $cozmU = parcelRequire("cozmU");


var $LvVJP = parcelRequire("LvVJP");

const $96cd3f35152a45d9$export$a43b6bbf2f1b5e96 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $LvVJP.default), {
        color: props?.color,
        onRender: props?.onRender
    });
};
module.exports["CommentCountElement"] = $96cd3f35152a45d9$export$a43b6bbf2f1b5e96;

});

parcelRegister("4buyQ", function(module, exports) {
/**
 * Public API — exported externally. Do not add props without external support intent.
 */ 
var $cozmU = parcelRequire("cozmU");


var $7sCIj = parcelRequire("7sCIj");

const $55b74caacac7f327$export$cb2b1990006f041b = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7sCIj.default), {
        hideDatePrefix: props?.hideDatePrefix,
        color: props?.color,
        onRender: props?.onRender,
        fontSize: props?.fontSize
    });
};
module.exports["ModifiedOnElement"] = $55b74caacac7f327$export$cb2b1990006f041b;

});

parcelRegister("6gjqU", function(module, exports) {
/**
 * Public API — exported externally. Do not add props without external support intent.
 */ 
var $cozmU = parcelRequire("cozmU");


var $4GRqQ = parcelRequire("4GRqQ");

const $b1780bc8b62e343f$export$d630834382353545 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4GRqQ.default), {
        hideFormat: props?.hideFormat,
        color: props?.color,
        onRender: props?.onRender,
        textPrefix: props?.textPrefix,
        fontSize: props?.fontSize
    });
};
module.exports["OwnedByElement"] = $b1780bc8b62e343f$export$d630834382353545;

});

parcelRegister("fEbt0", function(module, exports) {
/**
 * Public API — exported externally. Do not add props without external support intent.
 */ 
var $cozmU = parcelRequire("cozmU");


var $cl3v4 = parcelRequire("cl3v4");

const $214bea8d005f747b$export$633ffcc4029e4e39 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cl3v4.default), {
        onRender: props?.onRender
    });
};
module.exports["OwnedByGroupElement"] = $214bea8d005f747b$export$633ffcc4029e4e39;

});

parcelRegister("keB0x", function(module, exports) {
/**
 * Public API — exported externally. Do not add props without external support intent.
 */ 
var $cozmU = parcelRequire("cozmU");


var $eIk5O = parcelRequire("eIk5O");

const $aed3b7198b7ebd14$export$5ecf9c2b4f9ce084 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eIk5O.default), {
        color: props?.color,
        onRender: props?.onRender
    });
};
module.exports["ReactCountElement"] = $aed3b7198b7ebd14$export$5ecf9c2b4f9ce084;

});

parcelRegister("7j5Rg", function(module, exports) {
/**
 * Public API — exported externally. Do not add props without external support intent.
 */ 
var $cozmU = parcelRequire("cozmU");


var $8Mb1e = parcelRequire("8Mb1e");

const $06dae2c1d20cadc4$export$8687dc32e81b32c2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Mb1e.default), props);
module.exports["UnresolvedAction"] = $06dae2c1d20cadc4$export$8687dc32e81b32c2;

});

parcelRegister("epZ7a", function(module, exports) {
/**
 * Public API — exported externally. Do not add props without external support intent.
 */ 
var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $hsIfr = parcelRequire("hsIfr");

const $356f9a22b0bf3065$export$4d177e8e493d864d = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hsIfr.default), {
        size: props?.iconTileSize === 24 ? (0, $4yYAm.SmartLinkSize).Large : (0, $4yYAm.SmartLinkSize).Medium,
        render: props?.render
    });
};
module.exports["LinkIconElement"] = $356f9a22b0bf3065$export$4d177e8e493d864d;

});

parcelRegister("iLpJO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $57p4j = parcelRequire("57p4j");

const $3f6c89efab089b35$var$skeletonWrapperStyles = null;
const $3f6c89efab089b35$var$emojiSkeletonStyles = null;
const $3f6c89efab089b35$export$9fc60f86d5a6479f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { height: height, loadingMargin: loadingMargin } = t0;
    const PLACEHOLDER_SIZE = height;
    let t1;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== loadingMargin) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ $cozmU.createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $hekY6.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
                ])
            }, /*#__PURE__*/ $cozmU.createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: loadingMargin
                },
                className: (0, $hekY6.default)([
                    "_2rkofajl _1e0c1o8l _bfhkizff _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qze3t"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = loadingMargin;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ height: height, loadingMargin: loadingMargin })=>{
    const PLACEHOLDER_SIZE = height;
    return /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), {
        entranceDirection: "left"
    }, (animationProps)=>/*#__PURE__*/ $cozmU.createElement("span", {
            ...animationProps,
            "data-testid": "emoji-placeholder",
            "data-css-target": "emoji-placeholder",
            className: (0, $hekY6.default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("span", {
            style: {
                width: `${PLACEHOLDER_SIZE}px`,
                height: `${PLACEHOLDER_SIZE}px`,
                margin: loadingMargin
            },
            className: (0, $hekY6.default)([
                "_2rkofajl _1e0c1o8l _bfhkizff _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qze3t"
            ])
        })));
};
module.exports["EmojiPlaceholder"] = $3f6c89efab089b35$export$9fc60f86d5a6479f;

});

parcelRegister("inIhs", function(module, exports) {

let $d61cb93003de95e6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d61cb93003de95e6$var$load("br7gN"),
    $d61cb93003de95e6$var$load("bNJC9"),
    $d61cb93003de95e6$var$load("6wr18"),
    $d61cb93003de95e6$var$load("ffEVr"),
    $d61cb93003de95e6$var$load("2rpiM")
]).then(()=>parcelRequire('ePMfy'));

});

parcelRegister("8ngiY", function(module, exports) {
module.exports = new URL("NoDynamicCards.7cd8fd7d.svg", import.meta.url).toString();

});

parcelRegister("ipz0N", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $kkFbH = parcelRequire("kkFbH");


var $88149 = parcelRequire("88149");

const $c358709489b4576e$var$FileIconWithColor = (0, $88149.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), 'grayBold');
$c358709489b4576e$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $c358709489b4576e$export$2e2bcd8739ae039 = $c358709489b4576e$var$FileIconWithColor;
module.exports["default"] = $c358709489b4576e$export$2e2bcd8739ae039;

});

parcelRegister("f49me", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gJ798 = parcelRequire("gJ798");


var $88149 = parcelRequire("88149");

const $3736b97729106be6$var$ChartBarIconWithColor = (0, $88149.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($gJ798))), 'purpleBold');
$3736b97729106be6$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $3736b97729106be6$export$2e2bcd8739ae039 = $3736b97729106be6$var$ChartBarIconWithColor;
module.exports["default"] = $3736b97729106be6$export$2e2bcd8739ae039;

});

parcelRegister("jBJvN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $3fO5l = parcelRequire("3fO5l");


var $88149 = parcelRequire("88149");

const $a7d4397f4d39d7f1$var$ListBulletedIconWithColor = (0, $88149.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), 'greenBold');
$a7d4397f4d39d7f1$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $a7d4397f4d39d7f1$export$2e2bcd8739ae039 = $a7d4397f4d39d7f1$var$ListBulletedIconWithColor;
module.exports["default"] = $a7d4397f4d39d7f1$export$2e2bcd8739ae039;

});

parcelRegister("iMQz5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gIfnJ = parcelRequire("gIfnJ");


var $4hmAW = parcelRequire("4hmAW");

const $6e22e7dea691eafe$var$BranchObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BranchObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Branch" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BranchObject({ label: label = 'Branch', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $6e22e7dea691eafe$export$2e2bcd8739ae039 = $6e22e7dea691eafe$var$BranchObject;
module.exports["default"] = $6e22e7dea691eafe$export$2e2bcd8739ae039;

});

parcelRegister("f7FiQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gIfnJ = parcelRequire("gIfnJ");


var $gEyoZ = parcelRequire("gEyoZ");

const $b8829d8a161753f9$var$BranchObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BranchObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Branch" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BranchObjectTile({ label: label = 'Branch', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $b8829d8a161753f9$export$2e2bcd8739ae039 = $b8829d8a161753f9$var$BranchObjectTile;
module.exports["default"] = $b8829d8a161753f9$export$2e2bcd8739ae039;

});

parcelRegister("gEyoZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $9NPFC = parcelRequire("9NPFC");

/**
 * __Object tile base__
 *
 * An object tile represents an Atlassian-specific content type.
 *
 */ const $e64fa8a7fc69b505$var$ObjectTileBase = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ObjectTileBase(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { label: t1, size: t2, testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const validSizes = [
        "xsmall",
        "small",
        "medium",
        "large",
        "xlarge"
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(", ")}`);
    let t3;
    if ($[0] !== Icon || $[1] !== color || $[2] !== label || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: label,
            color: color,
            testId: testId,
            shouldScale: true
        });
        $[0] = Icon;
        $[1] = color;
        $[2] = label;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== backgroundColor || $[6] !== size || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
            label: "",
            backgroundColor: backgroundColor,
            size: size
        }, t3);
        $[5] = backgroundColor;
        $[6] = size;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function ObjectTileBase({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: label,
        color: color,
        testId: testId,
        // @ts-expect-error - Internal, undocumented prop
        shouldScale: true
    }));
};
var $e64fa8a7fc69b505$export$2e2bcd8739ae039 = $e64fa8a7fc69b505$var$ObjectTileBase;
module.exports["default"] = $e64fa8a7fc69b505$export$2e2bcd8739ae039;

});

parcelRegister("39Mwn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lepke = parcelRequire("lepke");


var $4hmAW = parcelRequire("4hmAW");

const $29a7acb65f94e0ba$var$CommitObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommitObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Commit" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CommitObject({ label: label = 'Commit', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
};
var $29a7acb65f94e0ba$export$2e2bcd8739ae039 = $29a7acb65f94e0ba$var$CommitObject;
module.exports["default"] = $29a7acb65f94e0ba$export$2e2bcd8739ae039;

});

parcelRegister("6gVpf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lepke = parcelRequire("lepke");


var $gEyoZ = parcelRequire("gEyoZ");

const $90d14fc97efa5c87$var$CommitObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommitObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Commit" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)";
    const t3 = isBold ? "color.background.accent.yellow.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function CommitObjectTile({ label: label = 'Commit', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
};
var $90d14fc97efa5c87$export$2e2bcd8739ae039 = $90d14fc97efa5c87$var$CommitObjectTile;
module.exports["default"] = $90d14fc97efa5c87$export$2e2bcd8739ae039;

});

parcelRegister("3CYX0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6YkHb = parcelRequire("6YkHb");


var $4hmAW = parcelRequire("4hmAW");

const $ff9912959f94fce6$var$CodeObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CodeObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Code" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CodeObject({ label: label = 'Code', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $ff9912959f94fce6$export$2e2bcd8739ae039 = $ff9912959f94fce6$var$CodeObject;
module.exports["default"] = $ff9912959f94fce6$export$2e2bcd8739ae039;

});

parcelRegister("2z1Cx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6YkHb = parcelRequire("6YkHb");


var $gEyoZ = parcelRequire("gEyoZ");

const $3fba6eb33cac86c2$var$CodeObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CodeObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Code" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function CodeObjectTile({ label: label = 'Code', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $3fba6eb33cac86c2$export$2e2bcd8739ae039 = $3fba6eb33cac86c2$var$CodeObjectTile;
module.exports["default"] = $3fba6eb33cac86c2$export$2e2bcd8739ae039;

});

parcelRegister("ahlZa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lCTy3 = parcelRequire("lCTy3");


var $4hmAW = parcelRequire("4hmAW");

const $4e5aedb3fb5b2488$var$ChangesObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChangesObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Changes" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function ChangesObject({ label: label = 'Changes', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
};
var $4e5aedb3fb5b2488$export$2e2bcd8739ae039 = $4e5aedb3fb5b2488$var$ChangesObject;
module.exports["default"] = $4e5aedb3fb5b2488$export$2e2bcd8739ae039;

});

parcelRegister("lfmf4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lCTy3 = parcelRequire("lCTy3");


var $gEyoZ = parcelRequire("gEyoZ");

const $d8f6dc54ca6872bb$var$ChangesObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChangesObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Changes" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)";
    const t3 = isBold ? "color.background.accent.yellow.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function ChangesObjectTile({ label: label = 'Changes', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
};
var $d8f6dc54ca6872bb$export$2e2bcd8739ae039 = $d8f6dc54ca6872bb$var$ChangesObjectTile;
module.exports["default"] = $d8f6dc54ca6872bb$export$2e2bcd8739ae039;

});

parcelRegister("6MsAF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7vAVv = parcelRequire("7vAVv");


var $4hmAW = parcelRequire("4hmAW");

const $caa0390e0439cdc5$var$EpicObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EpicObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function EpicObject({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $caa0390e0439cdc5$export$2e2bcd8739ae039 = $caa0390e0439cdc5$var$EpicObject;
module.exports["default"] = $caa0390e0439cdc5$export$2e2bcd8739ae039;

});

parcelRegister("bht3M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7vAVv = parcelRequire("7vAVv");


var $gEyoZ = parcelRequire("gEyoZ");

const $ff1c12598ed3ba74$var$EpicObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EpicObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function EpicObjectTile({ label: label = 'Epic', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $ff1c12598ed3ba74$export$2e2bcd8739ae039 = $ff1c12598ed3ba74$var$EpicObjectTile;
module.exports["default"] = $ff1c12598ed3ba74$export$2e2bcd8739ae039;

});

parcelRegister("38zdI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ipvL3 = parcelRequire("ipvL3");


var $4hmAW = parcelRequire("4hmAW");

const $021e642953ecdf56$var$IncidentObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IncidentObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Incident" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function IncidentObject({ label: label = 'Incident', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $021e642953ecdf56$export$2e2bcd8739ae039 = $021e642953ecdf56$var$IncidentObject;
module.exports["default"] = $021e642953ecdf56$export$2e2bcd8739ae039;

});

parcelRegister("tBrWH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ipvL3 = parcelRequire("ipvL3");


var $gEyoZ = parcelRequire("gEyoZ");

const $d409ccda82578191$var$IncidentObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IncidentObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Incident" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function IncidentObjectTile({ label: label = 'Incident', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $d409ccda82578191$export$2e2bcd8739ae039 = $d409ccda82578191$var$IncidentObjectTile;
module.exports["default"] = $d409ccda82578191$export$2e2bcd8739ae039;

});

parcelRegister("cVpj0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7EFpK = parcelRequire("7EFpK");


var $4hmAW = parcelRequire("4hmAW");

const $c45be7d7373a5bd1$var$ProblemObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProblemObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Problem" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function ProblemObject({ label: label = 'Problem', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $c45be7d7373a5bd1$export$2e2bcd8739ae039 = $c45be7d7373a5bd1$var$ProblemObject;
module.exports["default"] = $c45be7d7373a5bd1$export$2e2bcd8739ae039;

});

parcelRegister("e9ExL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7EFpK = parcelRequire("7EFpK");


var $gEyoZ = parcelRequire("gEyoZ");

const $70d7bc77e47e0fe4$var$ProblemObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProblemObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Problem" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function ProblemObjectTile({ label: label = 'Problem', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $70d7bc77e47e0fe4$export$2e2bcd8739ae039 = $70d7bc77e47e0fe4$var$ProblemObjectTile;
module.exports["default"] = $70d7bc77e47e0fe4$export$2e2bcd8739ae039;

});

parcelRegister("jMFOf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lSw2p = parcelRequire("lSw2p");


var $4hmAW = parcelRequire("4hmAW");

const $08adce465a629da4$var$SubtaskObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SubtaskObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Subtask" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function SubtaskObject({ label: label = 'Subtask', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $08adce465a629da4$export$2e2bcd8739ae039 = $08adce465a629da4$var$SubtaskObject;
module.exports["default"] = $08adce465a629da4$export$2e2bcd8739ae039;

});

parcelRegister("h3uhG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lSw2p = parcelRequire("lSw2p");


var $gEyoZ = parcelRequire("gEyoZ");

const $35e12172f066a32d$var$SubtaskObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SubtaskObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Subtask" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function SubtaskObjectTile({ label: label = 'Subtask', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $35e12172f066a32d$export$2e2bcd8739ae039 = $35e12172f066a32d$var$SubtaskObjectTile;
module.exports["default"] = $35e12172f066a32d$export$2e2bcd8739ae039;

});

parcelRegister("boaiH", function(module, exports) {

var $2gr4B = parcelRequire("2gr4B");

class $ffade2ccf1ecf3ef$export$12b6b072930fd68f {
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $2gr4B.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = void 0;
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
}
module.exports["ExperienceTracker"] = $ffade2ccf1ecf3ef$export$12b6b072930fd68f;

});

parcelRegister("2gr4B", function(module, exports) {

var $apqal = parcelRequire("apqal");

function $8617e1b2001e7e7c$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $8617e1b2001e7e7c$export$c90b54e658fc4d7c {
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $apqal.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this._hasStopped = false;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
}
module.exports["Experience"] = $8617e1b2001e7e7c$export$c90b54e658fc4d7c;

});

parcelRegister("apqal", function(module, exports) {
class $f9800b995ac71735$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}
module.exports["ExperienceTimeoutError"] = $f9800b995ac71735$export$d27a2b6293f7631c;

});

parcelRegister("hyOTw", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $52c0c0ab9e795973$var$placeholderShimmer = null;
const $52c0c0ab9e795973$var$appearanceValues = {
    darkGray: {
        animation: "var(--ds-background-accent-gray-subtle, #8C8F97)"
    },
    gray: {
        animation: "var(--ds-skeleton, #0515240F)"
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #CFE1FD)"
    }
};
const $52c0c0ab9e795973$var$spanSkeletonStyles = null;
const $52c0c0ab9e795973$var$spanSkeletonBackgroundStyleMap = {
    gray: "_bfhkysee",
    blue: "_bfhk1s93",
    darkGray: "_bfhk7qp0"
};
const $52c0c0ab9e795973$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$52c0c0ab9e795973$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hekY6.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $52c0c0ab9e795973$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
const $52c0c0ab9e795973$export$8f31e4c4a37b8e9c = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$52c0c0ab9e795973$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hekY6.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $52c0c0ab9e795973$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
var $52c0c0ab9e795973$export$2e2bcd8739ae039 = $52c0c0ab9e795973$export$8f31e4c4a37b8e9c;
module.exports["SpanSkeleton"] = $52c0c0ab9e795973$export$85d5658002cae6ce;
module.exports["Skeleton"] = $52c0c0ab9e795973$export$8f31e4c4a37b8e9c;

});


//# sourceMappingURL=cards-extension.e96660d0.js.map
